/* 134fb629e19ef1aefccd4fe88f1a6c59941e7781
 * This file is automatically generated by graphql-let. */

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConstraintNumber: any;
  ConstraintString: any;
  JSON: any;
  JSONObject: any;
};

export type AddToCartDomesticAccommodation = {
  adults: Scalars['Int'];
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childAges?: InputMaybe<Array<Scalars['Int']>>;
  price: Scalars['Int'];
  propertyId: Scalars['Int'];
  ratePlanId?: InputMaybe<Scalars['Int']>;
  ratePlanVersion?: InputMaybe<Scalars['Int']>;
  roomTypeId: Scalars['Int'];
  useType: DomesticAccommodationUseType;
};

export type AddToCartDomesticLeisure = {
  items: Array<DomesticLeisureCartItemAdd>;
};

export type AddToCartDomesticTrain = {
  adults: Scalars['Int'];
  child: Scalars['Int'];
  trains: Array<DomesticTrainCartItemAdd>;
};

export type AddToCartItems = {
  domesticLeisure?: InputMaybe<AddToCartDomesticLeisure>;
  domesticReservation?: InputMaybe<AddToCartDomesticAccommodation>;
  domesticTrain?: InputMaybe<AddToCartDomesticTrain>;
};

export type AdditionalOrder = {
  __typename?: 'AdditionalOrder';
  buyer: OrderDetailsBuyer;
  cancellations: Array<OrderDetailsCancellation>;
  categoryOrders: Array<OrderDetailsCategoryOrder>;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCartDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  payments: Array<OrderDetailsPayment>;
  /** 추가 구매 건의 구매 적립 예정 NOL 포인트 (order-coordinator 응답 pass-through) */
  totalRewardAmount?: Maybe<Scalars['Int']>;
  user: OrderDetailsUser;
};

export type AddressCodes = {
  __typename?: 'AddressCodes';
  code?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  subBuckets?: Maybe<Array<Maybe<SubBuckets>>>;
};

export type AddressLang = {
  __typename?: 'AddressLang';
  en?: Maybe<Scalars['String']>;
};

export type AddtoCartItemsResponse = {
  __typename?: 'AddtoCartItemsResponse';
  count: Scalars['Int'];
};

export type Affiliation = {
  __typename?: 'Affiliation';
  association?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  direct?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AgePolicy = {
  __typename?: 'AgePolicy';
  child?: Maybe<Scalars['Int']>;
  toddler?: Maybe<Scalars['String']>;
};

export type Aggregations = {
  __typename?: 'Aggregations';
  addressCodes?: Maybe<Array<Maybe<AddressCodes>>>;
};

export type AgreementType = {
  __typename?: 'AgreementType';
  isPrepaymentAgreed?: Maybe<Scalars['Boolean']>;
  isPrivacyAgreed?: Maybe<Scalars['Boolean']>;
};

export type AvailableInventoryRatePlanData = {
  __typename?: 'AvailableInventoryRatePlanData';
  inventory: Array<AvailableInventoryRatePlanInventory>;
  request?: Maybe<RatePlanDataRequest>;
};

export type AvailableInventoryRatePlanInventory = {
  __typename?: 'AvailableInventoryRatePlanInventory';
  availability: RatePlanAvailability;
  ratePlans: Array<RatePlan>;
  roomTypeId: Scalars['Int'];
  useType: RatePlanUseType;
};

export type AvailableInventoryRatePlanResponse = {
  __typename?: 'AvailableInventoryRatePlanResponse';
  code: Scalars['Int'];
  data: AvailableInventoryRatePlanData;
  status: Scalars['String'];
  timestamp: Scalars['String'];
};

export type AvailablePeriod = {
  __typename?: 'AvailablePeriod';
  end?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
};

export type BannerAction = {
  __typename?: 'BannerAction';
  app?: Maybe<Scalars['String']>;
  web?: Maybe<Scalars['String']>;
};

export type BannerImage = {
  __typename?: 'BannerImage';
  url: Scalars['String'];
};

export type BannerInput = {
  target: Scalars['String'];
};

export type BannerLogMeta = {
  __typename?: 'BannerLogMeta';
  id: Scalars['String'];
  objectType: Scalars['String'];
  title: Scalars['String'];
};

export type BannerResponse = {
  __typename?: 'BannerResponse';
  action?: Maybe<BannerAction>;
  image?: Maybe<BannerImage>;
  logMeta?: Maybe<BannerLogMeta>;
};

export type BedConfigurations = {
  __typename?: 'BedConfigurations';
  bedType?: Maybe<BedType>;
  quantity?: Maybe<Scalars['Int']>;
};

export type BedGroups = {
  __typename?: 'BedGroups';
  bedConfigurations?: Maybe<Array<Maybe<BedConfigurations>>>;
  id?: Maybe<Scalars['Int']>;
};

export enum BedType {
  CribBed = 'CRIB_BED',
  DoubleBed = 'DOUBLE_BED',
  KingBed = 'KING_BED',
  QueenBed = 'QUEEN_BED',
  QueenSofaBed = 'QUEEN_SOFA_BED',
  SingleBed = 'SINGLE_BED',
  SingleBunkBed = 'SINGLE_BUNK_BED',
  SingleFuton = 'SINGLE_FUTON',
  SingleSofaBed = 'SINGLE_SOFA_BED',
  SingleWaterBed = 'SINGLE_WATER_BED',
  SuperSingleBed = 'SUPER_SINGLE_BED'
}

export type BusCancelPolicy = {
  __typename?: 'BusCancelPolicy';
  endAt: Scalars['String'];
  startAt: Scalars['String'];
  type: Scalars['String'];
  weight?: Maybe<Scalars['String']>;
};

export type BusCancelPreview = {
  __typename?: 'BusCancelPreview';
  buses: Array<BusCancelPreviewType>;
};

export type BusCancelPreviewInput = {
  arrivalTerminalNo: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  reservedAt: Scalars['String'];
};

export type BusCancelPreviewType = {
  __typename?: 'BusCancelPreviewType';
  cancelPreviews: Array<BusCancelPolicy>;
};

export type BusDetail = {
  __typename?: 'BusDetail';
  arrivalTerminalAbbreviationName: Scalars['String'];
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalAbbreviationName: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  fees: Array<BusDetailFee>;
  isReturn: Scalars['Boolean'];
  transportationCompanyName: Scalars['String'];
  tripDuration: Scalars['String'];
};

export type BusDetailFee = {
  __typename?: 'BusDetailFee';
  fee: Scalars['Int'];
  ticketType: Scalars['String'];
};

export type BusDetailInput = {
  allocationArrivalTerminalNo: Scalars['String'];
  allocationDepartureTerminalNo: Scalars['String'];
  allocationDepartureTime: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  seats: Array<BusDetailSeatInput>;
  totalSeats: Scalars['Int'];
  transportationCompanyCode: Scalars['String'];
};

export type BusDetailSeat = {
  __typename?: 'BusDetailSeat';
  no: Scalars['Int'];
  status: Scalars['String'];
};

export type BusDetailSeatInput = {
  seatNo: Scalars['Int'];
  ticketType: Scalars['String'];
};

export type BusDetailTicketType = {
  __typename?: 'BusDetailTicketType';
  code: Scalars['String'];
  fee: Scalars['Int'];
};

export enum BusNonCancelableReason {
  /** 이미취소됨 */
  Canceled = 'CANCELED',
  /** 버스이미도착함 */
  Completed = 'COMPLETED',
  /** 취소수수료 규정에 따라 책정된 취소수수료율이 100% 인 경우 */
  NonRefundable = 'NON_REFUNDABLE',
  /** 승차권 검표처리 됨 */
  TicketConfirmed = 'TICKET_CONFIRMED'
}

export type BusSeat = {
  __typename?: 'BusSeat';
  price: Scalars['Int'];
  seatNo: Scalars['Int'];
  ticketType: Scalars['String'];
};

export type BusTransportationCompany = {
  __typename?: 'BusTransportationCompany';
  abbreviationName: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

/** deprecated: 중복 검토 필요 */
export enum BusUnavailableReason {
  /** 가격 외 다른 상품 정보 변경 */
  Outdated = 'OUTDATED',
  /** 가격 변경 */
  PriceChanged = 'PRICE_CHANGED',
  /** 해당 좌석 매진 */
  SoldOut = 'SOLD_OUT',
  /** 예약 마감 */
  Stop = 'STOP',
  /**
   * 그외 예약 불가
   * ( 왕복권일 때, 승차권 일부만 품절인 경우 )
   */
  Uncategorized = 'UNCATEGORIZED'
}

export enum CancelCause {
  BusBoothCancel = 'BUS_BOOTH_CANCEL',
  ByAdmin = 'BY_ADMIN',
  ByUser = 'BY_USER',
  LeisureForceCancel = 'LEISURE_FORCE_CANCEL',
  ReservationAdminCancel = 'RESERVATION_ADMIN_CANCEL',
  TrainAdminCancel = 'TRAIN_ADMIN_CANCEL'
}

export type CancelPolicy = {
  __typename?: 'CancelPolicy';
  endAt?: Maybe<Scalars['String']>;
  startAt: Scalars['String'];
  type: CancelPolicyType;
  weight?: Maybe<Scalars['Float']>;
};

export type CancelPolicyBusTicket = {
  __typename?: 'CancelPolicyBusTicket';
  cancelable: Scalars['Boolean'];
  commissionAmount: Scalars['Int'];
  id: Scalars['Int'];
  nonCancelableReason?: Maybe<BusNonCancelableReason>;
  price: Scalars['Int'];
  seatNo: Scalars['Int'];
  status: OrderDetailsBusReservationTicketStatus;
  /**
   * 티켓 권종
   * 1 : 일반
   * 2 : 초등생
   * 8 : 대학생
   * 9 : 중고생
   */
  ticketType: Scalars['String'];
};

export enum CancelPolicyCreteria {
  Free = 'FREE',
  Ratio = 'RATIO',
  Total = 'TOTAL'
}

export enum CancelPolicyMethod {
  ByCheckIn = 'BY_CHECK_IN',
  ByDays = 'BY_DAYS'
}

export type CancelPolicySummary = {
  __typename?: 'CancelPolicySummary';
  cancelPolicy?: Maybe<CancelPolicy>;
  cancelable: Scalars['Boolean'];
  expectedCommissionAmount?: Maybe<Scalars['Int']>;
  nonCancellationReason?: Maybe<Scalars['String']>;
};

export enum CancelPolicyType {
  /** 예외규정에 의한 무료취소 */
  ExceptionalFree = 'EXCEPTIONAL_FREE',
  /** 확정 금액 (현재 장바구니에서는 사용되지 않지만 추후 확장성을 고려하여 필드 유지) */
  Fixed = 'FIXED',
  /** 무료취소 */
  Free = 'FREE',
  /** 비율 */
  Ratio = 'RATIO',
  /** 전액 취소수수료 */
  Total = 'TOTAL'
}

/** 취소유형코드 */
export enum CancellationTypeCode {
  /** 요율별 취소수수료 부과 (0 < fee < 100) */
  Fee = 'FEE',
  /** 취소수수료 정책을 따름 (미이용 자동환불) */
  FeeAutoRefund = 'FEE_AUTO_REFUND',
  /** 무료취소 (무료취소가능한 기간을 의미, fee == 0) */
  Free = 'FREE',
  /** 미사용 100%환불의 의미 */
  FullRefund = 'FULL_REFUND',
  /** 취소 수수료 있음 (수기 정책) fee == 0 */
  ManualFee = 'MANUAL_FEE',
  /** 취소 및 환불불가 (fee = 100) */
  NoRefund = 'NO_REFUND'
}

export type CartBusOrder = CartOrder & {
  __typename?: 'CartBusOrder';
  category: CategoryType;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  reservations: Array<CartBusOrderReservation>;
};

export type CartBusOrderReservation = {
  __typename?: 'CartBusOrderReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<CartBusOrderReservationTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type CartBusOrderReservationTicket = {
  __typename?: 'CartBusOrderReservationTicket';
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  confirmed: Scalars['Boolean'];
  confirmedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  seatNo: Scalars['Int'];
  status: CartBusOrderReservationTicketStatus;
  ticketType: Scalars['String'];
};

export enum CartBusOrderReservationTicketStatus {
  Aborted = 'ABORTED',
  Canceled = 'CANCELED',
  Reserved = 'RESERVED'
}

export type CartCategoryOrder = CartBusOrder | CartDomesticOrder | CartLeisureProductOrder | CartTrainOrder;

export type CartDomesticOrder = CartOrder & {
  __typename?: 'CartDomesticOrder';
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  cancelPolicyId: Scalars['Int'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  canceledAt?: Maybe<Scalars['String']>;
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  createdAt: Scalars['String'];
  displayBadge?: Maybe<MemberClassBadgeType>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  isPenaltyAgree?: Maybe<Scalars['Boolean']>;
  memberClass?: Maybe<Scalars['String']>;
  memberClassDiscountRate?: Maybe<Scalars['Int']>;
  nolChat?: Maybe<NolChatResponse>;
  orderId: Scalars['String'];
  pendingStatus?: Maybe<PendingStatus>;
  pickupType?: Maybe<PickupType>;
  price: Scalars['Int'];
  productConfig?: Maybe<ProductConfigProperty>;
  property?: Maybe<ProductPropertyDomestic>;
  propertyCategory: PropertyCategory;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  propertyVersion: Scalars['Int'];
  ratePlanId?: Maybe<Scalars['Int']>;
  ratePlanTitle?: Maybe<Scalars['String']>;
  ratePlanVersion?: Maybe<Scalars['Int']>;
  reserveType?: Maybe<ReserveType>;
  reviewWritableV2?: Maybe<ReviewWritableResponseV2>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion: Scalars['Int'];
  statusGroupCode: StatusGroupCode;
  useType: DomesticAccommodationUseType;
  visitType: VisitType;
};

export enum CartItemOptionUnavailableReason {
  InvalidMemberClass = 'INVALID_MEMBER_CLASS',
  Outdated = 'OUTDATED',
  OutOfStock = 'OUT_OF_STOCK',
  PriceChanged = 'PRICE_CHANGED',
  SoldOut = 'SOLD_OUT',
  Stop = 'STOP',
  Uncategorized = 'UNCATEGORIZED'
}

export enum CartLeisureOrderStatus {
  AdminTotalCancelCompleted = 'ADMIN_TOTAL_CANCEL_COMPLETED',
  CancelRequested = 'CANCEL_REQUESTED',
  ExpiredCancelCompleted = 'EXPIRED_CANCEL_COMPLETED',
  Unused = 'UNUSED',
  Used = 'USED',
  UserCancelCompleted = 'USER_CANCEL_COMPLETED',
  VendorCancelCompleted = 'VENDOR_CANCEL_COMPLETED'
}

export type CartLeisureOrderValid = {
  __typename?: 'CartLeisureOrderValid';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type CartLeisureProductOrder = CartOrder & {
  __typename?: 'CartLeisureProductOrder';
  category: CategoryType;
  createdAt: Scalars['String'];
  displayBadge?: Maybe<MemberClassBadgeType>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<CartLeisureProductOrderItem>;
  orderId: Scalars['String'];
  reviewWritableV2?: Maybe<ReviewWritableResponseV2>;
};

export type CartLeisureProductOrderItem = {
  __typename?: 'CartLeisureProductOrderItem';
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  encryptedVoucherData: Scalars['String'];
  id: Scalars['String'];
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  orderId: Scalars['String'];
  product?: Maybe<LeisureProduct>;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  time?: Maybe<Scalars['String']>;
  valid: CartLeisureOrderValid;
  variant?: Maybe<LeisureProductVariant>;
  voucher?: Maybe<CartLeisureProductOrderItemVoucher>;
};

export type CartLeisureProductOrderItemVoucher = {
  __typename?: 'CartLeisureProductOrderItemVoucher';
  key?: Maybe<Scalars['String']>;
};

export type CartOrder = {
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
};

export type CartOrders = {
  __typename?: 'CartOrders';
  categoryOrders: Array<CartCategoryOrder>;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
};

export type CartPropertyDomesticRentTimeLines = {
  __typename?: 'CartPropertyDomesticRentTimeLines';
  lastCheckInTime: Scalars['String'];
  maxUseTime: Scalars['Int'];
  timeLines: Array<RentTimeLine>;
};

export type CartPropertyDomesticRentTimeLinesParams = {
  adultPax: Scalars['Int'];
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childAges?: InputMaybe<Array<Scalars['Int']>>;
  ratePlanId?: InputMaybe<Scalars['Int']>;
  ratePlanVersion?: InputMaybe<Scalars['Int']>;
  roomTypeId: Scalars['Int'];
  surcharges?: InputMaybe<Array<Scalars['Int']>>;
};

export type CartSingleItemParam = {
  optionId: Scalars['String'];
};

export type CartTrainOrder = CartOrder & {
  __typename?: 'CartTrainOrder';
  category: CategoryType;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  tickets: Array<CartTrainOrderTicket>;
};

export type CartTrainOrderTicket = {
  __typename?: 'CartTrainOrderTicket';
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  child: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  id: Scalars['Int'];
  seats: Array<CartTrainOrderTicketSeat>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type CartTrainOrderTicketSeat = {
  __typename?: 'CartTrainOrderTicketSeat';
  carriageNo: Scalars['String'];
  direction: CartTrainOrderTicketSeatDirection;
  seatDescription: Scalars['String'];
};

export enum CartTrainOrderTicketSeatDirection {
  Forward = 'FORWARD',
  Reverse = 'REVERSE'
}

export enum CartTrainOrderTicketStatus {
  Canceled = 'CANCELED',
  Reserved = 'RESERVED'
}

export enum CategoryGroupType {
  All = 'ALL',
  DomesticLeisureGiftcard = 'DOMESTIC_LEISURE_GIFTCARD',
  DomesticLeisureTicket = 'DOMESTIC_LEISURE_TICKET',
  DomesticReservation = 'DOMESTIC_RESERVATION',
  /** 주문 내역 교통 카테고리 선택시 기차, 버스 같이 노출 */
  DomesticTransportation = 'DOMESTIC_TRANSPORTATION'
}

export enum CategoryName {
  Db = 'DB',
  Dc = 'DC',
  Dl = 'DL',
  Dp = 'DP',
  Dt = 'DT',
  Gf = 'GF',
  Gl = 'GL',
  Gp = 'GP'
}

export enum CategoryType {
  All = 'ALL',
  DomesticBus = 'DOMESTIC_BUS',
  DomesticLeisureGiftcard = 'DOMESTIC_LEISURE_GIFTCARD',
  DomesticLeisureRentacar = 'DOMESTIC_LEISURE_RENTACAR',
  DomesticLeisureTicket = 'DOMESTIC_LEISURE_TICKET',
  DomesticReservation = 'DOMESTIC_RESERVATION',
  DomesticTrain = 'DOMESTIC_TRAIN'
}

export type CertificationCertifyResult = {
  __typename?: 'CertificationCertifyResult';
  certCount?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  expireTime?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  remainCount?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type Commission = {
  __typename?: 'Commission';
  commissionType?: Maybe<Scalars['String']>;
};

export type ConfirmBusTicket = {
  __typename?: 'ConfirmBusTicket';
  checkedAt: Scalars['String'];
};

export type ConfirmBusTicketInput = {
  orderId: Scalars['String'];
  reservationNo: Scalars['String'];
  ticketNo: Scalars['String'];
};

export type Content = {
  __typename?: 'Content';
  address: Scalars['String'];
  category: LeisureCategory;
  commission: Commission;
  coverPrice: Scalars['Int'];
  dealInfo?: Maybe<Scalars['String']>;
  dealIntroduce?: Maybe<Scalars['String']>;
  dealPriceGroups: Array<Scalars['String']>;
  discountRate: Scalars['Float'];
  districtHCode: Scalars['String'];
  gajagoSalePrice: Scalars['Int'];
  gajagoUrl: Scalars['String'];
  hasPenalty: Scalars['Boolean'];
  hotDealYn: Scalars['Boolean'];
  id: Scalars['Int'];
  image: Scalars['String'];
  images: Array<Scalars['String']>;
  isDealAppealPointUse: Scalars['Boolean'];
  lat: Scalars['Float'];
  location: Array<Location>;
  locations: Array<Locations>;
  lon: Scalars['Float'];
  lowestPriceYn: Scalars['String'];
  name: Scalars['String'];
  noticeInfo?: Maybe<Scalars['String']>;
  options: Array<Options>;
  pictogramJson: Scalars['String'];
  postReservationYn: Scalars['Boolean'];
  productType: Scalars['String'];
  refundInfo?: Maybe<Scalars['String']>;
  salesCount: Scalars['Int'];
  salesPeriod: SalesPeriod;
  sellerInfos: Array<Maybe<SellerInfos>>;
  socialImages: Array<Scalars['String']>;
  sortWeight: Scalars['Int'];
  status: Scalars['String'];
  storeInfo?: Maybe<Scalars['String']>;
  superDealWeight: Scalars['Int'];
  superDealYn: Scalars['String'];
  supplyYn: Scalars['String'];
  tags: Scalars['String'];
  todayUsable: Scalars['Boolean'];
  type: Array<Type>;
  usageInfo?: Maybe<Scalars['String']>;
};

export type ContentThemes = {
  __typename?: 'ContentThemes';
  code: Scalars['Int'];
  name: Scalars['String'];
  photos?: Maybe<ContentThemesPhotos>;
};

export type ContentThemesPhotos = {
  __typename?: 'ContentThemesPhotos';
  available?: Maybe<Scalars['String']>;
  matched?: Maybe<Scalars['String']>;
  unavailable?: Maybe<Scalars['String']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CouponDomesticInstance = {
  __typename?: 'CouponDomesticInstance';
  amount?: Maybe<Scalars['Int']>;
  applicableMaxPrice?: Maybe<Scalars['Int']>;
  applicableMinPrice?: Maybe<Scalars['Int']>;
  calculatedPrice?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  checkinPeriod?: Maybe<CouponDomesticInstancePeriod>;
  couponName: Scalars['String'];
  couponType: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  denyListGroupId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  maxDiscountPrice?: Maybe<Scalars['Int']>;
  metaCouponId?: Maybe<Scalars['Float']>;
  minActualPayment?: Maybe<Scalars['Int']>;
  offeredPlaceNo?: Maybe<Scalars['String']>;
  placeClassification?: Maybe<Scalars['String']>;
  placeTypes: Array<Scalars['String']>;
  progress?: Maybe<CouponDomesticInstanceProgress>;
  roomTypes: Array<Scalars['String']>;
  schema?: Maybe<CouponSchema>;
  status?: Maybe<Scalars['String']>;
  stayTypes: Array<Scalars['String']>;
  unavailableReasons: Array<Scalars['String']>;
  usablePeriod?: Maybe<CouponUsablePeriod>;
  useInAdvance?: Maybe<Scalars['Int']>;
  usedAt?: Maybe<Scalars['String']>;
  usedPlaceNo?: Maybe<Scalars['String']>;
  usedPrice?: Maybe<Scalars['String']>;
  week: Array<Scalars['String']>;
};

export type CouponDomesticInstanceInput = {
  checkinDate: Scalars['String'];
  placeId: Scalars['Int'];
  roomPrice: Scalars['Int'];
  roomTypeId?: InputMaybe<Scalars['Int']>;
  stayType: Scalars['String'];
  useMyRoom: Scalars['Boolean'];
};

export type CouponDomesticInstancePeriod = {
  __typename?: 'CouponDomesticInstancePeriod';
  days?: Maybe<Scalars['Int']>;
  endAt?: Maybe<Scalars['String']>;
  endAtDayOfWeek?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['String']>;
  startAtDayOfWeek?: Maybe<Scalars['String']>;
};

export type CouponDomesticInstanceProgress = {
  __typename?: 'CouponDomesticInstanceProgress';
  id?: Maybe<Scalars['String']>;
  limitUse: Scalars['Int'];
  offered: Scalars['Int'];
  used: Scalars['Int'];
};

export type CouponDomesticInstanceResponse = {
  __typename?: 'CouponDomesticInstanceResponse';
  coupons: Array<CouponDomesticInstance>;
};

export type CouponDomesticInstanceV2 = {
  __typename?: 'CouponDomesticInstanceV2';
  allowAdditional?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Int'];
  applicableMaxPrice?: Maybe<Scalars['Int']>;
  applicableMinPrice: Scalars['Int'];
  applicationType?: Maybe<DomesticCouponApplicationType>;
  calculatedPrice: Scalars['Int'];
  category: Scalars['String'];
  checkinPeriod?: Maybe<CouponDomesticInstancePeriod>;
  couponName: Scalars['String'];
  couponType: Scalars['String'];
  createdAt: Scalars['String'];
  denyListGroupId?: Maybe<Scalars['String']>;
  discountType: Scalars['String'];
  id?: Maybe<Scalars['Float']>;
  maxDiscountPrice?: Maybe<Scalars['Int']>;
  metaCouponId?: Maybe<Scalars['Float']>;
  minActualPayment: Scalars['Int'];
  offeredPlaceNo?: Maybe<Scalars['String']>;
  placeClassification: Scalars['String'];
  placeTypes: Array<Scalars['String']>;
  progress?: Maybe<CouponDomesticInstanceProgress>;
  roomTypes: Array<Scalars['String']>;
  schema: CouponSchema;
  status: Scalars['String'];
  stayTypes: Array<Scalars['String']>;
  unavailableReasons: Array<Scalars['String']>;
  usableDistricts?: Maybe<Array<Scalars['String']>>;
  usablePeriod: CouponUsablePeriod;
  useInAdvance: Scalars['Int'];
  usedAt?: Maybe<Scalars['String']>;
  usedPlaceNo?: Maybe<Scalars['String']>;
  usedPrice?: Maybe<Scalars['String']>;
  week: Array<Scalars['String']>;
};

export type CouponDomesticInstanceV2Input = {
  applicationType?: InputMaybe<Scalars['String']>;
  checkinDateTime: Scalars['String'];
  checkoutDateTime: Scalars['String'];
  originalRoomPrice: Scalars['Int'];
  placeId: Scalars['Int'];
  ratePlanId?: InputMaybe<Scalars['Int']>;
  roomPrice: Scalars['Int'];
  roomType: Scalars['String'];
  roomTypeId?: InputMaybe<Scalars['Int']>;
  stayType: Scalars['String'];
};

export type CouponDomesticInstances = {
  __typename?: 'CouponDomesticInstances';
  coupons: Array<CouponDomesticInstance>;
};

export type CouponDomesticInstancesV2 = {
  __typename?: 'CouponDomesticInstancesV2';
  coupons: Array<CouponDomesticInstanceV2>;
};

export type CouponDownloadInput = {
  metaCouponId: Scalars['Float'];
  placeId: Scalars['Int'];
};

export type CouponDownloaded = {
  __typename?: 'CouponDownloaded';
  id: Scalars['Float'];
  metaCouponId: Scalars['Float'];
};

export type CouponMetadata = {
  __typename?: 'CouponMetadata';
  couponTitle: Scalars['String'];
  id: Scalars['Float'];
  servicePeriod: CouponDomesticInstancePeriod;
};

export type CouponPlatformCheckProgress = {
  __typename?: 'CouponPlatformCheckProgress';
  appId: CouponPlatformInstanceAppId;
  couponId: Scalars['Float'];
  couponUsable: Scalars['Boolean'];
  maxUseCount: CouponPlatformCheckProgressMaxUseCount;
  message: Scalars['String'];
  productIds: Array<Scalars['String']>;
  stockUsable: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CouponPlatformCheckProgressConditionInput = {
  count: Scalars['Int'];
  productId: Scalars['Int'];
};

export type CouponPlatformCheckProgressInput = {
  checkProgressRequests: Array<CouponPlatformCheckProgressRequestInput>;
};

export type CouponPlatformCheckProgressMaxUseCount = {
  __typename?: 'CouponPlatformCheckProgressMaxUseCount';
  stock?: Maybe<CouponPlatformInstanceRedemptionPolicyStock>;
  usable: Scalars['Boolean'];
};

export type CouponPlatformCheckProgressRequestInput = {
  appId: CouponPlatformInstanceAppId;
  conditions: Array<CouponPlatformCheckProgressConditionInput>;
  couponId: Scalars['Float'];
};

export type CouponPlatformConditions = {
  __typename?: 'CouponPlatformConditions';
  code?: Maybe<Scalars['String']>;
  itemSet?: Maybe<Array<Maybe<Scalars['String']>>>;
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CouponPlatformDiscount = {
  __typename?: 'CouponPlatformDiscount';
  amount?: Maybe<Scalars['Int']>;
  percentOff?: Maybe<Scalars['Int']>;
};

export type CouponPlatformDownloadInput = {
  appId: CouponPlatformInstanceAppId;
  couponId: Scalars['Float'];
  /** 상품 ID */
  trackingCode: Scalars['Int'];
};

export type CouponPlatformDownloaded = {
  __typename?: 'CouponPlatformDownloaded';
  couponId: Scalars['Float'];
  id: Scalars['Float'];
};

export type CouponPlatformInstance = {
  __typename?: 'CouponPlatformInstance';
  confirmedDiscount: Scalars['Int'];
  couponType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  discount?: Maybe<CouponPlatformInstanceDiscount>;
  endAt?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  redemptionPolicy?: Maybe<CouponPlatformInstanceRedemptionPolicy>;
  resource: CouponPlatformInstanceResource;
  startAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  violations?: Maybe<Array<Scalars['String']>>;
};

export enum CouponPlatformInstanceAppId {
  /** 국내 레저 app */
  Dl = 'dl',
  /** 고속버스 app */
  Eb = 'eb',
  /** 기차 app */
  Tr = 'tr'
}

export type CouponPlatformInstanceDiscount = {
  __typename?: 'CouponPlatformInstanceDiscount';
  amount?: Maybe<Scalars['Int']>;
  percentOff?: Maybe<Scalars['Int']>;
};

export type CouponPlatformInstanceInput = {
  appId: CouponPlatformInstanceAppId;
  price: Scalars['Int'];
  productId?: InputMaybe<Scalars['Int']>;
  productType?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<Array<CouponPlatformInstanceInputBusReservation>>;
  trainGroupCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type CouponPlatformInstanceInputBusReservation = {
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<CouponPlatformInstanceInputBusReservationTicket>;
};

export type CouponPlatformInstanceInputBusReservationTicket = {
  price: Scalars['Int'];
  ticketType: Scalars['String'];
};

export type CouponPlatformInstanceRedemptionPolicy = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicy';
  stock?: Maybe<CouponPlatformInstanceRedemptionPolicyStock>;
};

export type CouponPlatformInstanceRedemptionPolicyCondition = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicyCondition';
  code?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Int'];
};

export type CouponPlatformInstanceRedemptionPolicyConditionV2 = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicyConditionV2';
  code?: Maybe<Scalars['String']>;
  itemSet?: Maybe<Array<Maybe<Scalars['String']>>>;
  path: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type CouponPlatformInstanceRedemptionPolicyStock = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicyStock';
  remain: Scalars['Int'];
  total: Scalars['Int'];
};

export type CouponPlatformInstanceRedemptionPolicyStockV2 = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicyStockV2';
  id?: Maybe<Scalars['Float']>;
  remain: Scalars['Int'];
  total: Scalars['Int'];
};

export type CouponPlatformInstanceRedemptionPolicyV2 = {
  __typename?: 'CouponPlatformInstanceRedemptionPolicyV2';
  conditions?: Maybe<Array<CouponPlatformInstanceRedemptionPolicyConditionV2>>;
  maxUseCount?: Maybe<CouponPlatformInstanceRedemptionPolicyStockV2>;
  stock?: Maybe<CouponPlatformInstanceRedemptionPolicyStockV2>;
};

export type CouponPlatformInstanceResource = {
  __typename?: 'CouponPlatformInstanceResource';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CouponPlatformInstanceResponse = {
  __typename?: 'CouponPlatformInstanceResponse';
  coupons: Array<CouponPlatformInstance>;
};

export type CouponPlatformInstanceV2 = {
  __typename?: 'CouponPlatformInstanceV2';
  confirmedDiscount: Scalars['Int'];
  couponId: Scalars['Float'];
  couponTarget?: Maybe<Scalars['String']>;
  couponType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  discount?: Maybe<CouponPlatformInstanceDiscount>;
  endAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  redemptionPolicy?: Maybe<CouponPlatformInstanceRedemptionPolicyV2>;
  resource: CouponPlatformInstanceResource;
  startAt?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  unavailableReasons?: Maybe<Array<Scalars['String']>>;
  violations?: Maybe<Array<Scalars['String']>>;
};

export type CouponPlatformInstances = {
  __typename?: 'CouponPlatformInstances';
  coupons: Array<CouponPlatformInstanceV2>;
};

export type CouponPlatformRedemptionPolicy = {
  __typename?: 'CouponPlatformRedemptionPolicy';
  conditions?: Maybe<Array<Maybe<CouponPlatformConditions>>>;
  stock?: Maybe<Scalars['String']>;
};

export type CouponPlatformResource = {
  __typename?: 'CouponPlatformResource';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CouponPlatformUserCoupon = {
  __typename?: 'CouponPlatformUserCoupon';
  createdAt?: Maybe<Scalars['String']>;
  discount?: Maybe<CouponPlatformDiscount>;
  endAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  redemptionPolicy?: Maybe<CouponPlatformRedemptionPolicy>;
  resource?: Maybe<CouponPlatformResource>;
  startAt?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CouponSchema = {
  __typename?: 'CouponSchema';
  web?: Maybe<Scalars['String']>;
  yanolja?: Maybe<Scalars['String']>;
  yanow?: Maybe<Scalars['String']>;
};

export type CouponUsablePeriod = {
  __typename?: 'CouponUsablePeriod';
  endAt?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['String']>;
};

export type Days = {
  __typename?: 'Days';
  date?: Maybe<Scalars['String']>;
  limitOffer?: Maybe<Scalars['String']>;
  limitUse?: Maybe<Scalars['Int']>;
  offered?: Maybe<Scalars['Int']>;
  roomTypeNo?: Maybe<Scalars['Int']>;
  stayAbleCnt?: Maybe<Scalars['Int']>;
  stayBreakTime?: Maybe<Scalars['String']>;
  stayCnt?: Maybe<Scalars['Int']>;
  stayDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalPrice?: Maybe<Scalars['Int']>;
  stayOpen?: Maybe<Scalars['Int']>;
  stayOpenStartTime?: Maybe<Scalars['String']>;
  stayPrice?: Maybe<Scalars['Int']>;
  staySoldout?: Maybe<Scalars['Int']>;
  stayUseEndTime?: Maybe<Scalars['String']>;
  stayUseRoomCnt?: Maybe<Scalars['Int']>;
  stayUseStartTime?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
};

export type DepthOne = {
  __typename?: 'DepthOne';
  depth_two?: Maybe<Array<Maybe<DepthTwo>>>;
  id?: Maybe<Scalars['Int']>;
};

export type DepthThree = {
  __typename?: 'DepthThree';
  id?: Maybe<Scalars['Int']>;
};

export type DepthTwo = {
  __typename?: 'DepthTwo';
  depth_three?: Maybe<Array<Maybe<DepthThree>>>;
  id?: Maybe<Scalars['Int']>;
};

export type Description = {
  __typename?: 'Description';
  overview?: Maybe<Scalars['String']>;
};

export type Descriptions = {
  __typename?: 'Descriptions';
  direction?: Maybe<Scalars['String']>;
  directionLang?: Maybe<DirectionLang>;
  location?: Maybe<Scalars['String']>;
  locationLang?: Maybe<LocationLang>;
  overview?: Maybe<Scalars['String']>;
  overviewLang?: Maybe<OverviewLang>;
  pickup?: Maybe<Scalars['String']>;
  pickupType?: Maybe<PickupType>;
  transportation?: Maybe<Scalars['String']>;
};

export type DirectionLang = {
  __typename?: 'DirectionLang';
  en?: Maybe<Scalars['String']>;
  zhcn?: Maybe<Scalars['String']>;
};

/** 할인 유형 코드 */
export enum DiscountTypeCode {
  /** 고정 금액 */
  FixedAmount = 'FIXED_AMOUNT',
  /** 고정 비율 */
  FixedRate = 'FIXED_RATE',
  /** 할인 없음 */
  None = 'NONE'
}

export type DistributionPreview = {
  __typename?: 'DistributionPreview';
  orders: DistributionPreviewOrders;
  payments?: Maybe<Array<DistributionPreviewOrdersPayments>>;
};

export type DistributionPreviewInput = {
  orders: DistributionPreviewInputOrders;
  payments: Array<DistributionPreviewInputPayments>;
};

export type DistributionPreviewInputOrders = {
  domesticLeisureTicket?: InputMaybe<DistributionPreviewInputOrdersLeisure>;
  domesticReservation?: InputMaybe<DistributionPreviewInputOrdersReservation>;
  domesticTrain?: InputMaybe<DistributionPreviewInputOrdersTrain>;
};

export type DistributionPreviewInputOrdersDiscount = {
  couponAmount?: InputMaybe<Scalars['Int']>;
};

export type DistributionPreviewInputOrdersLeisure = {
  discount?: InputMaybe<DistributionPreviewInputOrdersDiscount>;
  price: Scalars['Int'];
};

export type DistributionPreviewInputOrdersReservation = {
  discount?: InputMaybe<DistributionPreviewInputOrdersReservationDiscount>;
  price: Scalars['Int'];
};

export type DistributionPreviewInputOrdersReservationDiscount = {
  couponAmount?: InputMaybe<Scalars['Int']>;
  mobileMembershipAmount?: InputMaybe<Scalars['Int']>;
};

export type DistributionPreviewInputOrdersTrain = {
  discount?: InputMaybe<DistributionPreviewInputOrdersDiscount>;
  price: Scalars['Int'];
};

export type DistributionPreviewInputPayments = {
  amount: Scalars['Int'];
  method: Scalars['String'];
  type: Scalars['String'];
};

export type DistributionPreviewOrders = {
  __typename?: 'DistributionPreviewOrders';
  domesticLeisureTicket?: Maybe<DistributionPreviewOrdersLeisure>;
  domesticReservation?: Maybe<DistributionPreviewOrdersReservation>;
  domesticTrain?: Maybe<DistributionPreviewOrdersTrain>;
};

export type DistributionPreviewOrdersDiscount = {
  __typename?: 'DistributionPreviewOrdersDiscount';
  couponAmount?: Maybe<Scalars['Int']>;
};

export type DistributionPreviewOrdersLeisure = {
  __typename?: 'DistributionPreviewOrdersLeisure';
  discount?: Maybe<DistributionPreviewOrdersDiscount>;
  payments?: Maybe<Array<DistributionPreviewOrdersPayments>>;
  price: Scalars['Int'];
};

export type DistributionPreviewOrdersPayments = {
  __typename?: 'DistributionPreviewOrdersPayments';
  amount: Scalars['Int'];
  method: Scalars['String'];
  type: Scalars['String'];
};

export type DistributionPreviewOrdersReservation = {
  __typename?: 'DistributionPreviewOrdersReservation';
  discount?: Maybe<DistributionPreviewOrdersReservationDiscount>;
  payments?: Maybe<Array<DistributionPreviewOrdersPayments>>;
  price: Scalars['Int'];
};

export type DistributionPreviewOrdersReservationDiscount = {
  __typename?: 'DistributionPreviewOrdersReservationDiscount';
  couponAmount?: Maybe<Scalars['Int']>;
  mobileMembershipAmount?: Maybe<Scalars['Int']>;
};

export type DistributionPreviewOrdersTrain = {
  __typename?: 'DistributionPreviewOrdersTrain';
  discount?: Maybe<DistributionPreviewOrdersDiscount>;
  payments?: Maybe<Array<DistributionPreviewOrdersPayments>>;
  price: Scalars['Int'];
};

export type DomesticAccommodationCartItem = ICartItem & {
  __typename?: 'DomesticAccommodationCartItem';
  options: Array<DomesticAccommodationCartItemOption>;
  property: ProductPropertyDomestic;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  type: CategoryType;
};

export type DomesticAccommodationCartItemOption = ICartItemOption & {
  __typename?: 'DomesticAccommodationCartItemOption';
  adults: Scalars['Int'];
  availability: Scalars['Boolean'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  capacity: Scalars['Int'];
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  child?: Maybe<Scalars['Int']>;
  childAges?: Maybe<Array<Scalars['Int']>>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  infant?: Maybe<Scalars['Int']>;
  isChosen: Scalars['Boolean'];
  itemUpdatedByMemberClass: Scalars['Boolean'];
  maxCapacity: Scalars['Int'];
  memberClass?: Maybe<Scalars['String']>;
  memberClassDiscountRate?: Maybe<Scalars['Int']>;
  originalPrice?: Maybe<Scalars['Float']>;
  outdated?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  propertyCoupons?: Maybe<PropertyCouponsResponse>;
  propertyCouponsProgress?: Maybe<Array<PropertyCouponsProgress>>;
  ratePlan: DomesticAccommodationCartItemOptionRatePlan;
  ratePlanConfig: RatePlanConfig;
  ratePlanId?: Maybe<Scalars['Int']>;
  ratePlanVersion?: Maybe<Scalars['Int']>;
  remains?: Maybe<Scalars['Int']>;
  roomType: ProductPropertyRoomTypeDomestic;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion: Scalars['Int'];
  surcharges?: Maybe<Array<Scalars['Int']>>;
  unavailableReason?: Maybe<CartItemOptionUnavailableReason>;
  useType: DomesticAccommodationUseType;
};

export type DomesticAccommodationCartItemOptionHotDeal = {
  __typename?: 'DomesticAccommodationCartItemOptionHotDeal';
  discountRate: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
};

export type DomesticAccommodationCartItemOptionRatePlan = {
  __typename?: 'DomesticAccommodationCartItemOptionRatePlan';
  benefitList: Array<DomesticRatePlanBenefits>;
  hotDeal: DomesticAccommodationCartItemOptionHotDeal;
  isExceptionalCancelPolicy: Scalars['Boolean'];
  title: Scalars['String'];
};

export type DomesticAccommodationCartSingleItem = ICartSingleItem & {
  __typename?: 'DomesticAccommodationCartSingleItem';
  option: DomesticAccommodationCartItemOption;
  property: ProductPropertyDomestic;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  type: CategoryType;
};

export enum DomesticAccommodationUseType {
  DayUse = 'DAY_USE',
  MultiNights = 'MULTI_NIGHTS',
  OverNight = 'OVER_NIGHT'
}

export type DomesticAccommodationUserCoupon = {
  __typename?: 'DomesticAccommodationUserCoupon';
  amount?: Maybe<Scalars['Int']>;
  applicableMaxPrice?: Maybe<Scalars['String']>;
  applicableMinPrice?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  checkinPeriod?: Maybe<Scalars['String']>;
  couponName?: Maybe<Scalars['String']>;
  couponType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  denyListGroupId?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  maxDiscountPrice?: Maybe<Scalars['String']>;
  metaCouponId?: Maybe<Scalars['Float']>;
  minActualPayment?: Maybe<Scalars['Int']>;
  offeredPlaceNo?: Maybe<Scalars['String']>;
  placeClassification?: Maybe<Scalars['String']>;
  placeTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  roomTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  schema?: Maybe<CouponSchema>;
  status?: Maybe<Scalars['String']>;
  stayTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  usablePeriod?: Maybe<CouponUsablePeriod>;
  useInAdvance?: Maybe<Scalars['Int']>;
  usedAt?: Maybe<Scalars['String']>;
  usedPlaceNo?: Maybe<Scalars['String']>;
  usedPrice?: Maybe<Scalars['String']>;
  week?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DomesticBusCartItem = ICartItem & {
  __typename?: 'DomesticBusCartItem';
  options: Array<DomesticBusCartItemOption>;
  representativeName: Scalars['String'];
  type?: Maybe<CategoryType>;
};

export type DomesticBusCartItemOption = ICartItemOption & {
  __typename?: 'DomesticBusCartItemOption';
  availability: Scalars['Boolean'];
  coupons: Array<CouponPlatformInstanceV2>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  isChosen: Scalars['Boolean'];
  outdated?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  remains?: Maybe<Scalars['Int']>;
  reservations: Array<DomesticBusCartItemOptionReservation>;
  roundTrip: Scalars['Boolean'];
  unavailableReason?: Maybe<CartItemOptionUnavailableReason>;
};

export type DomesticBusCartItemOptionReservation = {
  __typename?: 'DomesticBusCartItemOptionReservation';
  allocationArrivalTerminalNo: Scalars['String'];
  allocationDepartureTerminalNo: Scalars['String'];
  allocationDepartureTime: Scalars['String'];
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  returnTrip: Scalars['Boolean'];
  seats: Array<BusSeat>;
  totalSeats: Scalars['Int'];
  transportationCompanyCode: Scalars['String'];
};

export type DomesticBusCartSingleItem = ICartSingleItem & {
  __typename?: 'DomesticBusCartSingleItem';
  option: DomesticBusCartItemOption;
  representativeName: Scalars['String'];
  type?: Maybe<CategoryType>;
};

export enum DomesticCouponApplicationType {
  AdditionalOne = 'ADDITIONAL_ONE',
  AdditionalTwo = 'ADDITIONAL_TWO',
  Main = 'MAIN'
}

export type DomesticDailyPrices = {
  __typename?: 'DomesticDailyPrices';
  partialCancel: Scalars['Boolean'];
  price: Scalars['Int'];
  stayDate: Scalars['String'];
};

export type DomesticLeisureCartItem = ICartItem & {
  __typename?: 'DomesticLeisureCartItem';
  dealId: Scalars['Float'];
  dealName: Scalars['String'];
  options: Array<DomesticLeisureCartItemOption>;
  type: CategoryType;
};

export type DomesticLeisureCartItemAdd = {
  leisureOptionId: Scalars['String'];
  price: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type DomesticLeisureCartItemOption = ICartItemOption & {
  __typename?: 'DomesticLeisureCartItemOption';
  availability: Scalars['Boolean'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  coupons: Array<CouponPlatformInstanceV2>;
  createdAt: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['Float'];
  id: Scalars['String'];
  isChosen: Scalars['Boolean'];
  leisureOptionId: Scalars['String'];
  leisureOptionName: Scalars['String'];
  outdated?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  quantityLimitPerOrder?: Maybe<Scalars['Int']>;
  remains?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  unavailableReason?: Maybe<CartItemOptionUnavailableReason>;
  variant: LeisureProductVariant;
};

export type DomesticLeisureCartSingleItem = ICartSingleItem & {
  __typename?: 'DomesticLeisureCartSingleItem';
  dealId: Scalars['Float'];
  dealName: Scalars['String'];
  option: DomesticLeisureCartItemOption;
  type?: Maybe<CategoryType>;
};

export type DomesticPropertySearch = {
  __typename?: 'DomesticPropertySearch';
  aggregations?: Maybe<Aggregations>;
  hits: Array<Hits>;
  totalCount: Scalars['Int'];
};

export enum DomesticRatePlanBenefitType {
  EarlyCheckIn = 'EARLY_CHECK_IN',
  EarlyCheckOut = 'EARLY_CHECK_OUT',
  FreeBreakfast = 'FREE_BREAKFAST',
  FreeBreakfastNumber = 'FREE_BREAKFAST_NUMBER',
  LateCheckIn = 'LATE_CHECK_IN',
  LateCheckOut = 'LATE_CHECK_OUT'
}

export type DomesticRatePlanBenefits = {
  __typename?: 'DomesticRatePlanBenefits';
  name: Scalars['String'];
  type: DomesticRatePlanBenefitType;
  value: Scalars['String'];
};

export type DomesticTrainCartItem = ICartItem & {
  __typename?: 'DomesticTrainCartItem';
  options: Array<DomesticTrainCartItemOption>;
  representativeName: Scalars['String'];
  stationTrainClassifyCode: Scalars['String'];
  type: CategoryType;
};

export type DomesticTrainCartItemAdd = {
  arrivalDate: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalTime: Scalars['String'];
  carriageClassCode: Scalars['String'];
  departureDate: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureTime: Scalars['String'];
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  price: Scalars['Int'];
  runningDate: Scalars['String'];
  seats?: InputMaybe<Array<DomesticTrainCartItemSeatAdd>>;
  stationTrainClassifyCode: Scalars['String'];
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type DomesticTrainCartItemOption = ICartItemOption & {
  __typename?: 'DomesticTrainCartItemOption';
  adults: Scalars['Int'];
  availability: Scalars['Boolean'];
  child?: Maybe<Scalars['Int']>;
  coupons: Array<CouponPlatformInstanceV2>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  isChosen: Scalars['Boolean'];
  outdated?: Maybe<Scalars['Boolean']>;
  price: Scalars['Int'];
  remains?: Maybe<Scalars['Int']>;
  roundTrip: Scalars['Boolean'];
  trains: Array<DomesticTrainCartItemTicket>;
  unavailableReason?: Maybe<CartItemOptionUnavailableReason>;
};

export type DomesticTrainCartItemOptionTicketSeat = {
  __typename?: 'DomesticTrainCartItemOptionTicketSeat';
  carriageNo: Scalars['String'];
  direction: Scalars['String'];
  seatDescription: Scalars['String'];
  seatNo: Scalars['String'];
};

export type DomesticTrainCartItemSeatAdd = {
  carriageNo: Scalars['String'];
  seatNo: Scalars['String'];
};

export type DomesticTrainCartItemTicket = {
  __typename?: 'DomesticTrainCartItemTicket';
  adultFare: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  carriageClassCode: Scalars['String'];
  childFare: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  goodsType: Scalars['String'];
  /** 묶음 할인 가격 */
  packageDiscount: Scalars['Int'];
  price: Scalars['Int'];
  runningDate: Scalars['String'];
  seats?: Maybe<Array<DomesticTrainCartItemOptionTicketSeat>>;
  stationTrainClassifyCode: Scalars['String'];
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type DomesticTrainCartSingleItem = ICartSingleItem & {
  __typename?: 'DomesticTrainCartSingleItem';
  option: DomesticTrainCartItemOption;
  representativeName: Scalars['String'];
  stationTrainClassifyCode: Scalars['String'];
  type: CategoryType;
};

export type Event = {
  __typename?: 'Event';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ExpectedReward = {
  __typename?: 'ExpectedReward';
  amount: Scalars['Int'];
  rate: Scalars['Float'];
  type: Scalars['String'];
};

export type Hits = {
  __typename?: 'Hits';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressDetail?: Maybe<Scalars['String']>;
  areaCity?: Maybe<Scalars['String']>;
  areaPropertyNo?: Maybe<Scalars['Int']>;
  associateLevel?: Maybe<Scalars['Int']>;
  association?: Maybe<Scalars['Int']>;
  authZoneType?: Maybe<Scalars['Int']>;
  averageQualityScore: Scalars['Float'];
  ballonZoneType?: Maybe<Scalars['Int']>;
  bestPick?: Maybe<Scalars['Int']>;
  bestPrice: Scalars['Int'];
  breakTime?: Maybe<Scalars['String']>;
  breakfast?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['Int']>;
  chargeAlertType?: Maybe<Scalars['Int']>;
  className?: Maybe<Scalars['String']>;
  classType?: Maybe<Scalars['String']>;
  contentsType?: Maybe<Scalars['Int']>;
  contractDate?: Maybe<Scalars['String']>;
  couponAround?: Maybe<Scalars['Int']>;
  couponDays?: Maybe<Scalars['Int']>;
  couponMyRoomDays?: Maybe<Scalars['Int']>;
  couponMyRoomRent?: Maybe<Scalars['Int']>;
  couponMyRoomStay?: Maybe<Scalars['Int']>;
  couponRent?: Maybe<Scalars['Int']>;
  couponStay?: Maybe<Scalars['Int']>;
  daysAgree?: Maybe<Scalars['Int']>;
  daysOpen?: Maybe<Scalars['Int']>;
  daysSoldout?: Maybe<Scalars['Int']>;
  directions?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  domain: Scalars['String'];
  eventTitles: Scalars['String'];
  extraPoint?: Maybe<Scalars['Int']>;
  fileName: Scalars['String'];
  franchiseType?: Maybe<Scalars['Int']>;
  happycall?: Maybe<Scalars['Int']>;
  hotDeal?: Maybe<Scalars['Int']>;
  introduction?: Maybe<Scalars['String']>;
  iot?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  luckyBox?: Maybe<Scalars['Int']>;
  mildWild?: Maybe<Scalars['Int']>;
  myRoom?: Maybe<Scalars['Int']>;
  myRoomRentSoldout?: Maybe<Scalars['Int']>;
  myRoomStaySoldout?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  newCategory?: Maybe<Scalars['Int']>;
  newHotDeal?: Maybe<Scalars['Int']>;
  newHotDealRentDiscountRate?: Maybe<Scalars['Int']>;
  newHotDealStayDiscountRate?: Maybe<Scalars['Int']>;
  no: Scalars['Int'];
  ownerReplyCount?: Maybe<Scalars['Int']>;
  partnershipType?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  photoNo?: Maybe<Scalars['Int']>;
  pickup?: Maybe<Scalars['Int']>;
  placeEvent?: Maybe<Scalars['Int']>;
  property: ProductPropertyDomestic;
  published?: Maybe<Scalars['Int']>;
  qaType?: Maybe<Scalars['Int']>;
  qualityScore?: Maybe<Scalars['Int']>;
  registerdDate?: Maybe<Scalars['String']>;
  rentAgree?: Maybe<Scalars['Int']>;
  rentDiscountPrice?: Maybe<Scalars['Int']>;
  rentMinUseTime?: Maybe<Scalars['String']>;
  rentOpen?: Maybe<Scalars['Int']>;
  rentPrice?: Maybe<Scalars['Int']>;
  rentSoldout?: Maybe<Scalars['Int']>;
  rentUseTime?: Maybe<Scalars['String']>;
  reserveDaysDiscountPrice?: Maybe<Scalars['Int']>;
  reserveDaysPrice?: Maybe<Scalars['Int']>;
  reserveDaysUseStartTime?: Maybe<Scalars['String']>;
  reserveEarly?: Maybe<Scalars['Int']>;
  reservePublished?: Maybe<Scalars['Int']>;
  reserveRentDiscountPrice?: Maybe<Scalars['Int']>;
  reserveRentMaxUseTime?: Maybe<Scalars['String']>;
  reserveRentPrice?: Maybe<Scalars['Int']>;
  reserveRentUseTime?: Maybe<Scalars['String']>;
  reserveStayDiscountPrice?: Maybe<Scalars['Int']>;
  reserveStayPrice?: Maybe<Scalars['Int']>;
  reserveStayUseStartTime?: Maybe<Scalars['String']>;
  reserveType?: Maybe<Scalars['Int']>;
  reviewType?: Maybe<Scalars['Int']>;
  reviewsCount: Scalars['Int'];
  selectedCount?: Maybe<Scalars['Int']>;
  serviceType?: Maybe<Scalars['Int']>;
  shortNotice: Scalars['String'];
  smartStay?: Maybe<Scalars['Int']>;
  stayAgree?: Maybe<Scalars['Int']>;
  stayDiscountPrice?: Maybe<Scalars['Int']>;
  stayOpen?: Maybe<Scalars['Int']>;
  stayPrice?: Maybe<Scalars['Int']>;
  staySoldout?: Maybe<Scalars['Int']>;
  stayUseStartTime?: Maybe<Scalars['String']>;
  subwayNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  todayCancel: Scalars['Int'];
  yellowId?: Maybe<Scalars['String']>;
};

export type ICartItem = {
  options: Array<ICartItemOption>;
  type?: Maybe<CategoryType>;
};

export type ICartItemOption = {
  id: Scalars['String'];
  isChosen: Scalars['Boolean'];
  remains?: Maybe<Scalars['Int']>;
};

export type ICartSingleItem = {
  option: ICartItemOption;
  type?: Maybe<CategoryType>;
};

export type Information = {
  __typename?: 'Information';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Items = {
  __typename?: 'Items';
  availablePeriod?: Maybe<AvailablePeriod>;
  costPrice?: Maybe<Scalars['Int']>;
  dealId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  optionId?: Maybe<Scalars['Int']>;
  pinType?: Maybe<Scalars['String']>;
  pqlat?: Maybe<Scalars['Int']>;
  pqlpp?: Maybe<Scalars['Int']>;
  sellerInfoId?: Maybe<Scalars['String']>;
  stockCount?: Maybe<Scalars['Int']>;
};

export type LeisureAdditionalPurchaseProduct = {
  __typename?: 'LeisureAdditionalPurchaseProduct';
  /** 추가구매 상품 ID */
  productId: Scalars['Float'];
  /** 추가구매 상품명 */
  productName: Scalars['String'];
};

/**
 * 추가 구매 검증
 * NOTE: 필드 타입만 정의
 */
export type LeisureAdditionalPurchaseVerification = {
  __typename?: 'LeisureAdditionalPurchaseVerification';
  /** 예약일시 */
  date: Scalars['String'];
};

export type LeisureAdditionalPurchaseVerificationInput = {
  orderGroupId: Scalars['String'];
  productId: Scalars['Float'];
};

export type LeisureBody = {
  __typename?: 'LeisureBody';
  content: Array<Content>;
  number: Scalars['Int'];
  size: Scalars['Int'];
  totalElements: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** 취소수수료 정책 */
export type LeisureCancellationFeePlan = {
  __typename?: 'LeisureCancellationFeePlan';
  cancellationFeeTypeCode: Scalars['String'];
  cancellationTypeCode: CancellationTypeCode;
  endDateTime: Scalars['String'];
  fee: Scalars['Float'];
  startDateTime: Scalars['String'];
};

export type LeisureCategory = {
  __typename?: 'LeisureCategory';
  depth_one?: Maybe<Array<Maybe<DepthOne>>>;
};

export type LeisureHeader = {
  __typename?: 'LeisureHeader';
  code?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type LeisureProduct = {
  __typename?: 'LeisureProduct';
  /** 추가구매 상품 정보 */
  additionalPurchaseProduct?: Maybe<LeisureAdditionalPurchaseProduct>;
  braze?: Maybe<LeisureProductBraze>;
  facilities: Array<LeisureProductFacility>;
  /** 취소 수수료 여부 */
  isCancelPenalty: Scalars['Boolean'];
  /** 회원 전용 상품 여부 */
  isMemberOnly: Scalars['Boolean'];
  memberOnlyLabel?: Maybe<Scalars['String']>;
  partners: Array<LeisureProductPartner>;
  /** 상품 이벤트 유형 코드 */
  productEvent?: Maybe<LeisureProductEvent>;
  /** 상품 그룹 정보 */
  productGroup?: Maybe<LeisureProductGroup>;
  productId: Scalars['Float'];
  productImage: LeisureProductImage;
  productInfo?: Maybe<LeisureProductInfo>;
  productName: Scalars['String'];
  /** 상품 옵션 그룹 정보 */
  productOptionGroups?: Maybe<Array<LeisureProductOptionGroup>>;
  /**
   * "HOT_DEAL", "LOWEST_PRICE", "POPULAR", "SPECIAL_PRICE"
   * API 명세는 enum 값이나 해당 값 추가 또는 변경시 오류 발생하지 않도록
   * String 으로 방어
   */
  productPromotions?: Maybe<Array<Scalars['String']>>;
  productStatusCode: LeisureProductStatusCode;
  productStatusCodeLabel?: Maybe<Scalars['String']>;
  productTypeCode: ProductTypeCode;
  productTypeCodeLabel?: Maybe<Scalars['String']>;
  productVersion: Scalars['Int'];
  purchaseOptionTypeCode: PurchaseOptionTypeCode;
};

export type LeisureProductBraze = {
  __typename?: 'LeisureProductBraze';
  /** braze 솔루션에서 정의한 카테고리 ID */
  categoryId?: Maybe<Scalars['String']>;
  /** braze 솔루션에서 정의한 카테고리명 */
  categoryName?: Maybe<Scalars['String']>;
  /** 도시상세 */
  cityDetail?: Maybe<Scalars['String']>;
  /** 도시명 */
  cityName?: Maybe<Scalars['String']>;
  /** 판매가격(대표가격) */
  propertyPrice?: Maybe<Scalars['Float']>;
};

export type LeisureProductDetailInfo = {
  __typename?: 'LeisureProductDetailInfo';
  content?: Maybe<Scalars['String']>;
  subContents?: Maybe<Array<LeisureProductDetailInfo>>;
};

/** 상품 이벤트 유형코드 */
export type LeisureProductEvent = {
  __typename?: 'LeisureProductEvent';
  /** 종료일시 */
  endDateTime?: Maybe<Scalars['String']>;
  /**
   * API 명세는 enum 값이나 해당 값 추가 또는 변경시 오류 발생하지 않도록 String 으로 방어
   * FIRST_BASIS: 선착순
   * EXCLUSIVE: 단독구성
   * LIMITED_PERIOD: 기간한정
   * PLAY_BATTLE: 레포츠대전
   * FISHING_VILLAGE_BATTLE: 어촌대전
   * KING_SPECIAL_PRICE: 킹특가
   */
  productEventTypeCode: Scalars['String'];
  /** 상품 이벤트 유형코드에 대한 라벨 */
  productEventTypeCodeLabel?: Maybe<Scalars['String']>;
  /** 시작일시 */
  startDateTime?: Maybe<Scalars['String']>;
};

/** 시설 목록 */
export type LeisureProductFacility = {
  __typename?: 'LeisureProductFacility';
  /** 주소 */
  address?: Maybe<Scalars['String']>;
  /** 오시는길, 문의전화, 운영시간 등 부가 정보 */
  facilityInfo?: Maybe<Array<LeisureProductDetailInfo>>;
  /** 시설명 */
  facilityName: Scalars['String'];
  /** 대표시설여부 */
  isRepFacility: Scalars['Boolean'];
  /** 위치-위도 (소수점 8자리) */
  latitude?: Maybe<Scalars['Float']>;
  /** 위치-경도 (소수점 8자리) */
  longitude?: Maybe<Scalars['Float']>;
};

export type LeisureProductGroup = {
  __typename?: 'LeisureProductGroup';
  /** 상품 ID 를 묶을 수 있는 상품 그룹 ID */
  productGroupId: Scalars['Float'];
};

export type LeisureProductImage = {
  __typename?: 'LeisureProductImage';
  detailImageUrls?: Maybe<Array<Scalars['String']>>;
  rollingImageUrls?: Maybe<Array<Scalars['String']>>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type LeisureProductInfo = {
  __typename?: 'LeisureProductInfo';
  /** 취소/환불 규정 */
  refundInfo?: Maybe<Array<LeisureProductDetailInfo>>;
  /** 고객센터의 업체명, 문의번호, 운영시간 */
  serviceCenterInfo?: Maybe<Array<LeisureProductDetailInfo>>;
  /** 기본 정보, 사용 안내, 유의사항 */
  usageInfo?: Maybe<Array<LeisureProductDetailInfo>>;
};

/** 상품 옵션 그룹 (필요 필드만 정의) */
export type LeisureProductOptionGroup = {
  __typename?: 'LeisureProductOptionGroup';
  /** 상품 옵션 그룹 ID */
  productOptionGroupId: Scalars['Float'];
  productOptionGroupName?: Maybe<Scalars['String']>;
};

export type LeisureProductPartner = {
  __typename?: 'LeisureProductPartner';
  /** 주소 */
  address: Scalars['String'];
  /** 사업자등록번호 */
  businessRegistrationNumber: Scalars['String'];
  /** 상호명 */
  companyName: Scalars['String'];
  /** 전자우편 주소 */
  email: Scalars['String'];
  /** 통신판매신고번호 */
  mailOrderSalesNumber?: Maybe<Scalars['String']>;
  /** 파트너Code */
  partnerCode: Scalars['String'];
  /** 전화번호 */
  phoneNumber: Scalars['String'];
  /** 대표자명 */
  representativeName: Scalars['String'];
};

/** 상태 코드 */
export enum LeisureProductStatusCode {
  /** 판매종료 */
  EndOfSale = 'END_OF_SALE',
  /** 판매중 */
  InSale = 'IN_SALE',
  /** 품절 */
  SoldOut = 'SOLD_OUT',
  /** 판매예정 */
  WaitingForSale = 'WAITING_FOR_SALE'
}

export type LeisureProductVariant = {
  __typename?: 'LeisureProductVariant';
  /** 취소수수료 정책 */
  cancellationFeePlans: Array<LeisureCancellationFeePlan>;
  /** 당일 사용 가능 여부 */
  isAvailableOnPurchaseDate: Scalars['Boolean'];
  /** 만료 후 환불 가능 여부 */
  isRefundableAfterExpiration: Scalars['Boolean'];
  /** 바우처(모바일 입장권) 확인 페이지 제공여부 */
  isVoucherPageProvided: Scalars['Boolean'];
  /** 회원등급 배지 유형 코드 (회원혜택 조회 API의 badge 값) */
  memberClassBadgeTypeCode: MemberClassBadgeType;
  /** 구매 가능한 회원등급 코드 (미전달 시 LEVEL_00) */
  memberClassTypeCode?: Maybe<Scalars['String']>;
  productOptionGroup: LeisureProductOptionGroup;
  /** 1인당 구매 제한 일 동안 구매 가능한 수량 (0 또는 -1 : 제한 없음) */
  quantityPerPerson: Scalars['Int'];
  /** 1인당 구매 가능 수량이 적용되는 일 수 (-1 : 제한 없음) */
  quantityPerPersonValidityDays: Scalars['Int'];
  /** 한번에 구매 가능한 수량 (0 또는 -1 : 제한 없음) */
  quantityPerPurchase: Scalars['Int'];
  refundApprovalTypeCode: RefundApprovalTypeCode;
  /** 유효기간 종료 n 일 전까지 100% 환불 */
  refundAvailableDays?: Maybe<Scalars['Int']>;
  /** 판매 종료일 */
  saleEndDate: Scalars['String'];
  saleEndTime?: Maybe<Scalars['String']>;
  /** 판매 시작일 */
  saleStartDate: Scalars['String'];
  saleStartTime?: Maybe<Scalars['String']>;
  /** 유효기간 유형 코드가 구매일기준일때, 구매일로 부터 n일 */
  validityDays?: Maybe<Scalars['Int']>;
  /** 유효기간 종료일 (구매일기준 유형일때는 오늘 + 유효기간 일 수) */
  validityEndDateTime?: Maybe<Scalars['String']>;
  validityPeriodTypeCode: ValidityPeriodTypeCode;
  /** 유효기간 시작일 (구매일기준 유형일때는 오늘) */
  validityStartDateTime?: Maybe<Scalars['String']>;
  variantDescription?: Maybe<Array<LeisureProductDetailInfo>>;
  variantId: Scalars['Float'];
  variantName: Scalars['String'];
  variantPrice: VariantPrice;
  variantStatusCode: LeisureProductStatusCode;
  variantStatusCodeLabel?: Maybe<Scalars['String']>;
  variantSupplyItems: Array<VariantSupplyItem>;
};

export type LeisureProductVariantInput = {
  date?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  productId: Scalars['Float'];
  productVersion?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['String']>;
};

export type LeisureSearch = {
  __typename?: 'LeisureSearch';
  body: LeisureBody;
  header: LeisureHeader;
};

export type LeisureSearchInput = {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type LeisureqProductItem = {
  __typename?: 'LeisureqProductItem';
  availableForSale?: Maybe<Scalars['Boolean']>;
  availablePeriod?: Maybe<LeisureqProductPeriod>;
  children?: Maybe<Array<Maybe<LeisureqProductOptionItem>>>;
  created?: Maybe<Scalars['String']>;
  expiredType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastModified?: Maybe<Scalars['String']>;
  limitPerOrder?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  parentName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  refundType?: Maybe<Scalars['String']>;
  refundableAfterExpiry?: Maybe<Scalars['Boolean']>;
  salesPeriod?: Maybe<LeisureqProductPeriod>;
  settlementPrice?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
};

export type LeisureqProductOptionItem = {
  __typename?: 'LeisureqProductOptionItem';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LeisureqProductPeriod = {
  __typename?: 'LeisureqProductPeriod';
  end?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
};

export type LinkageType = {
  __typename?: 'LinkageType';
  NOL: NolMemberInfoType;
};

export type Location = {
  __typename?: 'Location';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type LocationLang = {
  __typename?: 'LocationLang';
  en?: Maybe<Scalars['String']>;
  zhcn?: Maybe<Scalars['String']>;
};

export type Locations = {
  __typename?: 'Locations';
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Managements = {
  __typename?: 'Managements';
  code?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum MarketingAgree {
  MarketingLeverage = 'MARKETING_LEVERAGE',
  SmsReceive = 'SMS_RECEIVE'
}

export type MarketingAgreeInput = {
  option: MarketingAgree;
  value: Scalars['Boolean'];
};

export type MarketingOrderInput = {
  category: CategoryName;
  compositeId: Scalars['String'];
  id: Scalars['String'];
  useEndDate: Scalars['String'];
};

/** 회원등급 배지 유형 (회원혜택 조회 API의 badge 값) */
export enum MemberClassBadgeType {
  GoldClass = 'GOLD_CLASS',
  PlatinumClass = 'PLATINUM_CLASS',
  SilverClass = 'SILVER_CLASS'
}

export enum MemberClassBenefitCode {
  PaymentRewardGoldClass = 'PAYMENT_REWARD_GOLD_CLASS',
  PaymentRewardPlatinumClass = 'PAYMENT_REWARD_PLATINUM_CLASS',
  PaymentRewardSilverClass = 'PAYMENT_REWARD_SILVER_CLASS'
}

export type MemberClassItem = {
  __typename?: 'MemberClassItem';
  appliedAt?: Maybe<Scalars['String']>;
  classCode: Scalars['String'];
  classTypeCode: Scalars['String'];
  endAt?: Maybe<Scalars['String']>;
  firstConfirmedAt?: Maybe<Scalars['String']>;
  firstUpgradedAt?: Maybe<Scalars['String']>;
  memberNo: Scalars['String'];
  startAt?: Maybe<Scalars['String']>;
};

export type MemberGatewayCiData = {
  __typename?: 'MemberGatewayCIData';
  token?: Maybe<Scalars['String']>;
};

export type MemberGatewayMembership = {
  __typename?: 'MemberGatewayMembership';
  data?: Maybe<MemberGatewayMembershipData>;
  memberNo?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
};

export enum MemberGatewayMembershipAffiliation {
  Kt = 'KT',
  Skt = 'SKT'
}

export type MemberGatewayMembershipData = {
  __typename?: 'MemberGatewayMembershipData';
  birth?: Maybe<Scalars['String']>;
  cardNo?: Maybe<Scalars['String']>;
};

export type MemberGatewayMembershipDataInput = {
  birth?: InputMaybe<Scalars['String']>;
  cardNo?: InputMaybe<Scalars['String']>;
};

export type MemberInfo = {
  __typename?: 'MemberInfo';
  agreement?: Maybe<AgreementType>;
  email?: Maybe<Scalars['String']>;
  linkage: LinkageType;
  memberNo: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  phoneNum?: Maybe<Scalars['String']>;
};

export type MemberUpdateInput = {
  name?: InputMaybe<Scalars['String']>;
  payCode?: InputMaybe<Scalars['String']>;
};

export type MemberUpdatePhoneNumInput = {
  certGroup: Scalars['String'];
  code: Scalars['String'];
  createVisitorSession: Scalars['Boolean'];
  name: Scalars['String'];
  phoneNum: Scalars['String'];
};

export enum MobileMembershipType {
  Kt = 'KT',
  Skt = 'SKT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addToCart: AddtoCartItemsResponse;
  confirmBusTicket: ConfirmBusTicket;
  couponDomesticInstances: Array<CouponDomesticInstances>;
  couponDomesticInstancesV2: Array<CouponDomesticInstancesV2>;
  couponPlatformCheckProgress: Array<CouponPlatformCheckProgress>;
  couponPlatformDownloadCoupons: Array<CouponPlatformDownloaded>;
  couponPlatformInstances: Array<CouponPlatformInstances>;
  downloadCoupons: Array<CouponDownloaded>;
  memberUpdateMember: Scalars['Boolean'];
  memberUpdatePhoneNum: Scalars['Boolean'];
  orderCancelV3: OrderCancel;
  orderHide?: Maybe<Scalars['Boolean']>;
  precheckOrderCancel?: Maybe<OrderCancelPrecheck>;
  propertyCouponCheckProgress: Array<PropertyCouponCheckProgress>;
  removeFromCart: Scalars['String'];
  requestOrderShare: RequestOrderShare;
  requestSendKinesisLog?: Maybe<Scalars['String']>;
  saveVisitorAgree?: Maybe<Scalars['Boolean']>;
  sendCertification: CertificationCertifyResult;
  sendReceiptEmail: Scalars['Boolean'];
  serverCurrentAt: Scalars['String'];
  storeMembership: Scalars['Boolean'];
  updateCartItem: Scalars['String'];
  updateCartItemByOptionId: UpdateCartItemByOrderIdResponse;
  updateCartItemByOptionIdV2: UpdateCartItemByOrderIdV2Response;
  updateVisitorSessionName: Scalars['Boolean'];
};


export type MutationAddToCartArgs = {
  input: AddToCartItems;
};


export type MutationConfirmBusTicketArgs = {
  input: ConfirmBusTicketInput;
};


export type MutationCouponDomesticInstancesArgs = {
  input: Array<CouponDomesticInstanceInput>;
};


export type MutationCouponDomesticInstancesV2Args = {
  input: Array<CouponDomesticInstanceV2Input>;
};


export type MutationCouponPlatformCheckProgressArgs = {
  input: CouponPlatformCheckProgressInput;
};


export type MutationCouponPlatformDownloadCouponsArgs = {
  input: Array<CouponPlatformDownloadInput>;
};


export type MutationCouponPlatformInstancesArgs = {
  input: Array<CouponPlatformInstanceInput>;
};


export type MutationDownloadCouponsArgs = {
  inputs: Array<CouponDownloadInput>;
};


export type MutationMemberUpdateMemberArgs = {
  input: MemberUpdateInput;
};


export type MutationMemberUpdatePhoneNumArgs = {
  input: MemberUpdatePhoneNumInput;
};


export type MutationOrderCancelV3Args = {
  cancelDetails: OrderCancelInput;
  orderId: Scalars['String'];
};


export type MutationOrderHideArgs = {
  orderId: Scalars['String'];
};


export type MutationPrecheckOrderCancelArgs = {
  param: OrderCancelPrecheckInput;
};


export type MutationPropertyCouponCheckProgressArgs = {
  input: PropertyCouponCheckProgressInput;
};


export type MutationRemoveFromCartArgs = {
  input: RemoveFromCart;
};


export type MutationRequestOrderShareArgs = {
  orderId: Scalars['String'];
};


export type MutationRequestSendKinesisLogArgs = {
  data: Scalars['String'];
  eventName: Scalars['String'];
};


export type MutationSaveVisitorAgreeArgs = {
  input: VisitorSaveAgreeInput;
};


export type MutationSendCertificationArgs = {
  input: SendCertificationInput;
};


export type MutationSendReceiptEmailArgs = {
  input: SendReceiptEmailInput;
};


export type MutationStoreMembershipArgs = {
  data: MemberGatewayMembershipDataInput;
  option: MemberGatewayMembershipAffiliation;
};


export type MutationUpdateCartItemArgs = {
  input: UpdateCartItem;
};


export type MutationUpdateCartItemByOptionIdArgs = {
  input: UpdateCartItem;
};


export type MutationUpdateCartItemByOptionIdV2Args = {
  input: UpdateCartItem;
};


export type MutationUpdateVisitorSessionNameArgs = {
  name?: InputMaybe<Scalars['String']>;
};

export type NameLang = {
  __typename?: 'NameLang';
  en?: Maybe<Scalars['String']>;
  zhcn?: Maybe<Scalars['String']>;
};

export type NolChatResponse = {
  __typename?: 'NolChatResponse';
  isAvailable: Scalars['Boolean'];
  validInvitation?: Maybe<Scalars['Boolean']>;
};

export type NolMemberInfoType = {
  __typename?: 'NolMemberInfoType';
  achievementMonth?: Maybe<Scalars['String']>;
  affiliationAgreedAt?: Maybe<Scalars['String']>;
  cardMemberNo?: Maybe<Scalars['String']>;
  isAchieved?: Maybe<Scalars['Boolean']>;
  isAgreeAffiliation?: Maybe<Scalars['Boolean']>;
  isLinked: Scalars['Boolean'];
  isNoTrackRecord?: Maybe<Scalars['Boolean']>;
  issuedAt?: Maybe<Scalars['String']>;
  memberNo?: Maybe<Scalars['Int']>;
  modifiedDate?: Maybe<Scalars['String']>;
};

export enum NonCancellationReason {
  Canceled = 'CANCELED',
  CancelRequested = 'CANCEL_REQUESTED',
  Completed = 'COMPLETED',
  NonRefundable = 'NON_REFUNDABLE',
  PassedExpirationDate = 'PASSED_EXPIRATION_DATE'
}

export type Notices = {
  __typename?: 'Notices';
  benefit?: Maybe<Array<Maybe<Scalars['String']>>>;
  event?: Maybe<Array<Maybe<Event>>>;
  information?: Maybe<Array<Maybe<Information>>>;
  reservation?: Maybe<Array<Maybe<Reservation>>>;
  singleLine?: Maybe<Array<Maybe<SingleLine>>>;
};

export type Options = {
  __typename?: 'Options';
  availablePeriod?: Maybe<AvailablePeriod>;
  canExpiredRefund?: Maybe<Scalars['Boolean']>;
  costPrice?: Maybe<Scalars['Int']>;
  coverPrice?: Maybe<Scalars['Int']>;
  dealId?: Maybe<Scalars['Int']>;
  discountedGajagoSalePrice?: Maybe<Scalars['Int']>;
  displayYn?: Maybe<Scalars['String']>;
  expiredType?: Maybe<Scalars['String']>;
  gajagoSalePrice?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<Items>>>;
  name?: Maybe<Scalars['String']>;
  partnerMarginPercent?: Maybe<Scalars['Float']>;
  refundType?: Maybe<Scalars['String']>;
  salesPeriod?: Maybe<SalesPeriod>;
  status?: Maybe<Scalars['String']>;
  stockMgtYn?: Maybe<Scalars['String']>;
  supplyYn?: Maybe<Scalars['String']>;
};

export type OrderCancel = {
  __typename?: 'OrderCancel';
  additionalOrders?: Maybe<Array<OrderCancelAdditionalOrder>>;
  amount?: Maybe<Scalars['Int']>;
  categoryOrders: Array<OrderCancelCategory>;
  createdAt?: Maybe<Scalars['String']>;
  discount?: Maybe<OrderCancelCartDiscount>;
  hashOrderId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  payments?: Maybe<Array<OrderCancelPayment>>;
  requestedAt?: Maybe<Scalars['String']>;
};

export type OrderCancelAdditionalOrder = {
  __typename?: 'OrderCancelAdditionalOrder';
  categoryOrders: Array<OrderCancelCategory>;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  requestedAt: Scalars['String'];
};

export type OrderCancelBusDiscount = {
  __typename?: 'OrderCancelBusDiscount';
  amount: Scalars['Int'];
  discountType: OrderDetailsCancellationBusDiscountType;
};

export type OrderCancelBusOrder = {
  __typename?: 'OrderCancelBusOrder';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderCancelBusOrderDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  reservations: Array<OrderCancelBusOrderReservation>;
  success: Scalars['Boolean'];
};

export type OrderCancelBusOrderDiscount = {
  __typename?: 'OrderCancelBusOrderDiscount';
  busDiscount?: Maybe<OrderCancelBusDiscount>;
  coupons: Array<OrderCancelCoupon>;
};

export type OrderCancelBusOrderReservation = {
  __typename?: 'OrderCancelBusOrderReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<OrderCancelBusOrderReservationTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type OrderCancelBusOrderReservationTicket = {
  __typename?: 'OrderCancelBusOrderReservationTicket';
  id: Scalars['Int'];
  price: Scalars['Int'];
  seatNo: Scalars['Int'];
  success: Scalars['Boolean'];
  ticketType: Scalars['String'];
};

/** 장바구니 단위 할인 정보 */
export type OrderCancelCartDiscount = {
  __typename?: 'OrderCancelCartDiscount';
  package?: Maybe<OrderCancelCartTrainPackageDiscount>;
};

/** 장바구니 단위 기차 묶음할인 정보 */
export type OrderCancelCartTrainPackageDiscount = {
  __typename?: 'OrderCancelCartTrainPackageDiscount';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
};

export type OrderCancelCategory = OrderCancelBusOrder | OrderCancelDomesticOrder | OrderCancelLeisureProductOrder | OrderCancelTrainOrder;

export type OrderCancelCoupon = {
  __typename?: 'OrderCancelCoupon';
  commissionAmount: Scalars['Int'];
  coupon?: Maybe<DomesticAccommodationUserCoupon>;
  id: Scalars['Float'];
  refund: Scalars['Boolean'];
  userCoupon?: Maybe<CouponPlatformUserCoupon>;
};

export type OrderCancelDomesticOrder = {
  __typename?: 'OrderCancelDomesticOrder';
  adults?: Maybe<Scalars['Int']>;
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  canceledAt?: Maybe<Scalars['String']>;
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkOutAt: Scalars['String'];
  childrenAges?: Maybe<Array<Scalars['Int']>>;
  createdAt?: Maybe<Scalars['String']>;
  discount?: Maybe<OrderCancelDomesticOrderDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  pendingStatus?: Maybe<PendingStatus>;
  pickupType?: Maybe<PickupType>;
  price?: Maybe<Scalars['Int']>;
  property?: Maybe<ProductPropertyDomestic>;
  propertyCategory?: Maybe<PropertyCategory>;
  propertyId?: Maybe<Scalars['Int']>;
  propertyName?: Maybe<Scalars['String']>;
  propertyVersion?: Maybe<Scalars['Int']>;
  ratePlanId?: Maybe<Scalars['Int']>;
  ratePlanTitle?: Maybe<Scalars['String']>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName?: Maybe<Scalars['String']>;
  roomTypeVersion?: Maybe<Scalars['Int']>;
  statusGroupCode?: Maybe<StatusGroupCode>;
  success: Scalars['Boolean'];
  useType: DomesticAccommodationUseType;
  visitType?: Maybe<VisitType>;
};

export type OrderCancelDomesticOrderDiscount = {
  __typename?: 'OrderCancelDomesticOrderDiscount';
  coupons: Array<OrderCancelCoupon>;
  mobileMembership?: Maybe<OrderCancelMobileMembership>;
};

export type OrderCancelFdsMeta = {
  appVersion: Scalars['String'];
  channelCode: Scalars['String'];
  deviceId: Scalars['String'];
  deviceModel: Scalars['String'];
  devicePlatform: Scalars['String'];
  deviceTimezone: Scalars['String'];
  isRoaming?: InputMaybe<Scalars['Boolean']>;
  isVpn?: InputMaybe<Scalars['Boolean']>;
  mobileCountryCode?: InputMaybe<Scalars['String']>;
  mobileNetworkCode?: InputMaybe<Scalars['String']>;
  remoteAddress: Scalars['String'];
  userAgent: Scalars['String'];
};

export type OrderCancelInput = {
  additionalOrders?: InputMaybe<Array<OrderCancelInputAdditionalOrder>>;
  categoryOrders: Array<OrderCancelInputCategoryOrder>;
  fdsMeta?: InputMaybe<OrderCancelFdsMeta>;
  reasonCode: ReasonCode;
  reasonDetail?: InputMaybe<Scalars['String']>;
};

export type OrderCancelInputAdditionalOrder = {
  categoryOrders: Array<OrderCancelInputCategoryOrder>;
  compositeOrderGuid: Scalars['String'];
};

export type OrderCancelInputCategoryOrder = {
  id: Scalars['String'];
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCancelLeisureOrderDiscount = {
  __typename?: 'OrderCancelLeisureOrderDiscount';
  coupons: Array<OrderCancelCoupon>;
};

export type OrderCancelLeisureOrderValid = {
  __typename?: 'OrderCancelLeisureOrderValid';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type OrderCancelLeisureProductOrder = {
  __typename?: 'OrderCancelLeisureProductOrder';
  category: CategoryType;
  discount?: Maybe<OrderCancelLeisureOrderDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<OrderCancelLeisureProductOrderItem>;
  success: Scalars['Boolean'];
};

export type OrderCancelLeisureProductOrderItem = {
  __typename?: 'OrderCancelLeisureProductOrderItem';
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  id: Scalars['String'];
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  success: Scalars['Boolean'];
  time?: Maybe<Scalars['String']>;
  valid: OrderCancelLeisureOrderValid;
  variant: LeisureProductVariant;
};

export type OrderCancelMobileMembership = {
  __typename?: 'OrderCancelMobileMembership';
  commissionAmount: Scalars['Int'];
  refund: Scalars['Boolean'];
  type?: Maybe<MobileMembershipType>;
};

export type OrderCancelPayment = {
  __typename?: 'OrderCancelPayment';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  method: Scalars['String'];
  paymentMethod: YapaymentMethod;
  type: PaymentType;
};

export type OrderCancelPolicy = {
  __typename?: 'OrderCancelPolicy';
  additionalOrders?: Maybe<Array<OrderCancelPolicyAdditionalOrder>>;
  categoryOrders: Array<OrderCancelPolicyCategoryOrder>;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderCancelPolicyDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  /** 부분 취소 가능 여부 (장바구니 묶음 할인 여부) */
  partialCancelable: Scalars['Boolean'];
  payments?: Maybe<Array<OrderCancelPolicyPayment>>;
};

export type OrderCancelPolicyAdditionalOrder = {
  __typename?: 'OrderCancelPolicyAdditionalOrder';
  categoryOrders: Array<OrderCancelPolicyCategoryOrder>;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  partialCancelable: Scalars['Boolean'];
};

export type OrderCancelPolicyBus = OrderCancelPolicyCategory & {
  __typename?: 'OrderCancelPolicyBus';
  category: CategoryType;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  reservations: Array<OrderCancelPolicyBusReservation>;
};

export type OrderCancelPolicyBusReservation = {
  __typename?: 'OrderCancelPolicyBusReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  busGrade: Scalars['String'];
  cancelPolicy?: Maybe<BusCancelPolicy>;
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<CancelPolicyBusTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type OrderCancelPolicyCategory = {
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
};

export type OrderCancelPolicyCategoryOrder = OrderCancelPolicyBus | OrderCancelPolicyDomestic | OrderCancelPolicyLeisureProduct | OrderCancelPolicyTrain;

export type OrderCancelPolicyDiscount = {
  __typename?: 'OrderCancelPolicyDiscount';
  coupons?: Maybe<Array<Maybe<OrderCancelPolicyDiscountCoupon>>>;
};

export type OrderCancelPolicyDiscountCoupon = {
  __typename?: 'OrderCancelPolicyDiscountCoupon';
  amount: Scalars['Int'];
  id: Scalars['Int'];
};

export type OrderCancelPolicyDomestic = OrderCancelPolicyCategory & {
  __typename?: 'OrderCancelPolicyDomestic';
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  cancelPolicies: ProductConfigCancelPolicies;
  cancelPolicy?: Maybe<CancelPolicy>;
  cancelPolicyId: Scalars['Int'];
  cancelable: Scalars['Boolean'];
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkOutAt: Scalars['String'];
  commissionAmount: Scalars['Int'];
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  nonCancellationReason?: Maybe<NonCancellationReason>;
  pendingStatus?: Maybe<PendingStatus>;
  pickupType?: Maybe<PickupType>;
  price: Scalars['Int'];
  property?: Maybe<ProductPropertyDomestic>;
  propertyCategory: PropertyCategory;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  propertyVersion?: Maybe<Scalars['Int']>;
  ratePlanId: Scalars['Int'];
  ratePlanTitle?: Maybe<Scalars['String']>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion?: Maybe<Scalars['Int']>;
  statusCode?: Maybe<Scalars['String']>;
  statusGroupCode?: Maybe<StatusGroupCode>;
  useType: DomesticAccommodationUseType;
  visitType: VisitType;
};

export type OrderCancelPolicyLeisureProduct = OrderCancelPolicyCategory & {
  __typename?: 'OrderCancelPolicyLeisureProduct';
  category: CategoryType;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<OrderCancelPolicyLeisureProductItem>;
};

export type OrderCancelPolicyLeisureProductItem = {
  __typename?: 'OrderCancelPolicyLeisureProductItem';
  cancelPolicy?: Maybe<CancelPolicy>;
  cancelable: Scalars['Boolean'];
  commissionAmount: Scalars['Int'];
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  id: Scalars['String'];
  nonCancellationReason?: Maybe<NonCancellationReason>;
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  price: Scalars['Int'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  time?: Maybe<Scalars['String']>;
  valid: OrderCancelPolicyLeisureValid;
  variant: LeisureProductVariant;
};

export type OrderCancelPolicyLeisureValid = {
  __typename?: 'OrderCancelPolicyLeisureValid';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type OrderCancelPolicyPayment = {
  __typename?: 'OrderCancelPolicyPayment';
  amount: Scalars['Int'];
  method: Scalars['String'];
  paymentMethod: YapaymentMethod;
  type: PaymentType;
};

export type OrderCancelPolicyTrain = OrderCancelPolicyCategory & {
  __typename?: 'OrderCancelPolicyTrain';
  category: CategoryType;
  createdAt: Scalars['String'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  tickets: Array<OrderCancelPolicyTrainTicket>;
};

export type OrderCancelPolicyTrainTicket = {
  __typename?: 'OrderCancelPolicyTrainTicket';
  adultFare: Scalars['Int'];
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  cancelPolicy?: Maybe<CancelPolicy>;
  cancelable: Scalars['Boolean'];
  carriageClassCode: Scalars['String'];
  child: Scalars['Int'];
  childFare: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  goodsReservationNo: Scalars['String'];
  id: Scalars['String'];
  nonCancellationReason?: Maybe<NonCancellationReason>;
  price: Scalars['Int'];
  runningDate: Scalars['String'];
  seats: Array<OrderCancelPolicyTrainTicketSeat>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type OrderCancelPolicyTrainTicketSeat = {
  __typename?: 'OrderCancelPolicyTrainTicketSeat';
  carriageNo: Scalars['String'];
  direction: CartTrainOrderTicketSeatDirection;
  seatDescription: Scalars['String'];
};

export type OrderCancelPrecheck = {
  __typename?: 'OrderCancelPrecheck';
  cancellable: Scalars['Boolean'];
};

export type OrderCancelPrecheckInput = {
  categoryOrders: Array<OrderCancelPrecheckInputCategoryOrder>;
};

export type OrderCancelPrecheckInputCategoryOrder = {
  id: Scalars['String'];
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  type: CategoryType;
};

export type OrderCancelPreview = {
  __typename?: 'OrderCancelPreview';
  additionalOrders?: Maybe<Array<OrderCancelPreviewAdditionalOrder>>;
  categoryOrders?: Maybe<Array<OrderCancelPreviewOrder>>;
  discount?: Maybe<OrderCancelPreviewCartDiscount>;
  id: Scalars['String'];
  payments?: Maybe<Array<OrderCancelPreviewPayment>>;
};

export type OrderCancelPreviewAdditionalOrder = {
  __typename?: 'OrderCancelPreviewAdditionalOrder';
  categoryOrders: Array<OrderCancelPreviewOrder>;
  discount?: Maybe<OrderCancelPreviewCartDiscount>;
  id: Scalars['String'];
  payments: Array<OrderCancelPreviewPayment>;
};

/** 장바구니 단위 할인 정보 */
export type OrderCancelPreviewCartDiscount = {
  __typename?: 'OrderCancelPreviewCartDiscount';
  package?: Maybe<OrderCancelPreviewCartTrainPackageDiscount>;
};

/** 장바구니 단위의 기차 묶음할인 정보 */
export type OrderCancelPreviewCartTrainPackageDiscount = {
  __typename?: 'OrderCancelPreviewCartTrainPackageDiscount';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
};

export type OrderCancelPreviewInput = {
  additionalOrders?: InputMaybe<Array<OrderCancelPreviewInputAdditionalOrder>>;
  categoryOrders: Array<OrderCancelPreviewInputCategoryOrder>;
  orderId: Scalars['String'];
};

export type OrderCancelPreviewInputAdditionalOrder = {
  categoryOrders: Array<OrderCancelPreviewInputCategoryOrder>;
  compositeOrderGuid: Scalars['String'];
};

export type OrderCancelPreviewInputCategoryOrder = {
  id: Scalars['String'];
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrderCancelPreviewOrder = {
  __typename?: 'OrderCancelPreviewOrder';
  category: CategoryType;
  discount?: Maybe<OrderCancelPreviewOrderDiscount>;
  id: Scalars['String'];
};

export type OrderCancelPreviewOrderDiscount = {
  __typename?: 'OrderCancelPreviewOrderDiscount';
  busDiscount?: Maybe<OrderCancelBusDiscount>;
  coupons?: Maybe<Array<OrderCancelPreviewOrderDiscountDetails>>;
  mobileMembership?: Maybe<OrderCancelPreviewOrderDiscountMobileMembership>;
};

export type OrderCancelPreviewOrderDiscountDetails = {
  __typename?: 'OrderCancelPreviewOrderDiscountDetails';
  commissionAmount: Scalars['Int'];
  coupon?: Maybe<DomesticAccommodationUserCoupon>;
  id: Scalars['Float'];
  refund: Scalars['Boolean'];
  userCoupon?: Maybe<CouponPlatformUserCoupon>;
};

export type OrderCancelPreviewOrderDiscountMobileMembership = {
  __typename?: 'OrderCancelPreviewOrderDiscountMobileMembership';
  commissionAmount: Scalars['Int'];
  refund: Scalars['Boolean'];
  type: MobileMembershipType;
};

export type OrderCancelPreviewPayment = {
  __typename?: 'OrderCancelPreviewPayment';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  method: Scalars['String'];
  paymentMethod: YapaymentMethod;
  type: PaymentType;
};

export type OrderCancelTrainOrder = {
  __typename?: 'OrderCancelTrainOrder';
  category: CategoryType;
  discount?: Maybe<OrderCancelTrainOrderDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  success: Scalars['Boolean'];
  tickets: Array<OrderCancelTrainOrderTicket>;
};

export type OrderCancelTrainOrderDiscount = {
  __typename?: 'OrderCancelTrainOrderDiscount';
  coupons: Array<OrderCancelCoupon>;
};

export type OrderCancelTrainOrderTicket = {
  __typename?: 'OrderCancelTrainOrderTicket';
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  child: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  id: Scalars['String'];
  seats: Array<OrderCancelTrainOrderTicketSeatType>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  success: Scalars['Boolean'];
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type OrderCancelTrainOrderTicketSeatType = {
  __typename?: 'OrderCancelTrainOrderTicketSeatType';
  carriageNo: Scalars['String'];
  direction: CartTrainOrderTicketSeatDirection;
  seatDescription: Scalars['String'];
};

export type OrderDetails = {
  __typename?: 'OrderDetails';
  additionalOrders: Array<AdditionalOrder>;
  /** 구매 당시 회원 등급 혜택 (order-coordinator 응답 pass-through, 필드 추가 이전 주문은 null) */
  benefitCode?: Maybe<MemberClassBenefitCode>;
  buyer: OrderDetailsBuyer;
  cancellations: Array<OrderDetailsCancellation>;
  categoryOrders: Array<OrderDetailsCategoryOrder>;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCartDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  payments: Array<OrderDetailsPayment>;
  /** 구매 적립 예정 NOL 포인트 총액 (order-coordinator 응답 pass-through) */
  totalRewardAmount?: Maybe<Scalars['Int']>;
  user: OrderDetailsUser;
};

export type OrderDetailsBus = OrderDetailsCategory & {
  __typename?: 'OrderDetailsBus';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  reservations: Array<OrderDetailsBusReservation>;
};

export type OrderDetailsBusCancellationBusDiscount = {
  __typename?: 'OrderDetailsBusCancellationBusDiscount';
  amount: Scalars['Int'];
  discountType: OrderDetailsCancellationBusDiscountType;
};

export type OrderDetailsBusReservation = {
  __typename?: 'OrderDetailsBusReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  boardingNo?: Maybe<Scalars['String']>;
  /**
   * 버스 등급
   * 1 : 우등
   * 2 : 고속
   * 3 : 심야 우등
   * 4 : 심야 고속
   * 5 : 일반
   * 6 : 심야 일반
   * 7 : 프리미엄
   * 8 : 심야 프리미엄
   */
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  /** 출발 시간(단 시간은 24시를 넘을 수 있음) */
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  routerReservationNo: Scalars['String'];
  tickets: Array<OrderDetailsBusReservationTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type OrderDetailsBusReservationTicket = {
  __typename?: 'OrderDetailsBusReservationTicket';
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  /** 검표 여부 */
  confirm: Scalars['Boolean'];
  /** 검표 일시 */
  confirmedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  price: Scalars['Int'];
  qrGenNo: Scalars['String'];
  routerTicketNo: Scalars['String'];
  seatNo: Scalars['Int'];
  status: OrderDetailsBusReservationTicketStatus;
  /**
   * 티켓 권종
   * 1 : 일반
   * 2 : 초등생
   * 8 : 대학생
   * 9 : 중고생
   */
  ticketType: Scalars['String'];
};

export enum OrderDetailsBusReservationTicketStatus {
  Canceled = 'CANCELED',
  Reserved = 'RESERVED'
}

export type OrderDetailsBuyer = {
  __typename?: 'OrderDetailsBuyer';
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type OrderDetailsCancellation = {
  __typename?: 'OrderDetailsCancellation';
  cancelCause: CancelCause;
  categoryOrders: Array<OrderDetailsCancellationCategory>;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCancellationDiscount>;
  itemCount: Scalars['Int'];
  payments: Array<OrderDetailsCancellationPayment>;
  reasonCode?: Maybe<Scalars['String']>;
  reasonCodeName?: Maybe<Scalars['String']>;
  reasonDetail?: Maybe<Scalars['String']>;
  representativeGoodsName: Scalars['String'];
  status: OrderDetailsCancellationStatus;
};

export type OrderDetailsCancellationBus = OrderDetailsCancellationCategoryOrder & {
  __typename?: 'OrderDetailsCancellationBus';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCancellationBusDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  reservations: Array<OrderDetailsCancellationBusReservation>;
};

export type OrderDetailsCancellationBusDiscount = {
  __typename?: 'OrderDetailsCancellationBusDiscount';
  busDiscount?: Maybe<OrderDetailsBusCancellationBusDiscount>;
  coupons: Array<OrderDetailsCancellationOrderDiscountCoupon>;
};

export enum OrderDetailsCancellationBusDiscountType {
  Group = 'GROUP',
  Prebook = 'PREBOOK',
  Roundtrip = 'ROUNDTRIP'
}

export type OrderDetailsCancellationBusReservation = {
  __typename?: 'OrderDetailsCancellationBusReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  boardingNo?: Maybe<Scalars['String']>;
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<OrderDetailsCancellationBusReservationTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type OrderDetailsCancellationBusReservationTicket = {
  __typename?: 'OrderDetailsCancellationBusReservationTicket';
  commissionAmount: Scalars['Int'];
  confirm: Scalars['Boolean'];
  confirmedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  price: Scalars['Int'];
  seatNo: Scalars['String'];
  status: OrderDetailsCancellationBusReservationTicketStatus;
  ticketType: Scalars['String'];
};

export enum OrderDetailsCancellationBusReservationTicketStatus {
  Canceled = 'CANCELED',
  Reserved = 'RESERVED'
}

export type OrderDetailsCancellationCategory = OrderDetailsCancellationBus | OrderDetailsCancellationDomestic | OrderDetailsCancellationLeisureProduct | OrderDetailsCancellationTrain;

export type OrderDetailsCancellationCategoryOrder = {
  category: CategoryType;
  id: Scalars['String'];
};

export type OrderDetailsCancellationDiscount = {
  __typename?: 'OrderDetailsCancellationDiscount';
  /** 총 쿠폰 할인 가격 및 수수료 */
  coupons?: Maybe<Array<OrderDetailsCancellationDiscountCoupon>>;
  /** 총 기차 묶음할인가격 및 수수료 */
  package?: Maybe<OrderDetailsCancellationTrainPackageDiscount>;
};

export type OrderDetailsCancellationDiscountCoupon = {
  __typename?: 'OrderDetailsCancellationDiscountCoupon';
  commissionAmount: Scalars['Int'];
  completedAt: Scalars['String'];
  coupon?: Maybe<DomesticAccommodationUserCoupon>;
  id: Scalars['Float'];
  refund: Scalars['Boolean'];
  requestedAt: Scalars['String'];
  userCoupon?: Maybe<CouponPlatformUserCoupon>;
};

export type OrderDetailsCancellationDomestic = OrderDetailsCancellationCategoryOrder & {
  __typename?: 'OrderDetailsCancellationDomestic';
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkOutAt: Scalars['String'];
  commissionAmount: Scalars['Int'];
  discount?: Maybe<OrderDetailsCancellationDomesticDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  isPenaltyAgree?: Maybe<Scalars['Boolean']>;
  memberClass?: Maybe<Scalars['String']>;
  memberClassDiscountRate?: Maybe<Scalars['Int']>;
  pickupType?: Maybe<PickupType>;
  price: Scalars['Int'];
  property?: Maybe<ProductPropertyDomestic>;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  propertyVersion?: Maybe<Scalars['Int']>;
  ratePlanTitle?: Maybe<Scalars['String']>;
  rewardAmount?: Maybe<Scalars['Int']>;
  rewardStatus?: Maybe<RewardStatusType>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion?: Maybe<Scalars['Int']>;
  statusCode: StatusCode;
  statusGroupCode: StatusGroupCode;
  useType: DomesticAccommodationUseType;
  visitType: VisitType;
};

export type OrderDetailsCancellationDomesticDiscount = {
  __typename?: 'OrderDetailsCancellationDomesticDiscount';
  coupons: Array<OrderDetailsCancellationOrderDiscountCoupon>;
  mobileMembership?: Maybe<OrderDetailsCancellationDomesticDiscountMobileMembership>;
};

export type OrderDetailsCancellationDomesticDiscountMobileMembership = {
  __typename?: 'OrderDetailsCancellationDomesticDiscountMobileMembership';
  commissionAmount: Scalars['Int'];
  refund: Scalars['Boolean'];
  type: MobileMembershipType;
};

export type OrderDetailsCancellationLeisureDiscount = {
  __typename?: 'OrderDetailsCancellationLeisureDiscount';
  coupons: Array<OrderDetailsCancellationOrderDiscountCoupon>;
};

export type OrderDetailsCancellationLeisureProduct = OrderDetailsCancellationCategoryOrder & {
  __typename?: 'OrderDetailsCancellationLeisureProduct';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCancellationLeisureDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<OrderDetailsCancellationLeisureProductItem>;
};

export type OrderDetailsCancellationLeisureProductItem = {
  __typename?: 'OrderDetailsCancellationLeisureProductItem';
  commissionAmount: Scalars['Int'];
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  id: Scalars['String'];
  memberClass?: Maybe<Scalars['String']>;
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  price: Scalars['Int'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  time?: Maybe<Scalars['String']>;
  valid: OrderDetailsLeisureValid;
  variant: LeisureProductVariant;
};

export type OrderDetailsCancellationOrderDiscountCoupon = {
  __typename?: 'OrderDetailsCancellationOrderDiscountCoupon';
  commissionAmount: Scalars['Int'];
  coupon?: Maybe<DomesticAccommodationUserCoupon>;
  id: Scalars['Float'];
  refund: Scalars['Boolean'];
  userCoupon?: Maybe<CouponPlatformUserCoupon>;
};

export type OrderDetailsCancellationPayment = {
  __typename?: 'OrderDetailsCancellationPayment';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  completedAt?: Maybe<Scalars['String']>;
  method: Scalars['String'];
  paymentMethod: YapaymentMethod;
  requestedAt?: Maybe<Scalars['String']>;
  type: PaymentType;
};

export enum OrderDetailsCancellationStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type OrderDetailsCancellationTrain = OrderDetailsCancellationCategoryOrder & {
  __typename?: 'OrderDetailsCancellationTrain';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsCancellationTrainDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  tickets: Array<OrderDetailsCancellationTrainTicket>;
};

export type OrderDetailsCancellationTrainDiscount = {
  __typename?: 'OrderDetailsCancellationTrainDiscount';
  coupons: Array<OrderDetailsCancellationOrderDiscountCoupon>;
};

export type OrderDetailsCancellationTrainPackageDiscount = {
  __typename?: 'OrderDetailsCancellationTrainPackageDiscount';
  amount: Scalars['Int'];
  commissionAmount: Scalars['Int'];
};

export type OrderDetailsCancellationTrainTicket = {
  __typename?: 'OrderDetailsCancellationTrainTicket';
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  child: Scalars['Int'];
  commissionAmount: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  id: Scalars['Int'];
  price: Scalars['Int'];
  seats?: Maybe<Array<Maybe<OrderDetailsTrainTicketSeats>>>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

/** 장바구니 단위 할인 정보 */
export type OrderDetailsCartDiscount = {
  __typename?: 'OrderDetailsCartDiscount';
  coupons?: Maybe<Array<OrderDetailsCoupon>>;
  package?: Maybe<OrderDetailsTrainPackageDiscount>;
};

export type OrderDetailsCategory = {
  category: CategoryType;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
};

export type OrderDetailsCategoryOrder = OrderDetailsBus | OrderDetailsDomestic | OrderDetailsLeisureProduct | OrderDetailsTrain;

export type OrderDetailsCoupon = {
  __typename?: 'OrderDetailsCoupon';
  amount: Scalars['Int'];
  coupon?: Maybe<DomesticAccommodationUserCoupon>;
  /**
   * 국내숙소: required
   * 그 외 카테고리: optional
   */
  couponType?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  userCoupon?: Maybe<CouponPlatformUserCoupon>;
};

/** 카테고리 단위 할인 정보 */
export type OrderDetailsDiscount = {
  __typename?: 'OrderDetailsDiscount';
  busDiscount?: Maybe<OrderDetailsDiscountBusDiscount>;
  coupons: Array<OrderDetailsCoupon>;
};

export type OrderDetailsDiscountBusDiscount = {
  __typename?: 'OrderDetailsDiscountBusDiscount';
  amount: Scalars['Int'];
  discountType: OrderDetailsDiscountBusDiscountType;
};

export enum OrderDetailsDiscountBusDiscountType {
  Group = 'GROUP',
  Prebook = 'PREBOOK',
  Roundtrip = 'ROUNDTRIP'
}

export type OrderDetailsDomestic = OrderDetailsCategory & {
  __typename?: 'OrderDetailsDomestic';
  adults: Scalars['Int'];
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  cancelPolicyId: Scalars['Int'];
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  canceledAt?: Maybe<Scalars['String']>;
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childrenAges?: Maybe<Array<Scalars['Int']>>;
  createdAt: Scalars['String'];
  dailyPrices?: Maybe<Array<DomesticDailyPrices>>;
  discount?: Maybe<OrderDetailsDomesticDiscount>;
  displayBadge: MemberClassBadgeType;
  hasPartialCancel: Scalars['Boolean'];
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  isPenaltyAgree?: Maybe<Scalars['Boolean']>;
  memberClass?: Maybe<Scalars['String']>;
  memberClassDiscountRate?: Maybe<Scalars['Int']>;
  nolChat?: Maybe<NolChatResponse>;
  orderId: Scalars['String'];
  originalPrice?: Maybe<Scalars['Int']>;
  pendingStatus?: Maybe<PendingStatus>;
  pickupType: PickupType;
  price: Scalars['Int'];
  productConfig: ProductConfigProperty;
  property?: Maybe<ProductPropertyDomestic>;
  propertyCategory: PropertyCategory;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  propertyVersion?: Maybe<Scalars['Int']>;
  ratePlan: OrderDetailsDomesticRatePlan;
  ratePlanConfig?: Maybe<RatePlanConfig>;
  ratePlanDescription?: Maybe<Scalars['String']>;
  ratePlanId?: Maybe<Scalars['Int']>;
  ratePlanTitle?: Maybe<Scalars['String']>;
  ratePlanVersion?: Maybe<Scalars['Int']>;
  reserveType?: Maybe<ReserveType>;
  reviewWritableV2?: Maybe<ReviewWritableResponseV2>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion: Scalars['Int'];
  statusCode: StatusCode;
  statusGroupCode: StatusGroupCode;
  useType: DomesticAccommodationUseType;
  virtualPhoneNum?: Maybe<Scalars['String']>;
  visitType: VisitType;
};

export type OrderDetailsDomesticDiscount = {
  __typename?: 'OrderDetailsDomesticDiscount';
  coupons: Array<OrderDetailsCoupon>;
  mobileMembership?: Maybe<OrderDetailsMobileMembership>;
};

export type OrderDetailsDomesticRatePlan = {
  __typename?: 'OrderDetailsDomesticRatePlan';
  isExceptionalCancelPolicy: Scalars['Boolean'];
};

export type OrderDetailsLeisureProduct = OrderDetailsCategory & {
  __typename?: 'OrderDetailsLeisureProduct';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsDiscount>;
  displayBadge: MemberClassBadgeType;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<OrderDetailsLeisureProductItem>;
  orderId: Scalars['String'];
  reviewWritableV2?: Maybe<ReviewWritableResponseV2>;
};

export type OrderDetailsLeisureProductItem = {
  __typename?: 'OrderDetailsLeisureProductItem';
  cancelCompletedAt?: Maybe<Scalars['String']>;
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  cancelRequestedAt?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  encryptedVoucherData: Scalars['String'];
  id: Scalars['String'];
  memberClass?: Maybe<Scalars['String']>;
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  orderId: Scalars['String'];
  price: Scalars['Int'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  time?: Maybe<Scalars['String']>;
  valid: OrderDetailsLeisureValid;
  variant: LeisureProductVariant;
  voucher?: Maybe<CartLeisureProductOrderItemVoucher>;
};

export type OrderDetailsLeisureValid = {
  __typename?: 'OrderDetailsLeisureValid';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type OrderDetailsMobileMembership = {
  __typename?: 'OrderDetailsMobileMembership';
  amount: Scalars['Int'];
  type: MobileMembershipType;
};

export type OrderDetailsPayment = {
  __typename?: 'OrderDetailsPayment';
  amount: Scalars['Int'];
  method: Scalars['String'];
  paymentMethod: YapaymentMethod;
  type: PaymentType;
};

export type OrderDetailsTrain = OrderDetailsCategory & {
  __typename?: 'OrderDetailsTrain';
  category: CategoryType;
  createdAt: Scalars['String'];
  discount?: Maybe<OrderDetailsDiscount>;
  hashOrderId: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  tickets: Array<OrderDetailsTrainTicket>;
};

export type OrderDetailsTrainCoupon = {
  __typename?: 'OrderDetailsTrainCoupon';
  amount: Scalars['Int'];
  id: Scalars['Int'];
};

/** 기차 묶음 할인 */
export type OrderDetailsTrainPackageDiscount = {
  __typename?: 'OrderDetailsTrainPackageDiscount';
  /** 묶음 할인 가격 */
  amount: Scalars['Int'];
};

export type OrderDetailsTrainTicket = {
  __typename?: 'OrderDetailsTrainTicket';
  adultFare: Scalars['Int'];
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  cancelCompletedAt?: Maybe<Scalars['String']>;
  cancelPolicySummary?: Maybe<CancelPolicySummary>;
  cancelRequestedAt?: Maybe<Scalars['String']>;
  carriageClassCode: Scalars['String'];
  child: Scalars['Int'];
  childFare: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  goodsReservationNo: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Int'];
  runningDate?: Maybe<Scalars['String']>;
  seats: Array<OrderDetailsTrainTicketSeats>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type OrderDetailsTrainTicketSeats = {
  __typename?: 'OrderDetailsTrainTicketSeats';
  carriageNo: Scalars['String'];
  direction: CartTrainOrderTicketSeatDirection;
  seatDescription: Scalars['String'];
};

export type OrderDetailsUser = {
  __typename?: 'OrderDetailsUser';
  birthDate?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type OrderList = {
  __typename?: 'OrderList';
  orders: Array<CartOrders>;
  page: Scalars['Int'];
  size: Scalars['Int'];
  total: Scalars['Int'];
};

/** 결제 수단 조회 v4 */
export type OrderPaymentPolicy = {
  __typename?: 'OrderPaymentPolicy';
  paymentNotice: YapaymentPaymentNotice;
  paymentPolicies: Array<PaymentPolicy>;
  paymentPolicySeq: Scalars['Int'];
  promotions?: Maybe<PaymentPromotion>;
};

export type OrdersInput = {
  categoryGroup: CategoryGroupType;
  from: Scalars['String'];
  page: Scalars['Int'];
  size: Scalars['Int'];
  to: Scalars['String'];
};

export type OverviewLang = {
  __typename?: 'OverviewLang';
  en?: Maybe<Scalars['String']>;
  zhcn?: Maybe<Scalars['String']>;
};

export type PaymentMainPromotion = {
  __typename?: 'PaymentMainPromotion';
  imageUrl: Scalars['String'];
};

export type PaymentMethodPromotion = {
  __typename?: 'PaymentMethodPromotion';
  content: PaymentMethodPromotionContent;
  paymentMethodCode: Scalars['String'];
};

export type PaymentMethodPromotionContent = {
  __typename?: 'PaymentMethodPromotionContent';
  body: Scalars['String'];
  title: Scalars['String'];
};

export type PaymentNotice = {
  __typename?: 'PaymentNotice';
  content: Scalars['String'];
  title: Scalars['String'];
};

export type PaymentPolicy = {
  __typename?: 'PaymentPolicy';
  code: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  maxPayableAmount: Scalars['Int'];
  minPayableAmount: Scalars['Int'];
  name: Scalars['String'];
  notice?: Maybe<Scalars['String']>;
  sortNo: Scalars['Int'];
};

export type PaymentPromotion = {
  __typename?: 'PaymentPromotion';
  mainBannerPromotion?: Maybe<PaymentMainPromotion>;
  paymentMethodPromotions: Array<PaymentMethodPromotion>;
};

export enum PaymentType {
  CjOnePoint = 'CJ_ONE_POINT',
  NolPoint = 'NOL_POINT',
  PaymentDiscount = 'PAYMENT_DISCOUNT',
  Pg = 'PG',
  Point = 'POINT'
}

/** 대기 예약 상태 */
export enum PendingStatus {
  /** 대기예약 확정 */
  Confirm = 'CONFIRM',
  /** 대기예약 아님 */
  None = 'NONE',
  /** 대기 중 */
  Pending = 'PENDING'
}

export type PgReceiptInfo = {
  __typename?: 'PgReceiptInfo';
  guide?: Maybe<Scalars['String']>;
  receiptUrl: Scalars['String'];
};

export type Photos = {
  __typename?: 'Photos';
  category: Scalars['String'];
  legacy?: Maybe<Scalars['Boolean']>;
  url: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export enum PickupType {
  MartPickup = 'MART_PICKUP',
  NotProvided = 'NOT_PROVIDED',
  Pickup = 'PICKUP'
}

export type PlaceMetaCouponsPayload = {
  metaCouponId: Scalars['Float'];
  requests: Array<PlaceMetaCouponsPayloadRequest>;
};

export type PlaceMetaCouponsPayloadRequest = {
  checkInDate: Scalars['String'];
  placeId: Scalars['Int'];
  rentType: PlaceMetaCouponsPayloadRequestRentType;
  requestCount: Scalars['Int'];
};

export enum PlaceMetaCouponsPayloadRequestRentType {
  Days = 'DAYS',
  Rest = 'REST',
  Sleep = 'SLEEP'
}

export enum PointAssetType {
  Cash = 'CASH',
  Coin = 'COIN',
  Point = 'POINT'
}

export enum PointAssociationLevel {
  Formal = 'FORMAL',
  None = 'NONE',
  Semi = 'SEMI'
}

export type PointEvent = {
  __typename?: 'PointEvent';
  code: Scalars['String'];
  rewardRate: Scalars['Float'];
};

export type PointItemPolicy = {
  __typename?: 'PointItemPolicy';
  assetType: PointAssetType;
  itemType: PointItemType;
  rewardAmount: Scalars['Int'];
  rewardRate: Scalars['Float'];
  type: PointPolicyType;
};

export enum PointItemType {
  Bus = 'BUS',
  Leisure = 'LEISURE',
  Property = 'PROPERTY',
  Review = 'REVIEW',
  Train = 'TRAIN'
}

export type PointLeisurePolicyInput = {
  date?: InputMaybe<Scalars['String']>;
  pgAmount: Scalars['Int'];
};

export enum PointPlaceType {
  Camping = 'CAMPING',
  GuestHouse = 'GUEST_HOUSE',
  Hotel = 'HOTEL',
  Motel = 'MOTEL',
  Pension = 'PENSION',
  Resort = 'RESORT'
}

export enum PointPolicyType {
  Event = 'EVENT',
  Reward = 'REWARD'
}

export type PointPropertyPolicyInput = {
  associateLevel: Scalars['String'];
  checkInDate: Scalars['String'];
  pgAmount: Scalars['Int'];
  placeType: Scalars['String'];
  published: Scalars['Boolean'];
  reservationAt: Scalars['String'];
};

export type PointServicePolicy = {
  __typename?: 'PointServicePolicy';
  assetType: Scalars['String'];
  code: Scalars['String'];
  events: Array<Maybe<PointEvent>>;
  maxPoint?: Maybe<Scalars['Int']>;
  minPrice?: Maybe<Scalars['Int']>;
  rewardRate: Scalars['Float'];
  type: Scalars['String'];
};

export type PointTotal = {
  __typename?: 'PointTotal';
  isSuccess: Scalars['Boolean'];
  point: Scalars['Int'];
};

export type PointTrainPolicyInput = {
  date?: InputMaybe<Scalars['String']>;
  pgAmount: Scalars['Int'];
};

export type ProductConfigCancelPolicies = {
  __typename?: 'ProductConfigCancelPolicies';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  method: CancelPolicyMethod;
  name?: Maybe<Scalars['String']>;
  policies: Array<ProductConfigCancelPoliciesPolicy>;
  updatedAt: Scalars['String'];
};

export type ProductConfigCancelPoliciesPolicy = {
  __typename?: 'ProductConfigCancelPoliciesPolicy';
  criteria: CancelPolicyCreteria;
  endDays: Scalars['Int'];
  endOffset: Scalars['Int'];
  endTime: Scalars['String'];
  ratio?: Maybe<Scalars['Int']>;
  startDays?: Maybe<Scalars['Int']>;
  startOffset?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
};

export type ProductConfigParking = {
  __typename?: 'ProductConfigParking';
  date?: Maybe<Scalars['String']>;
  /** 만차여부 */
  full: Scalars['Boolean'];
};

export enum ProductConfigParkingType {
  /** 주차장 없음 */
  NoParkingLot = 'NO_PARKING_LOT',
  /** 주차 가능 */
  ParkingAvailable = 'PARKING_AVAILABLE',
  /** 도보 전용 (주차장은 있을 수 있음) */
  WalkingOnly = 'WALKING_ONLY'
}

export type ProductConfigProperty = {
  __typename?: 'ProductConfigProperty';
  badges?: Maybe<Array<Scalars['String']>>;
  banners?: Maybe<Array<Scalars['String']>>;
  control: ProductConfigPropertyControl;
  parking?: Maybe<ProductConfigParking>;
  promotions?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type ProductConfigPropertyControl = {
  __typename?: 'ProductConfigPropertyControl';
  globalSales: Scalars['Boolean'];
  parking: Scalars['Boolean'];
  ratePlan: Scalars['Boolean'];
  reservation: Scalars['Boolean'];
  selfCheckIn: Scalars['Boolean'];
};

export type ProductConfigRoomType = {
  __typename?: 'ProductConfigRoomType';
  badges?: Maybe<Array<Scalars['String']>>;
  banners?: Maybe<Array<Scalars['String']>>;
  control: ProductConfigRoomTypeControl;
  parking?: Maybe<ProductConfigParking>;
  promotions?: Maybe<Array<Scalars['String']>>;
};

export type ProductConfigRoomTypeControl = {
  __typename?: 'ProductConfigRoomTypeControl';
  adultAuth: Scalars['Boolean'];
  globalSales: Scalars['Boolean'];
  login: Scalars['Boolean'];
  mustNotCancel: Scalars['Boolean'];
  parking: ProductConfigParkingType;
  reservation: Scalars['Boolean'];
};

export type ProductPropertyDomestic = {
  __typename?: 'ProductPropertyDomestic';
  config?: Maybe<ProductConfigProperty>;
  confirmedReservation: Scalars['Boolean'];
  data: PropertyData;
  id: Scalars['Int'];
  isRatePlan: Scalars['Boolean'];
  published: Scalars['Boolean'];
  ratePlan: ProductPropertyDomesticRatePlan;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypes: Array<ProductPropertyRoomTypeDomestic>;
  updatedAt: Scalars['String'];
  version: Scalars['Int'];
};


export type ProductPropertyDomesticConfigArgs = {
  checkInDate?: InputMaybe<Scalars['String']>;
};


export type ProductPropertyDomesticConfirmedReservationArgs = {
  ratePlanId?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type ProductPropertyDomesticRatePlanArgs = {
  params: RatePlanInventoryInput;
  ratePlanId?: InputMaybe<Scalars['Int']>;
  roomTypeId?: InputMaybe<Scalars['Int']>;
  useTypeInput: UseTypeInput;
  version?: InputMaybe<Scalars['Int']>;
};


export type ProductPropertyDomesticRoomTypeArgs = {
  roomTypeId?: InputMaybe<Scalars['Int']>;
  roomTypeVesrsion?: InputMaybe<Scalars['Int']>;
};

export type ProductPropertyDomesticRatePlan = {
  __typename?: 'ProductPropertyDomesticRatePlan';
  benefitList: Array<DomesticRatePlanBenefits>;
  cancelPolicy?: Maybe<Scalars['Int']>;
  channelId?: Maybe<Scalars['Int']>;
  checkInTime?: Maybe<Scalars['String']>;
  checkOutTime?: Maybe<Scalars['String']>;
  config: RatePlanConfig;
  dates: Array<RatePlanDate>;
  discountRate?: Maybe<Scalars['Int']>;
  memberClass?: Maybe<Scalars['String']>;
  originalRatePlanId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  ratePlanId: Scalars['Int'];
  ratePlanVersion?: Maybe<Scalars['Int']>;
  sharedRatePlans: Array<SharedRatePlan>;
  title: Scalars['String'];
  totalOriginalRate: Scalars['Int'];
};

export type ProductPropertyRoomTypeDomestic = {
  __typename?: 'ProductPropertyRoomTypeDomestic';
  additionalOneCoupons: Array<CouponDomesticInstanceV2>;
  additionalTwoCoupons: Array<CouponDomesticInstanceV2>;
  config?: Maybe<ProductConfigRoomType>;
  coupons: Array<CouponDomesticInstanceV2>;
  data: RoomTypeData;
  id: Scalars['Int'];
  property?: Maybe<ProductPropertyDomestic>;
  propertyId: Scalars['Int'];
  published?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


export type ProductPropertyRoomTypeDomesticConfigArgs = {
  checkInDate?: InputMaybe<Scalars['String']>;
};

export enum ProductTypeCode {
  Gifticon = 'GIFTICON',
  Leisure = 'LEISURE',
  Rentcar = 'RENTCAR'
}

export type Progress = {
  __typename?: 'Progress';
  DAYS?: Maybe<Days>;
  REST?: Maybe<Rest>;
  SLEEP?: Maybe<Sleep>;
};

export type PropertyBreakfast = {
  __typename?: 'PropertyBreakfast';
  name: Scalars['String'];
};

export enum PropertyCategory {
  Camping = 'CAMPING',
  GuestHouse = 'GUEST_HOUSE',
  Hotel = 'HOTEL',
  Motel = 'MOTEL',
  Pension = 'PENSION'
}

export type PropertyCoupon = {
  __typename?: 'PropertyCoupon';
  applicableMinPrice?: Maybe<Scalars['Int']>;
  checkin_finished_at?: Maybe<Scalars['String']>;
  checkin_started_at?: Maybe<Scalars['String']>;
  couponIdx: Scalars['Float'];
  couponName?: Maybe<Scalars['String']>;
  couponType: Scalars['Int'];
  maxPrice?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['Int']>;
  notice?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  priceType: Scalars['String'];
  product?: Maybe<Scalars['String']>;
  provideCondition?: Maybe<Scalars['String']>;
  roomType?: Maybe<Scalars['String']>;
  stayTypeConfigs?: Maybe<Array<Maybe<StayTypeConfigs>>>;
  supplyStatus?: Maybe<Scalars['String']>;
  usableRoomType: Scalars['String'];
  useInAdvance?: Maybe<Scalars['Int']>;
  useType?: Maybe<Scalars['Int']>;
  week: Week;
};

export type PropertyCouponCheckProgress = {
  __typename?: 'PropertyCouponCheckProgress';
  metaCouponId: Scalars['Float'];
  placeIds: Array<Scalars['Int']>;
  title: Scalars['String'];
  usable: Scalars['Boolean'];
};

export type PropertyCouponCheckProgressInput = {
  checkProgressPayload: Array<PlaceMetaCouponsPayload>;
};

export type PropertyCouponsProgress = {
  __typename?: 'PropertyCouponsProgress';
  metas: Array<PropertyCouponsProgressMeta>;
  placeNo: Scalars['Int'];
};

export type PropertyCouponsProgressMeta = {
  __typename?: 'PropertyCouponsProgressMeta';
  id?: Maybe<Scalars['Float']>;
  progress: Progress;
};

export type PropertyCouponsResponse = {
  __typename?: 'PropertyCouponsResponse';
  list?: Maybe<Array<PropertyCoupon>>;
  maxDcPrice?: Maybe<Scalars['Int']>;
  maxDcPriceType?: Maybe<Scalars['String']>;
  totalCnt?: Maybe<Scalars['Int']>;
};

export type PropertyData = {
  __typename?: 'PropertyData';
  address?: Maybe<Scalars['String']>;
  addressLang?: Maybe<AddressLang>;
  affiliation?: Maybe<Affiliation>;
  agePolicy?: Maybe<AgePolicy>;
  breakfasts?: Maybe<Array<PropertyBreakfast>>;
  category: PropertyCategory;
  channelId?: Maybe<Scalars['Int']>;
  coordinate?: Maybe<Coordinate>;
  createdAt?: Maybe<Scalars['String']>;
  customerServicePhone?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Descriptions>;
  id: Scalars['Int'];
  isTest?: Maybe<Scalars['Boolean']>;
  managements?: Maybe<Array<Maybe<Managements>>>;
  name?: Maybe<Scalars['String']>;
  nameLang?: Maybe<NameLang>;
  notices?: Maybe<Notices>;
  phone?: Maybe<Scalars['String']>;
  photos: Array<Photos>;
  postalCode?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  reservationPolicy?: Maybe<ReservationPolicy>;
  routerId?: Maybe<Scalars['String']>;
  star?: Maybe<StarInfo>;
  status?: Maybe<Scalars['String']>;
  subCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  surcharges?: Maybe<Array<Maybe<Scalars['String']>>>;
  themes?: Maybe<Array<Themes>>;
  themesImages?: Maybe<Array<ContentThemes>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** 구매 옵션 유형 코드 */
export enum PurchaseOptionTypeCode {
  /** 조합형 */
  Combination = 'COMBINATION',
  /** 단일선택형 */
  Mono = 'MONO',
  /** 예약-회차형 */
  Round = 'ROUND',
  /** 예약-날짜형 */
  Schedule = 'SCHEDULE'
}

export type QrCode = {
  __typename?: 'QrCode';
  qrInfo: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  benefitBanner: BannerResponse;
  busCancelPolicyPreview?: Maybe<BusCancelPreview>;
  busDetail: Array<BusDetail>;
  busTransportationCompany?: Maybe<BusTransportationCompany>;
  cartItemV2: ICartSingleItem;
  cartItemsV3: Array<ICartItem>;
  cartPropertyDomesticRentTimeLines: CartPropertyDomesticRentTimeLines;
  cartSingleItems: Array<ICartSingleItem>;
  contentThemes?: Maybe<ContentThemes>;
  couponDomesticInstance: Array<CouponDomesticInstance>;
  couponDomesticInstanceV2: Array<CouponDomesticInstanceV2>;
  couponMeta?: Maybe<CouponMetadata>;
  couponPlatformInstance: Array<CouponPlatformInstance>;
  couponPlatformInstanceV2: Array<CouponPlatformInstanceV2>;
  distributionPreview?: Maybe<DistributionPreview>;
  domesticPropertySearch: DomesticPropertySearch;
  findVisitorAgree: VisitorFindAgreeData;
  isLoginUser: Scalars['Boolean'];
  isNolCardFirstPayPromotion: Scalars['Boolean'];
  latestAppConfig: Scalars['JSON'];
  leisureProduct: LeisureProduct;
  leisureProductVariant: LeisureProductVariant;
  leisureSearch: LeisureSearch;
  memberClass: Array<MemberClassItem>;
  memberClassCode: Scalars['String'];
  memberGatewayAskCi?: Maybe<MemberGatewayCiData>;
  memberGatewayMembership?: Maybe<MemberGatewayMembership>;
  memberInfoByCache: MemberInfo;
  nolPointTotal: PointTotal;
  orderCancelPolicyV3: OrderCancelPolicy;
  orderCancelPreviewV2: OrderCancelPreview;
  orderDetailsV3: OrderDetails;
  orderListV3: OrderList;
  orderPaymentPolicy: OrderPaymentPolicy;
  paymentHistoryApproval: YapaymentHistoryApproval;
  pgReceiptInfo: PgReceiptInfo;
  ping: Scalars['Boolean'];
  pointAllPolicies: Array<PointItemPolicy>;
  pointTotal: PointTotal;
  productConfig: ProductConfigProperty;
  productConfigCancelPolicies: ProductConfigCancelPolicies;
  productConfigCancelPoliciesCheck?: Maybe<ProductConfigCancelPolicies>;
  property: ProductPropertyDomestic;
  propertyRoomTypeRatePlanForTest?: Maybe<AvailableInventoryRatePlanResponse>;
  propertyRoomTypeStock: SingleStock;
  propertyRoomTypesStock: Stock;
  qrCode: QrCode;
  reservation: ReservationDetail;
  reservationRentStock: ReservationStockRentType;
  reservations: Array<Reservation>;
  reviewPolicy: Array<PointServicePolicy>;
  roomType: ProductPropertyRoomTypeDomestic;
  serverCurrentAt: Scalars['String'];
  sharedOrder: SharedOrder;
  trainStations: Array<TrainStation>;
  transportationSearchCarriageSeats: Array<TransportationSearchSeat>;
  transportationSearchCarriages: Array<TransportationSearchCarriage>;
  transportationSearchFares: Array<TransportationSearchFare>;
  transportationSearchPackageFares: Array<TransportationSearchPackageFare>;
  transportationSearchTrains: Array<TransportationSearchTrain>;
  transportationSearchs: Array<TransportationSearch>;
  validateOrderSheetMemberClass: ValidateOrderSheetMemberClassResponse;
  validateViewerPhone: Scalars['String'];
  validateVisitorPhone: Scalars['Boolean'];
  verifyAdditionalPurchase?: Maybe<LeisureAdditionalPurchaseVerification>;
  viewer: Viewer;
  vigToken: Scalars['String'];
  yapaymentMethod: Array<YapaymentMethod>;
  yapaymentPaymentPolicy: YapaymentPaymentPolicy;
};


export type QueryBenefitBannerArgs = {
  target: Scalars['String'];
};


export type QueryBusCancelPolicyPreviewArgs = {
  params: Array<BusCancelPreviewInput>;
};


export type QueryBusDetailArgs = {
  params: Array<BusDetailInput>;
};


export type QueryBusTransportationCompanyArgs = {
  code: Scalars['String'];
  isDisabledReplaceCorp?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCartItemV2Args = {
  optionId: Scalars['String'];
};


export type QueryCartPropertyDomesticRentTimeLinesArgs = {
  params: CartPropertyDomesticRentTimeLinesParams;
};


export type QueryCartSingleItemsArgs = {
  input: Array<CartSingleItemParam>;
};


export type QueryContentThemesArgs = {
  codes: Array<Scalars['Int']>;
};


export type QueryCouponDomesticInstanceArgs = {
  input: CouponDomesticInstanceInput;
};


export type QueryCouponDomesticInstanceV2Args = {
  input: CouponDomesticInstanceV2Input;
};


export type QueryCouponMetaArgs = {
  couponId: Scalars['Float'];
};


export type QueryCouponPlatformInstanceArgs = {
  input: CouponPlatformInstanceInput;
};


export type QueryCouponPlatformInstanceV2Args = {
  input: CouponPlatformInstanceInput;
};


export type QueryDistributionPreviewArgs = {
  input: DistributionPreviewInput;
};


export type QueryDomesticPropertySearchArgs = {
  checkinDate?: InputMaybe<Scalars['String']>;
  checkoutDate?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
};


export type QueryFindVisitorAgreeArgs = {
  phone: Scalars['String'];
};


export type QueryLatestAppConfigArgs = {
  appConfigKey?: InputMaybe<Scalars['String']>;
};


export type QueryLeisureProductArgs = {
  id: Scalars['Float'];
  productVersion?: InputMaybe<Scalars['Int']>;
};


export type QueryLeisureProductVariantArgs = {
  input: LeisureProductVariantInput;
};


export type QueryLeisureSearchArgs = {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMemberGatewayAskCiArgs = {
  tk: Scalars['String'];
};


export type QueryMemberGatewayMembershipArgs = {
  option: MemberGatewayMembershipAffiliation;
};


export type QueryOrderCancelPolicyV3Args = {
  orderId: Scalars['String'];
};


export type QueryOrderCancelPreviewV2Args = {
  param: OrderCancelPreviewInput;
};


export type QueryOrderDetailsV3Args = {
  orderId: Scalars['String'];
};


export type QueryOrderListV3Args = {
  params: OrdersInput;
};


export type QueryOrderPaymentPolicyArgs = {
  input: YapaymentPaymentPolicyInput;
};


export type QueryPaymentHistoryApprovalArgs = {
  orderId: Scalars['String'];
};


export type QueryPgReceiptInfoArgs = {
  orderId: Scalars['String'];
  tenancyCode: Scalars['String'];
};


export type QueryPointAllPoliciesArgs = {
  buses?: InputMaybe<Array<PointTrainPolicyInput>>;
  leisures?: InputMaybe<Array<PointLeisurePolicyInput>>;
  properties?: InputMaybe<Array<PointPropertyPolicyInput>>;
  trains?: InputMaybe<Array<PointTrainPolicyInput>>;
};


export type QueryProductConfigArgs = {
  checkInDate?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['Int'];
};


export type QueryProductConfigCancelPoliciesArgs = {
  id: Scalars['Int'];
};


export type QueryProductConfigCancelPoliciesCheckArgs = {
  checkInDate: Scalars['String'];
  checkOutDate: Scalars['String'];
  propertyId: Scalars['Int'];
};


export type QueryPropertyArgs = {
  propertyId: Scalars['Int'];
  propertyVersion?: InputMaybe<Scalars['Int']>;
};


export type QueryPropertyRoomTypeRatePlanForTestArgs = {
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  roomTypeId: Scalars['Int'];
};


export type QueryPropertyRoomTypeStockArgs = {
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  propertyId: Scalars['Int'];
  roomTypeId: Scalars['Int'];
};


export type QueryPropertyRoomTypesStockArgs = {
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  propertyId: Scalars['Int'];
};


export type QueryQrCodeArgs = {
  phoneNo: Scalars['String'];
  reservationNo: Scalars['String'];
};


export type QueryReservationArgs = {
  reservationNo: Scalars['String'];
};


export type QueryReservationRentStockArgs = {
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  propertyId: Scalars['Int'];
  roomTypeId: Scalars['Int'];
};


export type QueryRoomTypeArgs = {
  roomTypeId: Scalars['Int'];
  roomTypeVersion?: InputMaybe<Scalars['Int']>;
};


export type QuerySharedOrderArgs = {
  uuid: Scalars['String'];
};


export type QueryTransportationSearchCarriageSeatsArgs = {
  params: TransportationSearchCarriageSeatInput;
};


export type QueryTransportationSearchCarriagesArgs = {
  params: TransportationSearchCarriageInput;
};


export type QueryTransportationSearchFaresArgs = {
  params: TransportationSearchFareInput;
};


export type QueryTransportationSearchPackageFaresArgs = {
  params: TransportationSearchPackageFareInput;
};


export type QueryTransportationSearchTrainsArgs = {
  params: TransportationSearchTrainsInput;
};


export type QueryTransportationSearchsArgs = {
  inputs: Array<TransportationSearchInput>;
};


export type QueryValidateOrderSheetMemberClassArgs = {
  properties: Array<ValidatePropertyInput>;
};


export type QueryValidateVisitorPhoneArgs = {
  phoneNumber: Scalars['String'];
};


export type QueryVerifyAdditionalPurchaseArgs = {
  orderGroupId: Scalars['String'];
  productId: Scalars['Int'];
};


export type QueryYapaymentMethodArgs = {
  paymentMethodCode?: InputMaybe<Scalars['String']>;
};


export type QueryYapaymentPaymentPolicyArgs = {
  input: YapaymentPaymentPolicyInput;
};

export type RatePlan = {
  __typename?: 'RatePlan';
  adsList?: Maybe<Array<Scalars['Int']>>;
  availability: RatePlanAvailability;
  averageRackRate?: Maybe<Scalars['Int']>;
  averageRate?: Maybe<Scalars['Int']>;
  cancelPolicy?: Maybe<Scalars['Int']>;
  checkInTime?: Maybe<Scalars['String']>;
  checkOutTime?: Maybe<Scalars['String']>;
  dates: Array<RatePlanDate>;
  invalidReason?: Maybe<RatePlanInvalidReason>;
  minUseTime?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  ratePlanId: Scalars['Int'];
  ratePlanVersion: Scalars['Int'];
  reservableQuantity?: Maybe<Scalars['Int']>;
  roomTypeId: Scalars['Int'];
  totalRackRate?: Maybe<Scalars['Int']>;
  totalRate?: Maybe<Scalars['Int']>;
  useTime?: Maybe<Scalars['Int']>;
  useType: RatePlanUseType;
};

export enum RatePlanAvailability {
  Invalid = 'INVALID',
  Valid = 'VALID'
}

export type RatePlanConfig = {
  __typename?: 'RatePlanConfig';
  /** 뱃지 표시 */
  badges?: Maybe<Array<Scalars['String']>>;
  /** 주차설정 */
  control: RatePlanConfigControl;
  /** 만차정보 */
  parking?: Maybe<ProductConfigParking>;
  /** 프로모션 대상 */
  promotions?: Maybe<Array<Scalars['String']>>;
};

export type RatePlanConfigControl = {
  __typename?: 'RatePlanConfigControl';
  parking: ProductConfigParkingType;
};

export type RatePlanDataRequest = {
  __typename?: 'RatePlanDataRequest';
  baseDate: Scalars['String'];
  baseTime: Scalars['String'];
  checkInDate: Scalars['String'];
  checkInTime?: Maybe<Scalars['String']>;
  checkOutDate: Scalars['String'];
  perDate: Scalars['String'];
  persons: RatePlanDataRequestPersons;
  surcharges: Array<Scalars['Int']>;
  useType: Scalars['String'];
};

export type RatePlanDataRequestPersons = {
  __typename?: 'RatePlanDataRequestPersons';
  adultPax: Scalars['Int'];
  childrentAges: Array<Scalars['Int']>;
};

export type RatePlanDate = {
  __typename?: 'RatePlanDate';
  date: Scalars['String'];
  extraPersonRate: Scalars['Int'];
  otherSettings?: Maybe<RatePlanDateOtherSetting>;
  rackRate: Scalars['Int'];
  rate: Scalars['Int'];
};

export type RatePlanDateOtherSetting = {
  __typename?: 'RatePlanDateOtherSetting';
  depositPrice?: Maybe<Scalars['Int']>;
};

export enum RatePlanInvalidReason {
  AbnormalRate = 'ABNORMAL_RATE',
  EmptyStock = 'EMPTY_STOCK',
  InvalidNights = 'INVALID_NIGHTS',
  InvalidReservationPeriod = 'INVALID_RESERVATION_PERIOD',
  InvalidStayDate = 'INVALID_STAY_DATE',
  InvalidSurcharge = 'INVALID_SURCHARGE',
  MaxCapacityExceeded = 'MAX_CAPACITY_EXCEEDED',
  NotServiced = 'NOT_SERVICED',
  NotServicedInventory = 'NOT_SERVICED_INVENTORY',
  SoldOu = 'SOLD_OU',
  TodaySaleClosed = 'TODAY_SALE_CLOSED',
  UnexposedInventory = 'UNEXPOSED_INVENTORY',
  Valid = 'VALID'
}

export type RatePlanInventoryInput = {
  adultPax: Scalars['Int'];
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childAges: Array<Scalars['Int']>;
  surcharges: Array<Scalars['Int']>;
};

export enum RatePlanUseType {
  Dayuse = 'DAYUSE',
  Overnight = 'OVERNIGHT'
}

export enum ReasonCode {
  Etc = 'ETC',
  Reason_001 = 'REASON_001',
  Reason_002 = 'REASON_002',
  Reason_003 = 'REASON_003',
  Reason_004 = 'REASON_004',
  Reason_005 = 'REASON_005'
}

/** 환불 승인 유형 코드 */
export enum RefundApprovalTypeCode {
  /** 관리자승인 */
  Admin = 'ADMIN',
  /** 즉시 */
  Direct = 'DIRECT'
}

export type RemoveFromCart = {
  option_ids: Array<Scalars['String']>;
};

export type RentTimeLine = {
  __typename?: 'RentTimeLine';
  time: Scalars['String'];
  useTime: Scalars['Int'];
};

export type RequestOrderShare = {
  __typename?: 'RequestOrderShare';
  key?: Maybe<Scalars['String']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  affiliatePoint?: Maybe<Scalars['Int']>;
  appointmentDate: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  couponAmount?: Maybe<Scalars['Int']>;
  inTime: Scalars['String'];
  inTimeDate: Scalars['String'];
  inType?: Maybe<Scalars['String']>;
  memberNo: Scalars['Int'];
  mrName?: Maybe<Scalars['String']>;
  myroom?: Maybe<Scalars['Int']>;
  outTime: Scalars['String'];
  outTimeDate: Scalars['String'];
  payType?: Maybe<Scalars['Int']>;
  phoneNum?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
  placeNo: Scalars['Int'];
  purchasePrice: Scalars['Int'];
  regdate: Scalars['String'];
  reservationNo: Scalars['ID'];
  roomNum?: Maybe<Scalars['String']>;
  roomTypeName?: Maybe<Scalars['String']>;
  roomTypeNo: Scalars['Int'];
  salePrice: Scalars['Int'];
  savePoint?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  stayType: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  usePoint?: Maybe<Scalars['Int']>;
  useTime?: Maybe<Scalars['Int']>;
};

export type ReservationDetail = {
  __typename?: 'ReservationDetail';
  affiliatePoint?: Maybe<Scalars['Int']>;
  appointmentDate?: Maybe<Scalars['String']>;
  appointmentEndDate?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['String']>;
  couponAmount?: Maybe<Scalars['Int']>;
  couponEventIdx?: Maybe<Scalars['Int']>;
  datediff?: Maybe<Scalars['Int']>;
  eventRefundPoint?: Maybe<Scalars['Int']>;
  inTime?: Maybe<Scalars['String']>;
  inTimeDate?: Maybe<Scalars['String']>;
  inType?: Maybe<Scalars['String']>;
  memberNo?: Maybe<Scalars['Int']>;
  mpType?: Maybe<Scalars['Int']>;
  mrCancelAmt?: Maybe<Scalars['Int']>;
  mrCancelPoint?: Maybe<Scalars['Int']>;
  mrName?: Maybe<Scalars['String']>;
  myroom?: Maybe<Scalars['Int']>;
  outTime?: Maybe<Scalars['String']>;
  outTimeDate?: Maybe<Scalars['String']>;
  partnerPoint?: Maybe<ReservationPartnerPoint>;
  payType?: Maybe<Scalars['Int']>;
  phoneNum?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
  placeNo?: Maybe<Scalars['Int']>;
  publicPhoneNum?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  regdate?: Maybe<Scalars['String']>;
  reservationNo?: Maybe<Scalars['String']>;
  reserveDetailUrl?: Maybe<Scalars['String']>;
  roomNum?: Maybe<Scalars['String']>;
  roomTypeName?: Maybe<Scalars['String']>;
  roomTypeNo?: Maybe<Scalars['Int']>;
  salePrice?: Maybe<Scalars['Int']>;
  savePoint?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  stayType?: Maybe<Scalars['String']>;
  usePoint?: Maybe<Scalars['Int']>;
  useTime?: Maybe<Scalars['Int']>;
};

export type ReservationPartnerPoint = {
  __typename?: 'ReservationPartnerPoint';
  allRefund?: Maybe<Scalars['Boolean']>;
  amount?: Maybe<Scalars['Int']>;
  commissionAmount?: Maybe<Scalars['Int']>;
  partner?: Maybe<Scalars['String']>;
};

export type ReservationPolicy = {
  __typename?: 'ReservationPolicy';
  confirmedReservation?: Maybe<Scalars['Boolean']>;
};

export type ReservationStockRentType = {
  __typename?: 'ReservationStockRentType';
  myRoom: Scalars['Int'];
  rentAbleCnt: Scalars['Int'];
  rentCnt: Scalars['Int'];
  rentDiscountPrice: Scalars['Int'];
  rentMinUseTime: Scalars['String'];
  rentOpen: Scalars['Int'];
  rentOpenEndTime: Scalars['String'];
  rentPrice: Scalars['Int'];
  rentSoldout: Scalars['Int'];
  rentTimeLine?: Maybe<Array<RentTimeLine>>;
  rentUseEndTime: Scalars['String'];
  rentUseRoomCnt: Scalars['Int'];
  rentUseStartTime: Scalars['String'];
  rentUseTime: Scalars['String'];
  reservationType: Scalars['Int'];
  roomTypeNo: Scalars['Int'];
};

/** 예약 유형 (ONLINE: B2C 온라인 예약, OFFLINE: 현장 예약) */
export enum ReserveType {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type Rest = {
  __typename?: 'Rest';
  limitOffer?: Maybe<Scalars['String']>;
  limitUse?: Maybe<Scalars['Int']>;
  offered?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

export enum ReviewStatusGroup {
  Cancel = 'CANCEL',
  Complete = 'COMPLETE',
  Fail = 'FAIL',
  Ready = 'READY'
}

export type ReviewWritable = {
  __typename?: 'ReviewWritable';
  dueDateForReview?: Maybe<Scalars['String']>;
  reason?: Maybe<ReviewWritableReason>;
  reservationNo: Scalars['String'];
  writable: Scalars['Boolean'];
};

export type ReviewWritableParams = {
  checkInDateTime: Scalars['String'];
  checkOutDateTime: Scalars['String'];
  propertyCategory: PropertyCategory;
  propertyId: Scalars['Int'];
  reservationNo: Scalars['String'];
  reservePrice: Scalars['Int'];
  statusGroup: ReviewStatusGroup;
  useType: DomesticAccommodationUseType;
};

export type ReviewWritableParamsOrders = {
  orderId: Scalars['String'];
  serviceCategory: Scalars['String'];
};

export type ReviewWritableParamsV2 = {
  orders: Array<ReviewWritableParamsOrders>;
};

export enum ReviewWritableReason {
  AfterDeadline = 'AFTER_DEADLINE',
  BeforeCheckIn = 'BEFORE_CHECK_IN',
  BeforeCheckOut = 'BEFORE_CHECK_OUT',
  NotMember = 'NOT_MEMBER',
  ReservationNotCompleted = 'RESERVATION_NOT_COMPLETED',
  ReviewExist = 'REVIEW_EXIST'
}

export type ReviewWritableResponse = {
  __typename?: 'ReviewWritableResponse';
  reservations?: Maybe<Array<Maybe<ReviewWritable>>>;
};

export type ReviewWritableResponseV2 = {
  __typename?: 'ReviewWritableResponseV2';
  available: Scalars['Boolean'];
  expectedReward?: Maybe<ExpectedReward>;
  orderId: Scalars['String'];
  reviewAvailableUntil?: Maybe<Scalars['String']>;
  serviceCategory: Scalars['String'];
  unavailableReason?: Maybe<Scalars['String']>;
};

export enum RewardStatusType {
  Complete = 'COMPLETE',
  Fail = 'FAIL',
  NotOffer = 'NOT_OFFER',
  Ready = 'READY'
}

export enum Role {
  None = 'NONE',
  User = 'USER',
  Visitor = 'VISITOR'
}

export type RoomList = {
  __typename?: 'RoomList';
  placeNo?: Maybe<Scalars['Int']>;
  rentOpen?: Maybe<Scalars['Int']>;
  rentSoldout?: Maybe<Scalars['Int']>;
  roomNo?: Maybe<Scalars['Int']>;
  roomTimeList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  roomTypeNo?: Maybe<Scalars['Int']>;
  stayOpen?: Maybe<Scalars['Int']>;
  staySoldout?: Maybe<Scalars['Int']>;
};

export type RoomTypeCamping = {
  __typename?: 'RoomTypeCamping';
  zone: RoomTypeCampingZone;
};

export type RoomTypeCampingZone = {
  __typename?: 'RoomTypeCampingZone';
  name: Scalars['String'];
};

export type RoomTypeData = {
  __typename?: 'RoomTypeData';
  bedGroups?: Maybe<Array<Maybe<BedGroups>>>;
  camping?: Maybe<RoomTypeCamping>;
  capacity: Scalars['Int'];
  cloneType?: Maybe<Scalars['String']>;
  description?: Maybe<Description>;
  extraCharge?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maxCapacity: Scalars['Int'];
  name: Scalars['String'];
  nameLang?: Maybe<NameLang>;
  orderNo?: Maybe<Scalars['Int']>;
  originId?: Maybe<Scalars['String']>;
  photos: Array<Photos>;
  propertyId: Scalars['Int'];
  published?: Maybe<Scalars['Boolean']>;
  reservationPolicy?: Maybe<ReservationPolicy>;
  routerId?: Maybe<Scalars['String']>;
  smokingPreference?: Maybe<SmokingPreference>;
  status?: Maybe<Scalars['String']>;
};

export type RoomTypeStock = {
  __typename?: 'RoomTypeStock';
  day?: Maybe<Scalars['String']>;
  days?: Maybe<Array<Maybe<Days>>>;
  daysAbleRoomList?: Maybe<Array<Maybe<Scalars['Int']>>>;
  daysAverageDiscountPrice?: Maybe<Scalars['Int']>;
  daysAveragePrice?: Maybe<Scalars['Int']>;
  daysDiscountPrice?: Maybe<Scalars['Int']>;
  daysGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  daysGlobalPrice?: Maybe<Scalars['Int']>;
  daysOpen?: Maybe<Scalars['Int']>;
  daysOpenStartTime?: Maybe<Scalars['String']>;
  daysPrice?: Maybe<Scalars['Int']>;
  daysSoldout?: Maybe<Scalars['Int']>;
  daysUseEndTime?: Maybe<Scalars['String']>;
  daysUseRoomCnt?: Maybe<Scalars['Int']>;
  daysUseStartTime?: Maybe<Scalars['String']>;
  docId?: Maybe<Scalars['String']>;
  globalOpen?: Maybe<Scalars['Int']>;
  myRoom?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  placeNo?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  rentAbleCnt?: Maybe<Scalars['Int']>;
  rentBreakTime?: Maybe<Scalars['String']>;
  rentCnt?: Maybe<Scalars['Int']>;
  rentDiscountPrice?: Maybe<Scalars['Int']>;
  rentGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  rentGlobalPrice?: Maybe<Scalars['Int']>;
  rentMinUseTime?: Maybe<Scalars['String']>;
  rentOpen?: Maybe<Scalars['Int']>;
  rentOpenEndTime?: Maybe<Scalars['String']>;
  rentPrice?: Maybe<Scalars['Int']>;
  rentSoldout?: Maybe<Scalars['Int']>;
  rentTimeLine?: Maybe<Array<Maybe<RentTimeLine>>>;
  rentUseEndTime?: Maybe<Scalars['String']>;
  rentUseRoomCnt?: Maybe<Scalars['Int']>;
  rentUseStartTime?: Maybe<Scalars['String']>;
  rentUseTime?: Maybe<Scalars['String']>;
  rentWorkInDiscountPrice?: Maybe<Scalars['Int']>;
  rentWorkInPrice?: Maybe<Scalars['Int']>;
  reservationType?: Maybe<Scalars['Int']>;
  reservePublished?: Maybe<Scalars['Int']>;
  roomList?: Maybe<Array<Maybe<RoomList>>>;
  roomTypeNo?: Maybe<Scalars['Int']>;
  stayAbleCnt?: Maybe<Scalars['Int']>;
  stayBreakTime?: Maybe<Scalars['String']>;
  stayCnt?: Maybe<Scalars['Int']>;
  stayDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalPrice?: Maybe<Scalars['Int']>;
  stayOpen?: Maybe<Scalars['Int']>;
  stayOpenStartTime?: Maybe<Scalars['String']>;
  stayPrice?: Maybe<Scalars['Int']>;
  staySoldout?: Maybe<Scalars['Int']>;
  stayUseEndTime?: Maybe<Scalars['String']>;
  stayUseRoomCnt?: Maybe<Scalars['Int']>;
  stayUseStartTime?: Maybe<Scalars['String']>;
  stayWorkInDiscountPrice?: Maybe<Scalars['Int']>;
  stayWorkInPrice?: Maybe<Scalars['Int']>;
};

export type SalesPeriod = {
  __typename?: 'SalesPeriod';
  end?: Maybe<Scalars['String']>;
  endDateTime?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  startDateTime?: Maybe<Scalars['String']>;
};

export type SellerInfos = {
  __typename?: 'SellerInfos';
  businessNumber?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyEmail?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
};

export type SendCertificationInput = {
  certGroup: Scalars['String'];
  phoneNum: Scalars['String'];
};

export type SendReceiptEmailInput = {
  orderId: Scalars['String'];
  recipient: Scalars['String'];
};

export type SendReceiptEmailTemplateDataBuyerInformationInput = {
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type SendReceiptEmailTemplateDataInput = {
  buyerInformation: SendReceiptEmailTemplateDataBuyerInformationInput;
  orderId: Scalars['String'];
  orderedAt: Scalars['String'];
  orders: Array<SendReceiptEmailTemplateDataOrderInput>;
  paymentInformation: SendReceiptEmailTemplateDataPaymentInformationInput;
  refundInformation: Array<InputMaybe<SendReceiptEmailTemplateDataRefundInformationInput>>;
  userInformation: SendReceiptEmailTemplateDataUserInformationInput;
};

export type SendReceiptEmailTemplateDataOrderInput = {
  categoryOrderId: Scalars['String'];
  categoryType: Scalars['String'];
  hasPartialCancel: Scalars['Boolean'];
  imageSrc: Scalars['String'];
  info: Array<InputMaybe<Scalars['String']>>;
  isCancel: Scalars['Boolean'];
  isCancelProgress: Scalars['Boolean'];
  options?: InputMaybe<Scalars['String']>;
  price: Scalars['String'];
  ratePlanTitle?: InputMaybe<Scalars['String']>;
  serviceType: Scalars['String'];
  statusText: Scalars['String'];
  subTitle: Scalars['String'];
  title: Scalars['String'];
  useTypeText: Scalars['String'];
  vipMemberClass: Scalars['String'];
};

export type SendReceiptEmailTemplateDataPaymentInformationCouponInput = {
  price: Scalars['String'];
  title: Scalars['String'];
};

export type SendReceiptEmailTemplateDataPaymentInformationInput = {
  coupons: Array<InputMaybe<SendReceiptEmailTemplateDataPaymentInformationCouponInput>>;
  discountPrice: Scalars['String'];
  discountRatio: Scalars['String'];
  paidMethod: Scalars['String'];
  paidPrice: Scalars['String'];
  paidTotal: Scalars['Int'];
  partnerDiscountPrice: Scalars['String'];
  pointDiscount: Scalars['String'];
  points: Array<InputMaybe<SendReceiptEmailTemplateDataPaymentInformationPointInput>>;
  totalPrice: Scalars['String'];
  trainPackageDiscountPrice: Scalars['String'];
};

export type SendReceiptEmailTemplateDataPaymentInformationPointInput = {
  amount: Scalars['String'];
  title: Scalars['String'];
};

export type SendReceiptEmailTemplateDataRefundInformationInput = {
  couponCount: Scalars['Int'];
  date: Scalars['String'];
  isCancelComplete: Scalars['Boolean'];
  isMembership: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  payment: Scalars['String'];
  paymentAmount: Scalars['String'];
  point: Scalars['String'];
  refundAmount: Scalars['String'];
  representativeGoodsName: Scalars['String'];
};

export type SendReceiptEmailTemplateDataUserInformationInput = {
  birthDate: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  virtualPhoneNumber: Scalars['String'];
};

export type SharedOrder = {
  __typename?: 'SharedOrder';
  additionalCategoryOrders: Array<SharedOrderCategory>;
  categoryOrders: Array<SharedOrderCategory>;
  createdAt: Scalars['String'];
  id: Scalars['String'];
};

export type SharedOrderBus = SharedOrderCategoryOrder & {
  __typename?: 'SharedOrderBus';
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  reservations: Array<SharedOrderBusReservation>;
};

export type SharedOrderBusReservation = {
  __typename?: 'SharedOrderBusReservation';
  arrivalTerminalName: Scalars['String'];
  arrivalTerminalNo: Scalars['String'];
  boardingNo?: Maybe<Scalars['String']>;
  busGrade: Scalars['String'];
  departureAt: Scalars['String'];
  departureDate: Scalars['String'];
  departureTerminalName: Scalars['String'];
  departureTerminalNo: Scalars['String'];
  departureTime: Scalars['String'];
  expectedArriveAt: Scalars['String'];
  id: Scalars['Int'];
  returnTrip: Scalars['Boolean'];
  tickets: Array<SharedOrderBusReservationTicket>;
  transportationCompanyCode: Scalars['String'];
};

export type SharedOrderBusReservationTicket = {
  __typename?: 'SharedOrderBusReservationTicket';
  confirm: Scalars['Boolean'];
  confirmedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  qrGenNo: Scalars['String'];
  seatNo: Scalars['Int'];
  status: OrderDetailsBusReservationTicketStatus;
  ticketType: Scalars['String'];
};

export type SharedOrderCategory = SharedOrderBus | SharedOrderDomestic | SharedOrderLeisure | SharedOrderTrain;

export type SharedOrderCategoryOrder = {
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
};

export type SharedOrderDomestic = SharedOrderCategoryOrder & {
  __typename?: 'SharedOrderDomestic';
  benefits?: Maybe<Array<DomesticRatePlanBenefits>>;
  category: CategoryType;
  checkInAt: Scalars['String'];
  checkOutAt: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  pendingStatus?: Maybe<PendingStatus>;
  pickupType?: Maybe<PickupType>;
  property?: Maybe<ProductPropertyDomestic>;
  propertyCategory: PropertyCategory;
  propertyId: Scalars['Int'];
  propertyName: Scalars['String'];
  propertyVersion?: Maybe<Scalars['Int']>;
  ratePlanDescription?: Maybe<Scalars['String']>;
  ratePlanId?: Maybe<Scalars['Int']>;
  ratePlanTitle?: Maybe<Scalars['String']>;
  ratePlanVersion?: Maybe<Scalars['Int']>;
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
  roomTypeId: Scalars['Int'];
  roomTypeName: Scalars['String'];
  roomTypeVersion: Scalars['Int'];
  statusGroupCode: StatusGroupCode;
  useType: DomesticAccommodationUseType;
  visitType: VisitType;
};

export type SharedOrderLeisure = SharedOrderCategoryOrder & {
  __typename?: 'SharedOrderLeisure';
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  items: Array<SharedOrderLeisureItem>;
};

export type SharedOrderLeisureItem = {
  __typename?: 'SharedOrderLeisureItem';
  date?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealName: Scalars['String'];
  id: Scalars['String'];
  optionId: Scalars['String'];
  optionName: Scalars['String'];
  product: LeisureProduct;
  productVersion?: Maybe<Scalars['Int']>;
  status: CartLeisureOrderStatus;
  time?: Maybe<Scalars['String']>;
  valid: OrderDetailsLeisureValid;
  variant: LeisureProductVariant;
};

export type SharedOrderTrain = SharedOrderCategoryOrder & {
  __typename?: 'SharedOrderTrain';
  category: CategoryType;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  tickets: Array<OrderDetailsTrainTicket>;
};

export type SharedOrderTrainTicket = {
  __typename?: 'SharedOrderTrainTicket';
  adults: Scalars['Int'];
  arrivalAt: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  carriageClassCode: Scalars['String'];
  child: Scalars['Int'];
  departureAt: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  goodsReservationNo: Scalars['String'];
  id: Scalars['String'];
  runningDate?: Maybe<Scalars['String']>;
  seats: Array<OrderDetailsTrainTicketSeats>;
  stationTrainClassifyCode: Scalars['String'];
  status: CartTrainOrderTicketStatus;
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type SharedRatePlan = {
  __typename?: 'SharedRatePlan';
  memberClass?: Maybe<Scalars['String']>;
  ratePlanId?: Maybe<Scalars['Int']>;
};

export type SingleLine = {
  __typename?: 'SingleLine';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SingleStock = {
  __typename?: 'SingleStock';
  data: RoomTypeStock;
};

export type Sleep = {
  __typename?: 'Sleep';
  limitOffer?: Maybe<Scalars['String']>;
  limitUse?: Maybe<Scalars['Int']>;
  offered?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
};

export enum SmokingPreference {
  NonSmoking = 'NON_SMOKING',
  Smoking = 'SMOKING'
}

export type StarInfo = {
  __typename?: 'StarInfo';
  date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export enum StatusCode {
  AdminCancel = 'ADMIN_CANCEL',
  CancelPointRefund = 'CANCEL_POINT_REFUND',
  CompleteReserve = 'COMPLETE_RESERVE',
  CustomerCancel = 'CUSTOMER_CANCEL',
  FailReserve = 'FAIL_RESERVE',
  OfflineCancel = 'OFFLINE_CANCEL',
  PgCancel = 'PG_CANCEL',
  PrepareReserve = 'PREPARE_RESERVE'
}

export enum StatusGroupCode {
  Cancel = 'CANCEL',
  Complete = 'COMPLETE',
  Ready = 'READY'
}

export type StayTypeConfigs = {
  __typename?: 'StayTypeConfigs';
  applicableMaxPrice?: Maybe<Scalars['String']>;
  applicableMinPrice?: Maybe<Scalars['Int']>;
  maxDiscount?: Maybe<Scalars['String']>;
  minActualPayment?: Maybe<Scalars['Int']>;
  stayType?: Maybe<Scalars['String']>;
};

export type Stock = {
  __typename?: 'Stock';
  data: Array<RoomTypeStock>;
  log?: Maybe<Scalars['String']>;
  resultCode: Scalars['Int'];
  resultMsg: Scalars['String'];
  totalCnt: Scalars['Int'];
};

export type StockReservationRoomType = {
  __typename?: 'StockReservationRoomType';
  checkinDate?: Maybe<Scalars['String']>;
  checkinDateTime?: Maybe<Scalars['String']>;
  checkoutDate?: Maybe<Scalars['String']>;
  checkoutDateTime?: Maybe<Scalars['String']>;
  day?: Maybe<Scalars['String']>;
  daysAverageDiscountPrice?: Maybe<Scalars['Int']>;
  daysAveragePrice?: Maybe<Scalars['Int']>;
  daysDiscountPrice?: Maybe<Scalars['Int']>;
  daysGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  daysGlobalPrice?: Maybe<Scalars['Int']>;
  daysOpen?: Maybe<Scalars['Int']>;
  daysOpenStartTime?: Maybe<Scalars['String']>;
  daysPrice?: Maybe<Scalars['Int']>;
  daysSoldout?: Maybe<Scalars['Int']>;
  daysUseEndTime?: Maybe<Scalars['String']>;
  daysUseRoomCnt?: Maybe<Scalars['Int']>;
  daysUseStartTime?: Maybe<Scalars['String']>;
  docId?: Maybe<Scalars['String']>;
  globalOpen?: Maybe<Scalars['Int']>;
  inTime?: Maybe<Scalars['String']>;
  myRoom?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  outTime?: Maybe<Scalars['String']>;
  placeNo?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  rentAbleCnt?: Maybe<Scalars['Int']>;
  rentBreakTime?: Maybe<Scalars['String']>;
  rentCnt?: Maybe<Scalars['Int']>;
  rentDiscountPrice?: Maybe<Scalars['Int']>;
  rentGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  rentGlobalPrice?: Maybe<Scalars['Int']>;
  rentMinUseTime?: Maybe<Scalars['String']>;
  rentOpen?: Maybe<Scalars['Int']>;
  rentOpenEndTime?: Maybe<Scalars['String']>;
  rentPrice?: Maybe<Scalars['Int']>;
  rentSoldout?: Maybe<Scalars['Int']>;
  rentUseEndTime?: Maybe<Scalars['String']>;
  rentUseRoomCnt?: Maybe<Scalars['Int']>;
  rentUseStartTime?: Maybe<Scalars['String']>;
  rentUseTime?: Maybe<Scalars['String']>;
  rentWorkInDiscountPrice?: Maybe<Scalars['Int']>;
  rentWorkInPrice?: Maybe<Scalars['Int']>;
  reservationType?: Maybe<Scalars['Int']>;
  reservePublished?: Maybe<Scalars['Int']>;
  roomTypeNo: Scalars['Int'];
  stayAbleCnt?: Maybe<Scalars['Int']>;
  stayBreakTime?: Maybe<Scalars['String']>;
  stayCnt?: Maybe<Scalars['Int']>;
  stayDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalDiscountPrice?: Maybe<Scalars['Int']>;
  stayGlobalPrice?: Maybe<Scalars['Int']>;
  stayOpen?: Maybe<Scalars['Int']>;
  stayOpenStartTime?: Maybe<Scalars['String']>;
  stayPrice?: Maybe<Scalars['Int']>;
  staySoldout?: Maybe<Scalars['Int']>;
  stayUseEndTime?: Maybe<Scalars['String']>;
  stayUseRoomCnt?: Maybe<Scalars['Int']>;
  stayUseStartTime?: Maybe<Scalars['String']>;
  stayWorkInDiscountPrice?: Maybe<Scalars['Int']>;
  stayWorkInPrice?: Maybe<Scalars['Int']>;
};

export type StockRoomType = {
  __typename?: 'StockRoomType';
  price: Scalars['Int'];
  roomType?: Maybe<ProductPropertyRoomTypeDomestic>;
};

export type StockRoomTypeInput = {
  adults?: InputMaybe<Scalars['Int']>;
  checkInDate: Scalars['String'];
  checkOutDate: Scalars['String'];
  childAges?: InputMaybe<Array<Scalars['Int']>>;
  ratePlanId?: InputMaybe<Scalars['Int']>;
  ratePlanVersion?: InputMaybe<Scalars['Int']>;
  roomTypeId: Scalars['Int'];
  surchargeIds?: InputMaybe<Array<Scalars['Int']>>;
  useType: Scalars['String'];
};

export type SubBuckets = {
  __typename?: 'SubBuckets';
  code?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type Themes = {
  __typename?: 'Themes';
  code: Scalars['String'];
  value: Scalars['String'];
};

export type TrainStation = {
  __typename?: 'TrainStation';
  code: Scalars['String'];
  districtCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ktx: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Int']>;
  mark: Scalars['Boolean'];
  name: Scalars['String'];
  supplyCompanyId: Scalars['Int'];
  supplyCompanyName: Scalars['String'];
};

export type TransportationSearch = {
  __typename?: 'TransportationSearch';
  arrivalDate: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName?: Maybe<Scalars['String']>;
  arrivalTime: Scalars['String'];
  departureDate: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName?: Maybe<Scalars['String']>;
  departureTime: Scalars['String'];
  directTransferCode?: Maybe<Scalars['String']>;
  fares: Array<TransportationSearchFare>;
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  packageFares: Array<TransportationSearchPackageFare>;
  runningDate: Scalars['String'];
  runningHourMinute?: Maybe<Scalars['String']>;
  saleControlYn?: Maybe<Scalars['String']>;
  seatAssignYn?: Maybe<Scalars['String']>;
  seats: Array<TransportationSearchCarriageSeat>;
  secondClassSeatCount?: Maybe<Scalars['Int']>;
  secondClassSeatYn?: Maybe<Scalars['String']>;
  stationTrainClassifyCode?: Maybe<Scalars['String']>;
  stationTrainClassifyName?: Maybe<Scalars['String']>;
  trainChangeYn?: Maybe<Scalars['String']>;
  trainGroupCode: Scalars['String'];
  trainGroupName?: Maybe<Scalars['String']>;
  trainNo: Scalars['String'];
  trainOrderNo?: Maybe<Scalars['String']>;
  transferTrainOrderNo?: Maybe<Scalars['String']>;
};

export type TransportationSearchCarriage = {
  __typename?: 'TransportationSearchCarriage';
  carriageNo: Scalars['String'];
  restSeatCount: Scalars['Int'];
  seatCount: Scalars['Int'];
};

export type TransportationSearchCarriageInput = {
  arrivalStationCode: Scalars['String'];
  departureStationCode: Scalars['String'];
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  runningDate: Scalars['String'];
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type TransportationSearchCarriageSeat = {
  __typename?: 'TransportationSearchCarriageSeat';
  carriageNo: Scalars['String'];
  seatDescription: Scalars['String'];
  seatNo: Scalars['String'];
};

export type TransportationSearchCarriageSeatInput = {
  arrivalStationCode: Scalars['String'];
  carriageNo: Scalars['String'];
  departureStationCode: Scalars['String'];
  goodsNo: Scalars['String'];
  runningDate: Scalars['String'];
  trainGroupCode: Scalars['String'];
  trainNo: Scalars['String'];
};

export type TransportationSearchFare = {
  __typename?: 'TransportationSearchFare';
  carriageClassCode: Scalars['String'];
  carriageClassName: Scalars['String'];
  fullPrice: Scalars['Int'];
  passengerTypeCode: Scalars['String'];
  passengerTypeName: Scalars['String'];
  salePrice: Scalars['Int'];
  yanoljaPrice: Scalars['Int'];
};

export type TransportationSearchFareInput = {
  arrivalStationCode: Scalars['String'];
  departureStationCode: Scalars['String'];
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  runningDate: Scalars['String'];
  trainNo: Scalars['String'];
};

export type TransportationSearchInput = {
  arrivalStationCode: Scalars['String'];
  departureDate: Scalars['String'];
  departureStationCode: Scalars['String'];
  goodsNo: Scalars['String'];
  seats: Array<TransportationSearchSeatInput>;
  trainNo: Scalars['String'];
};

export type TransportationSearchPackageFare = {
  __typename?: 'TransportationSearchPackageFare';
  /** 객실등급 코드 */
  carriageClassCode: Scalars['String'];
  /** 객실등급 코드명 */
  carriageClassName: Scalars['String'];
  /** 소비자 요금 (판매가) */
  fullPrice: Scalars['Int'];
  /** 승객유형 코드 */
  passengerTypeCode: Scalars['String'];
  /** 승객유형 코드명 */
  passengerTypeName: Scalars['String'];
  /** 판매 요금 (공급가) */
  salePrice: Scalars['Int'];
  /** 여행석 소비자 요금 */
  travelFullPrice: Scalars['Int'];
  /** 여행석 판매 요금 */
  travelSalePrice: Scalars['Int'];
  /** 야놀자 패키지석 할인 금액 */
  yanoljaPackageDiscountAmount: Scalars['Int'];
  /** 야놀자 패키지석 할인율 */
  yanoljaPackageDiscountRatio: Scalars['Int'];
  /** 야놀자 패키지석 판매 요금 */
  yanoljaPackagePrice: Scalars['Int'];
  /** 야놀자 판매 요금 */
  yanoljaPrice: Scalars['Int'];
};

/** 열차별 운임 리스트 조회 input (묶음할인 가격 포함) */
export type TransportationSearchPackageFareInput = {
  /** 도착역 코드 */
  arrivalStationCode: Scalars['String'];
  /** 출발역 코드 */
  departureStationCode: Scalars['String'];
  /** 상품 구성 품목 ID */
  goodsGroupItemId: Scalars['String'];
  /** 상품 구성 그룹 일련 번호 */
  goodsGroupSequenceNo: Scalars['String'];
  /** 상품 품목 ID */
  goodsItemId: Scalars['String'];
  /** 상품번호 */
  goodsNo: Scalars['String'];
  /** 운행일자 */
  runningDate: Scalars['String'];
  /** 역무 열차종별 코드 */
  stationTrainClassifyCode: Scalars['String'];
  /** 열차번호: PathVariable */
  trainNo: Scalars['String'];
};

export type TransportationSearchSeat = {
  __typename?: 'TransportationSearchSeat';
  directionCode?: Maybe<Scalars['String']>;
  directionCodeName?: Maybe<Scalars['String']>;
  etcCode?: Maybe<Scalars['String']>;
  etcCodeName?: Maybe<Scalars['String']>;
  goodsNo: Scalars['String'];
  goodsSaleGroupId: Scalars['String'];
  locationCode?: Maybe<Scalars['String']>;
  locationCodeName?: Maybe<Scalars['String']>;
  nearEntranceYn: Scalars['String'];
  requestCode?: Maybe<Scalars['String']>;
  requestCodeName?: Maybe<Scalars['String']>;
  saleAvailabilityYn: Scalars['String'];
  seatDescription: Scalars['String'];
  seatNo: Scalars['String'];
  smokeCode?: Maybe<Scalars['String']>;
  smokeCodeName?: Maybe<Scalars['String']>;
  stationTrainClassifyCode: Scalars['String'];
  stationTrainClassifyName: Scalars['String'];
};

export type TransportationSearchSeatInput = {
  carriageNo: Scalars['String'];
  seatNo: Scalars['String'];
};

export type TransportationSearchTrain = {
  __typename?: 'TransportationSearchTrain';
  arrivalDate: Scalars['String'];
  arrivalStationCode: Scalars['String'];
  arrivalStationName: Scalars['String'];
  arrivalTime: Scalars['String'];
  departureDate: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureStationName: Scalars['String'];
  departureTime: Scalars['String'];
  directTransferCode: Scalars['String'];
  goodsGroupItemId: Scalars['String'];
  goodsGroupSequenceNo: Scalars['String'];
  goodsItemId: Scalars['String'];
  goodsNo: Scalars['String'];
  runningDate: Scalars['String'];
  runningHourMinute: Scalars['String'];
  saleControlYn: Scalars['String'];
  seatAssignYn: Scalars['String'];
  secondClassSeatCount: Scalars['Int'];
  secondClassSeatYn: Scalars['String'];
  stationTrainClassifyCode: Scalars['String'];
  stationTrainClassifyName: Scalars['String'];
  trainChangeYn: Scalars['String'];
  trainGroupCode: Scalars['String'];
  trainGroupName: Scalars['String'];
  trainNo: Scalars['String'];
  trainOrderNo: Scalars['String'];
  transferTrainOrderNo: Scalars['String'];
};

export type TransportationSearchTrainsInput = {
  arrivalStationCode: Scalars['String'];
  departureDate: Scalars['String'];
  departureStationCode: Scalars['String'];
  departureTime?: InputMaybe<Scalars['String']>;
  goodsType?: InputMaybe<Scalars['String']>;
  pageNo?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  passengerCount: Scalars['Int'];
};

export type Type = {
  __typename?: 'Type';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateCartItem = {
  domesticLeisure?: InputMaybe<UpdateDomesticLeisureOption>;
  domesticReservation?: InputMaybe<UpdateDomesticAccommodationOption>;
  optionId: Scalars['String'];
};

export type UpdateCartItemByOrderIdResponse = {
  __typename?: 'UpdateCartItemByOrderIdResponse';
  cartItemsV3: Array<ICartItem>;
  errorCode?: Maybe<Scalars['String']>;
};

export type UpdateCartItemByOrderIdV2Response = {
  __typename?: 'UpdateCartItemByOrderIdV2Response';
  cartSingleItems: Array<ICartSingleItem>;
  errorCode?: Maybe<Scalars['String']>;
};

export type UpdateDomesticAccommodationOption = {
  checkInAt: Scalars['String'];
  checkOutAt: Scalars['String'];
};

export type UpdateDomesticLeisureOption = {
  quantity: Scalars['Int'];
};

export type UpdateOrder = {
  __typename?: 'UpdateOrder';
  updatedProperties: Array<UpdatedProperty>;
};

export type UpdatedProperty = {
  __typename?: 'UpdatedProperty';
  adults: Scalars['Int'];
  badgeMemberCode?: Maybe<Scalars['String']>;
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childrenAges?: Maybe<Array<Scalars['Int']>>;
  propertyId: Scalars['Int'];
  ratePlanId: Scalars['Int'];
  ratePlanVersion?: Maybe<Scalars['Int']>;
  roomTypeId?: Maybe<Scalars['Int']>;
  surchargeIds?: Maybe<Array<Scalars['Int']>>;
  type: Scalars['String'];
  useType: Scalars['String'];
};

export type UseTypeInput = {
  useType: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export enum ValidateOrderSheetMemberClassReason {
  MemberClassDowngraded = 'MEMBER_CLASS_DOWNGRADED',
  MemberClassUpgraded = 'MEMBER_CLASS_UPGRADED',
  VipRatePlanForNonMember = 'VIP_RATE_PLAN_FOR_NON_MEMBER'
}

export type ValidateOrderSheetMemberClassResponse = {
  __typename?: 'ValidateOrderSheetMemberClassResponse';
  data?: Maybe<UpdateOrder>;
  reason?: Maybe<ValidateOrderSheetMemberClassReason>;
  success: Scalars['Boolean'];
};

export type ValidatePropertyInput = {
  adults: Scalars['Int'];
  checkInAt: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutAt: Scalars['String'];
  checkOutDate: Scalars['String'];
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
  propertyId: Scalars['Int'];
  ratePlanId?: InputMaybe<Scalars['Int']>;
  ratePlanVersion?: InputMaybe<Scalars['Int']>;
  roomTypeId?: InputMaybe<Scalars['Int']>;
  surchargeIds?: InputMaybe<Array<Scalars['Int']>>;
  type: Scalars['String'];
  useType: Scalars['String'];
};

/** 유효기간 유형 코드 */
export enum ValidityPeriodTypeCode {
  /** 구매일기준 */
  Buy = 'BUY',
  /** 기간고정 */
  Fix = 'FIX'
}

/** 가격 정보 */
export type VariantPrice = {
  __typename?: 'VariantPrice';
  /** 할인 금액 (할인이 없으면 0) */
  discountAmount?: Maybe<Scalars['Float']>;
  /** 할인율 (100% 기준, 할인이 없으면 0) */
  discountPercentage?: Maybe<Scalars['Float']>;
  discountTypeCode?: Maybe<DiscountTypeCode>;
  /** 할인 전 원래 가격 (할인이 없으면 salePrice와 같은 값) */
  retailPrice?: Maybe<Scalars['Float']>;
  /** 판매 가격 */
  salePrice: Scalars['Float'];
};

export type VariantSupplyItem = {
  __typename?: 'VariantSupplyItem';
  /** 파트너ID */
  partnerCode: Scalars['Float'];
  /** 공급상품ID */
  supplyItemId: Scalars['Float'];
  /** 공급상품명 */
  supplyItemName?: Maybe<Scalars['String']>;
};

export type Viewer = {
  __typename?: 'Viewer';
  classCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hashedMemberNo: Scalars['String'];
  memberNo: Scalars['Int'];
  name: Scalars['String'];
  nolMemberProxyId?: Maybe<Scalars['String']>;
  payCode?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  role: Role;
};

export enum VisitType {
  OwnVehicle = 'OWN_VEHICLE',
  ParkingAvailable = 'PARKING_AVAILABLE',
  ParkingUnavailable = 'PARKING_UNAVAILABLE',
  PublicTransport = 'PUBLIC_TRANSPORT',
  Vehicle = 'VEHICLE',
  Walk = 'WALK'
}

export type VisitorAgreements = {
  __typename?: 'VisitorAgreements';
  option?: Maybe<MarketingAgree>;
  value?: Maybe<Scalars['Boolean']>;
};

export type VisitorFindAgreeData = {
  __typename?: 'VisitorFindAgreeData';
  agreements?: Maybe<Array<Maybe<VisitorAgreements>>>;
  effectiveDate?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type VisitorSaveAgreeInput = {
  agreements: Array<MarketingAgreeInput>;
  orders: Array<MarketingOrderInput>;
  phone: Scalars['String'];
};

export type Week = {
  __typename?: 'Week';
  impossibleWeek: Scalars['String'];
  possibleWeek: Scalars['String'];
};

/** 결제 승인정보 조회 */
export type YapaymentHistoryApproval = {
  __typename?: 'YapaymentHistoryApproval';
  isPlcc: Scalars['Boolean'];
  orderId: Scalars['String'];
  tenancyCode: Scalars['String'];
};

/** 결제 수단 */
export type YapaymentMethod = {
  __typename?: 'YapaymentMethod';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type YapaymentPaymentGoodsMeta = {
  category?: InputMaybe<YapaymentPaymentGoodsMetaCategory>;
  itemCode?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<YapaymentPaymentGoodsMetaType>;
};

export enum YapaymentPaymentGoodsMetaCategory {
  Giftcard = 'GIFTCARD',
  GuestHouse = 'GUEST_HOUSE',
  Hotel = 'HOTEL',
  Leisure = 'LEISURE',
  Motel = 'MOTEL',
  Pension = 'PENSION',
  Rentcar = 'RENTCAR'
}

export enum YapaymentPaymentGoodsMetaType {
  Bus = 'BUS',
  Cart = 'CART',
  PointCharge = 'POINT_CHARGE',
  RoomMy = 'ROOM_MY',
  RoomNow = 'ROOM_NOW',
  RoomOversea = 'ROOM_OVERSEA',
  Ticket = 'TICKET',
  Train = 'TRAIN'
}

export type YapaymentPaymentMethodPolicy = {
  __typename?: 'YapaymentPaymentMethodPolicy';
  badgeText?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  iconUrl: Scalars['String'];
  maxPayableAmount: Scalars['Int'];
  minPayableAmount: Scalars['Int'];
  name: Scalars['String'];
  notice?: Maybe<Scalars['String']>;
  sortNo: Scalars['Int'];
};

/** 결제 공지사항 */
export type YapaymentPaymentNotice = {
  __typename?: 'YapaymentPaymentNotice';
  inactivePaymentMethodCodes: Array<Scalars['String']>;
  notices: Array<PaymentNotice>;
};

export type YapaymentPaymentPolicy = {
  __typename?: 'YapaymentPaymentPolicy';
  paymentMethodPolicies: Array<YapaymentPaymentMethodPolicy>;
  paymentNotice: YapaymentPaymentNotice;
  paymentPolicySeq: Scalars['Int'];
  promotions: Array<YapaymentPaymentPromotion>;
};

export type YapaymentPaymentPolicyInput = {
  goodsMetas: Array<YapaymentPaymentGoodsMeta>;
  trackCode?: InputMaybe<Scalars['String']>;
};

export type YapaymentPaymentPromotion = {
  __typename?: 'YapaymentPaymentPromotion';
  imageUrl: Scalars['String'];
  sortNo?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes = {
  CartCategoryOrder: ( CartBusOrder ) | ( CartDomesticOrder ) | ( CartLeisureProductOrder ) | ( CartTrainOrder );
  OrderCancelCategory: ( OrderCancelBusOrder ) | ( OrderCancelDomesticOrder ) | ( OrderCancelLeisureProductOrder ) | ( OrderCancelTrainOrder );
  OrderCancelPolicyCategoryOrder: ( OrderCancelPolicyBus ) | ( OrderCancelPolicyDomestic ) | ( OrderCancelPolicyLeisureProduct ) | ( OrderCancelPolicyTrain );
  OrderDetailsCancellationCategory: ( OrderDetailsCancellationBus ) | ( OrderDetailsCancellationDomestic ) | ( OrderDetailsCancellationLeisureProduct ) | ( OrderDetailsCancellationTrain );
  OrderDetailsCategoryOrder: ( OrderDetailsBus ) | ( OrderDetailsDomestic ) | ( OrderDetailsLeisureProduct ) | ( OrderDetailsTrain );
  SharedOrderCategory: ( SharedOrderBus ) | ( SharedOrderDomestic ) | ( SharedOrderLeisure ) | ( SharedOrderTrain );
};

/** Mapping of union parent types */
export type ResolversUnionParentTypes = {
  CartCategoryOrder: ( CartBusOrder ) | ( CartDomesticOrder ) | ( CartLeisureProductOrder ) | ( CartTrainOrder );
  OrderCancelCategory: ( OrderCancelBusOrder ) | ( OrderCancelDomesticOrder ) | ( OrderCancelLeisureProductOrder ) | ( OrderCancelTrainOrder );
  OrderCancelPolicyCategoryOrder: ( OrderCancelPolicyBus ) | ( OrderCancelPolicyDomestic ) | ( OrderCancelPolicyLeisureProduct ) | ( OrderCancelPolicyTrain );
  OrderDetailsCancellationCategory: ( OrderDetailsCancellationBus ) | ( OrderDetailsCancellationDomestic ) | ( OrderDetailsCancellationLeisureProduct ) | ( OrderDetailsCancellationTrain );
  OrderDetailsCategoryOrder: ( OrderDetailsBus ) | ( OrderDetailsDomestic ) | ( OrderDetailsLeisureProduct ) | ( OrderDetailsTrain );
  SharedOrderCategory: ( SharedOrderBus ) | ( SharedOrderDomestic ) | ( SharedOrderLeisure ) | ( SharedOrderTrain );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AddToCartDomesticAccommodation: AddToCartDomesticAccommodation;
  AddToCartDomesticLeisure: AddToCartDomesticLeisure;
  AddToCartDomesticTrain: AddToCartDomesticTrain;
  AddToCartItems: AddToCartItems;
  AdditionalOrder: ResolverTypeWrapper<Omit<AdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderDetailsCategoryOrder']> }>;
  AddressCodes: ResolverTypeWrapper<AddressCodes>;
  AddressLang: ResolverTypeWrapper<AddressLang>;
  AddtoCartItemsResponse: ResolverTypeWrapper<AddtoCartItemsResponse>;
  Affiliation: ResolverTypeWrapper<Affiliation>;
  AgePolicy: ResolverTypeWrapper<AgePolicy>;
  Aggregations: ResolverTypeWrapper<Aggregations>;
  AgreementType: ResolverTypeWrapper<AgreementType>;
  AvailableInventoryRatePlanData: ResolverTypeWrapper<AvailableInventoryRatePlanData>;
  AvailableInventoryRatePlanInventory: ResolverTypeWrapper<AvailableInventoryRatePlanInventory>;
  AvailableInventoryRatePlanResponse: ResolverTypeWrapper<AvailableInventoryRatePlanResponse>;
  AvailablePeriod: ResolverTypeWrapper<AvailablePeriod>;
  BannerAction: ResolverTypeWrapper<BannerAction>;
  BannerImage: ResolverTypeWrapper<BannerImage>;
  BannerInput: BannerInput;
  BannerLogMeta: ResolverTypeWrapper<BannerLogMeta>;
  BannerResponse: ResolverTypeWrapper<BannerResponse>;
  BedConfigurations: ResolverTypeWrapper<BedConfigurations>;
  BedGroups: ResolverTypeWrapper<BedGroups>;
  BedType: BedType;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BusCancelPolicy: ResolverTypeWrapper<BusCancelPolicy>;
  BusCancelPreview: ResolverTypeWrapper<BusCancelPreview>;
  BusCancelPreviewInput: BusCancelPreviewInput;
  BusCancelPreviewType: ResolverTypeWrapper<BusCancelPreviewType>;
  BusDetail: ResolverTypeWrapper<BusDetail>;
  BusDetailFee: ResolverTypeWrapper<BusDetailFee>;
  BusDetailInput: BusDetailInput;
  BusDetailSeat: ResolverTypeWrapper<BusDetailSeat>;
  BusDetailSeatInput: BusDetailSeatInput;
  BusDetailTicketType: ResolverTypeWrapper<BusDetailTicketType>;
  BusNonCancelableReason: BusNonCancelableReason;
  BusSeat: ResolverTypeWrapper<BusSeat>;
  BusTransportationCompany: ResolverTypeWrapper<BusTransportationCompany>;
  BusUnavailableReason: BusUnavailableReason;
  CancelCause: CancelCause;
  CancelPolicy: ResolverTypeWrapper<CancelPolicy>;
  CancelPolicyBusTicket: ResolverTypeWrapper<CancelPolicyBusTicket>;
  CancelPolicyCreteria: CancelPolicyCreteria;
  CancelPolicyMethod: CancelPolicyMethod;
  CancelPolicySummary: ResolverTypeWrapper<CancelPolicySummary>;
  CancelPolicyType: CancelPolicyType;
  CancellationTypeCode: CancellationTypeCode;
  CartBusOrder: ResolverTypeWrapper<CartBusOrder>;
  CartBusOrderReservation: ResolverTypeWrapper<CartBusOrderReservation>;
  CartBusOrderReservationTicket: ResolverTypeWrapper<CartBusOrderReservationTicket>;
  CartBusOrderReservationTicketStatus: CartBusOrderReservationTicketStatus;
  CartCategoryOrder: ResolverTypeWrapper<ResolversUnionTypes['CartCategoryOrder']>;
  CartDomesticOrder: ResolverTypeWrapper<CartDomesticOrder>;
  CartItemOptionUnavailableReason: CartItemOptionUnavailableReason;
  CartLeisureOrderStatus: CartLeisureOrderStatus;
  CartLeisureOrderValid: ResolverTypeWrapper<CartLeisureOrderValid>;
  CartLeisureProductOrder: ResolverTypeWrapper<CartLeisureProductOrder>;
  CartLeisureProductOrderItem: ResolverTypeWrapper<CartLeisureProductOrderItem>;
  CartLeisureProductOrderItemVoucher: ResolverTypeWrapper<CartLeisureProductOrderItemVoucher>;
  CartOrder: ResolversTypes['CartBusOrder'] | ResolversTypes['CartDomesticOrder'] | ResolversTypes['CartLeisureProductOrder'] | ResolversTypes['CartTrainOrder'];
  CartOrders: ResolverTypeWrapper<Omit<CartOrders, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['CartCategoryOrder']> }>;
  CartPropertyDomesticRentTimeLines: ResolverTypeWrapper<CartPropertyDomesticRentTimeLines>;
  CartPropertyDomesticRentTimeLinesParams: CartPropertyDomesticRentTimeLinesParams;
  CartSingleItemParam: CartSingleItemParam;
  CartTrainOrder: ResolverTypeWrapper<CartTrainOrder>;
  CartTrainOrderTicket: ResolverTypeWrapper<CartTrainOrderTicket>;
  CartTrainOrderTicketSeat: ResolverTypeWrapper<CartTrainOrderTicketSeat>;
  CartTrainOrderTicketSeatDirection: CartTrainOrderTicketSeatDirection;
  CartTrainOrderTicketStatus: CartTrainOrderTicketStatus;
  CategoryGroupType: CategoryGroupType;
  CategoryName: CategoryName;
  CategoryType: CategoryType;
  CertificationCertifyResult: ResolverTypeWrapper<CertificationCertifyResult>;
  Commission: ResolverTypeWrapper<Commission>;
  ConfirmBusTicket: ResolverTypeWrapper<ConfirmBusTicket>;
  ConfirmBusTicketInput: ConfirmBusTicketInput;
  ConstraintNumber: ResolverTypeWrapper<Scalars['ConstraintNumber']>;
  ConstraintString: ResolverTypeWrapper<Scalars['ConstraintString']>;
  Content: ResolverTypeWrapper<Content>;
  ContentThemes: ResolverTypeWrapper<ContentThemes>;
  ContentThemesPhotos: ResolverTypeWrapper<ContentThemesPhotos>;
  Coordinate: ResolverTypeWrapper<Coordinate>;
  CouponDomesticInstance: ResolverTypeWrapper<CouponDomesticInstance>;
  CouponDomesticInstanceInput: CouponDomesticInstanceInput;
  CouponDomesticInstancePeriod: ResolverTypeWrapper<CouponDomesticInstancePeriod>;
  CouponDomesticInstanceProgress: ResolverTypeWrapper<CouponDomesticInstanceProgress>;
  CouponDomesticInstanceResponse: ResolverTypeWrapper<CouponDomesticInstanceResponse>;
  CouponDomesticInstanceV2: ResolverTypeWrapper<CouponDomesticInstanceV2>;
  CouponDomesticInstanceV2Input: CouponDomesticInstanceV2Input;
  CouponDomesticInstances: ResolverTypeWrapper<CouponDomesticInstances>;
  CouponDomesticInstancesV2: ResolverTypeWrapper<CouponDomesticInstancesV2>;
  CouponDownloadInput: CouponDownloadInput;
  CouponDownloaded: ResolverTypeWrapper<CouponDownloaded>;
  CouponMetadata: ResolverTypeWrapper<CouponMetadata>;
  CouponPlatformCheckProgress: ResolverTypeWrapper<CouponPlatformCheckProgress>;
  CouponPlatformCheckProgressConditionInput: CouponPlatformCheckProgressConditionInput;
  CouponPlatformCheckProgressInput: CouponPlatformCheckProgressInput;
  CouponPlatformCheckProgressMaxUseCount: ResolverTypeWrapper<CouponPlatformCheckProgressMaxUseCount>;
  CouponPlatformCheckProgressRequestInput: CouponPlatformCheckProgressRequestInput;
  CouponPlatformConditions: ResolverTypeWrapper<CouponPlatformConditions>;
  CouponPlatformDiscount: ResolverTypeWrapper<CouponPlatformDiscount>;
  CouponPlatformDownloadInput: CouponPlatformDownloadInput;
  CouponPlatformDownloaded: ResolverTypeWrapper<CouponPlatformDownloaded>;
  CouponPlatformInstance: ResolverTypeWrapper<CouponPlatformInstance>;
  CouponPlatformInstanceAppId: CouponPlatformInstanceAppId;
  CouponPlatformInstanceDiscount: ResolverTypeWrapper<CouponPlatformInstanceDiscount>;
  CouponPlatformInstanceInput: CouponPlatformInstanceInput;
  CouponPlatformInstanceInputBusReservation: CouponPlatformInstanceInputBusReservation;
  CouponPlatformInstanceInputBusReservationTicket: CouponPlatformInstanceInputBusReservationTicket;
  CouponPlatformInstanceRedemptionPolicy: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicy>;
  CouponPlatformInstanceRedemptionPolicyCondition: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicyCondition>;
  CouponPlatformInstanceRedemptionPolicyConditionV2: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicyConditionV2>;
  CouponPlatformInstanceRedemptionPolicyStock: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicyStock>;
  CouponPlatformInstanceRedemptionPolicyStockV2: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicyStockV2>;
  CouponPlatformInstanceRedemptionPolicyV2: ResolverTypeWrapper<CouponPlatformInstanceRedemptionPolicyV2>;
  CouponPlatformInstanceResource: ResolverTypeWrapper<CouponPlatformInstanceResource>;
  CouponPlatformInstanceResponse: ResolverTypeWrapper<CouponPlatformInstanceResponse>;
  CouponPlatformInstanceV2: ResolverTypeWrapper<CouponPlatformInstanceV2>;
  CouponPlatformInstances: ResolverTypeWrapper<CouponPlatformInstances>;
  CouponPlatformRedemptionPolicy: ResolverTypeWrapper<CouponPlatformRedemptionPolicy>;
  CouponPlatformResource: ResolverTypeWrapper<CouponPlatformResource>;
  CouponPlatformUserCoupon: ResolverTypeWrapper<CouponPlatformUserCoupon>;
  CouponSchema: ResolverTypeWrapper<CouponSchema>;
  CouponUsablePeriod: ResolverTypeWrapper<CouponUsablePeriod>;
  Days: ResolverTypeWrapper<Days>;
  DepthOne: ResolverTypeWrapper<DepthOne>;
  DepthThree: ResolverTypeWrapper<DepthThree>;
  DepthTwo: ResolverTypeWrapper<DepthTwo>;
  Description: ResolverTypeWrapper<Description>;
  Descriptions: ResolverTypeWrapper<Descriptions>;
  DirectionLang: ResolverTypeWrapper<DirectionLang>;
  DiscountTypeCode: DiscountTypeCode;
  DistributionPreview: ResolverTypeWrapper<DistributionPreview>;
  DistributionPreviewInput: DistributionPreviewInput;
  DistributionPreviewInputOrders: DistributionPreviewInputOrders;
  DistributionPreviewInputOrdersDiscount: DistributionPreviewInputOrdersDiscount;
  DistributionPreviewInputOrdersLeisure: DistributionPreviewInputOrdersLeisure;
  DistributionPreviewInputOrdersReservation: DistributionPreviewInputOrdersReservation;
  DistributionPreviewInputOrdersReservationDiscount: DistributionPreviewInputOrdersReservationDiscount;
  DistributionPreviewInputOrdersTrain: DistributionPreviewInputOrdersTrain;
  DistributionPreviewInputPayments: DistributionPreviewInputPayments;
  DistributionPreviewOrders: ResolverTypeWrapper<DistributionPreviewOrders>;
  DistributionPreviewOrdersDiscount: ResolverTypeWrapper<DistributionPreviewOrdersDiscount>;
  DistributionPreviewOrdersLeisure: ResolverTypeWrapper<DistributionPreviewOrdersLeisure>;
  DistributionPreviewOrdersPayments: ResolverTypeWrapper<DistributionPreviewOrdersPayments>;
  DistributionPreviewOrdersReservation: ResolverTypeWrapper<DistributionPreviewOrdersReservation>;
  DistributionPreviewOrdersReservationDiscount: ResolverTypeWrapper<DistributionPreviewOrdersReservationDiscount>;
  DistributionPreviewOrdersTrain: ResolverTypeWrapper<DistributionPreviewOrdersTrain>;
  DomesticAccommodationCartItem: ResolverTypeWrapper<DomesticAccommodationCartItem>;
  DomesticAccommodationCartItemOption: ResolverTypeWrapper<DomesticAccommodationCartItemOption>;
  DomesticAccommodationCartItemOptionHotDeal: ResolverTypeWrapper<DomesticAccommodationCartItemOptionHotDeal>;
  DomesticAccommodationCartItemOptionRatePlan: ResolverTypeWrapper<DomesticAccommodationCartItemOptionRatePlan>;
  DomesticAccommodationCartSingleItem: ResolverTypeWrapper<DomesticAccommodationCartSingleItem>;
  DomesticAccommodationUseType: DomesticAccommodationUseType;
  DomesticAccommodationUserCoupon: ResolverTypeWrapper<DomesticAccommodationUserCoupon>;
  DomesticBusCartItem: ResolverTypeWrapper<DomesticBusCartItem>;
  DomesticBusCartItemOption: ResolverTypeWrapper<DomesticBusCartItemOption>;
  DomesticBusCartItemOptionReservation: ResolverTypeWrapper<DomesticBusCartItemOptionReservation>;
  DomesticBusCartSingleItem: ResolverTypeWrapper<DomesticBusCartSingleItem>;
  DomesticCouponApplicationType: DomesticCouponApplicationType;
  DomesticDailyPrices: ResolverTypeWrapper<DomesticDailyPrices>;
  DomesticLeisureCartItem: ResolverTypeWrapper<DomesticLeisureCartItem>;
  DomesticLeisureCartItemAdd: DomesticLeisureCartItemAdd;
  DomesticLeisureCartItemOption: ResolverTypeWrapper<DomesticLeisureCartItemOption>;
  DomesticLeisureCartSingleItem: ResolverTypeWrapper<DomesticLeisureCartSingleItem>;
  DomesticPropertySearch: ResolverTypeWrapper<DomesticPropertySearch>;
  DomesticRatePlanBenefitType: DomesticRatePlanBenefitType;
  DomesticRatePlanBenefits: ResolverTypeWrapper<DomesticRatePlanBenefits>;
  DomesticTrainCartItem: ResolverTypeWrapper<DomesticTrainCartItem>;
  DomesticTrainCartItemAdd: DomesticTrainCartItemAdd;
  DomesticTrainCartItemOption: ResolverTypeWrapper<DomesticTrainCartItemOption>;
  DomesticTrainCartItemOptionTicketSeat: ResolverTypeWrapper<DomesticTrainCartItemOptionTicketSeat>;
  DomesticTrainCartItemSeatAdd: DomesticTrainCartItemSeatAdd;
  DomesticTrainCartItemTicket: ResolverTypeWrapper<DomesticTrainCartItemTicket>;
  DomesticTrainCartSingleItem: ResolverTypeWrapper<DomesticTrainCartSingleItem>;
  Event: ResolverTypeWrapper<Event>;
  ExpectedReward: ResolverTypeWrapper<ExpectedReward>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Hits: ResolverTypeWrapper<Hits>;
  ICartItem: ResolversTypes['DomesticAccommodationCartItem'] | ResolversTypes['DomesticBusCartItem'] | ResolversTypes['DomesticLeisureCartItem'] | ResolversTypes['DomesticTrainCartItem'];
  ICartItemOption: ResolversTypes['DomesticAccommodationCartItemOption'] | ResolversTypes['DomesticBusCartItemOption'] | ResolversTypes['DomesticLeisureCartItemOption'] | ResolversTypes['DomesticTrainCartItemOption'];
  ICartSingleItem: ResolversTypes['DomesticAccommodationCartSingleItem'] | ResolversTypes['DomesticBusCartSingleItem'] | ResolversTypes['DomesticLeisureCartSingleItem'] | ResolversTypes['DomesticTrainCartSingleItem'];
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Information: ResolverTypeWrapper<Information>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Items: ResolverTypeWrapper<Items>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']>;
  LeisureAdditionalPurchaseProduct: ResolverTypeWrapper<LeisureAdditionalPurchaseProduct>;
  LeisureAdditionalPurchaseVerification: ResolverTypeWrapper<LeisureAdditionalPurchaseVerification>;
  LeisureAdditionalPurchaseVerificationInput: LeisureAdditionalPurchaseVerificationInput;
  LeisureBody: ResolverTypeWrapper<LeisureBody>;
  LeisureCancellationFeePlan: ResolverTypeWrapper<LeisureCancellationFeePlan>;
  LeisureCategory: ResolverTypeWrapper<LeisureCategory>;
  LeisureHeader: ResolverTypeWrapper<LeisureHeader>;
  LeisureProduct: ResolverTypeWrapper<LeisureProduct>;
  LeisureProductBraze: ResolverTypeWrapper<LeisureProductBraze>;
  LeisureProductDetailInfo: ResolverTypeWrapper<LeisureProductDetailInfo>;
  LeisureProductEvent: ResolverTypeWrapper<LeisureProductEvent>;
  LeisureProductFacility: ResolverTypeWrapper<LeisureProductFacility>;
  LeisureProductGroup: ResolverTypeWrapper<LeisureProductGroup>;
  LeisureProductImage: ResolverTypeWrapper<LeisureProductImage>;
  LeisureProductInfo: ResolverTypeWrapper<LeisureProductInfo>;
  LeisureProductOptionGroup: ResolverTypeWrapper<LeisureProductOptionGroup>;
  LeisureProductPartner: ResolverTypeWrapper<LeisureProductPartner>;
  LeisureProductStatusCode: LeisureProductStatusCode;
  LeisureProductVariant: ResolverTypeWrapper<LeisureProductVariant>;
  LeisureProductVariantInput: LeisureProductVariantInput;
  LeisureSearch: ResolverTypeWrapper<LeisureSearch>;
  LeisureSearchInput: LeisureSearchInput;
  LeisureqProductItem: ResolverTypeWrapper<LeisureqProductItem>;
  LeisureqProductOptionItem: ResolverTypeWrapper<LeisureqProductOptionItem>;
  LeisureqProductPeriod: ResolverTypeWrapper<LeisureqProductPeriod>;
  LinkageType: ResolverTypeWrapper<LinkageType>;
  Location: ResolverTypeWrapper<Location>;
  LocationLang: ResolverTypeWrapper<LocationLang>;
  Locations: ResolverTypeWrapper<Locations>;
  Managements: ResolverTypeWrapper<Managements>;
  MarketingAgree: MarketingAgree;
  MarketingAgreeInput: MarketingAgreeInput;
  MarketingOrderInput: MarketingOrderInput;
  MemberClassBadgeType: MemberClassBadgeType;
  MemberClassBenefitCode: MemberClassBenefitCode;
  MemberClassItem: ResolverTypeWrapper<MemberClassItem>;
  MemberGatewayCIData: ResolverTypeWrapper<MemberGatewayCiData>;
  MemberGatewayMembership: ResolverTypeWrapper<MemberGatewayMembership>;
  MemberGatewayMembershipAffiliation: MemberGatewayMembershipAffiliation;
  MemberGatewayMembershipData: ResolverTypeWrapper<MemberGatewayMembershipData>;
  MemberGatewayMembershipDataInput: MemberGatewayMembershipDataInput;
  MemberInfo: ResolverTypeWrapper<MemberInfo>;
  MemberUpdateInput: MemberUpdateInput;
  MemberUpdatePhoneNumInput: MemberUpdatePhoneNumInput;
  MobileMembershipType: MobileMembershipType;
  Mutation: ResolverTypeWrapper<{}>;
  NameLang: ResolverTypeWrapper<NameLang>;
  NolChatResponse: ResolverTypeWrapper<NolChatResponse>;
  NolMemberInfoType: ResolverTypeWrapper<NolMemberInfoType>;
  NonCancellationReason: NonCancellationReason;
  Notices: ResolverTypeWrapper<Notices>;
  Options: ResolverTypeWrapper<Options>;
  OrderCancel: ResolverTypeWrapper<Omit<OrderCancel, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderCancelCategory']> }>;
  OrderCancelAdditionalOrder: ResolverTypeWrapper<Omit<OrderCancelAdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderCancelCategory']> }>;
  OrderCancelBusDiscount: ResolverTypeWrapper<OrderCancelBusDiscount>;
  OrderCancelBusOrder: ResolverTypeWrapper<OrderCancelBusOrder>;
  OrderCancelBusOrderDiscount: ResolverTypeWrapper<OrderCancelBusOrderDiscount>;
  OrderCancelBusOrderReservation: ResolverTypeWrapper<OrderCancelBusOrderReservation>;
  OrderCancelBusOrderReservationTicket: ResolverTypeWrapper<OrderCancelBusOrderReservationTicket>;
  OrderCancelCartDiscount: ResolverTypeWrapper<OrderCancelCartDiscount>;
  OrderCancelCartTrainPackageDiscount: ResolverTypeWrapper<OrderCancelCartTrainPackageDiscount>;
  OrderCancelCategory: ResolverTypeWrapper<ResolversUnionTypes['OrderCancelCategory']>;
  OrderCancelCoupon: ResolverTypeWrapper<OrderCancelCoupon>;
  OrderCancelDomesticOrder: ResolverTypeWrapper<OrderCancelDomesticOrder>;
  OrderCancelDomesticOrderDiscount: ResolverTypeWrapper<OrderCancelDomesticOrderDiscount>;
  OrderCancelFDSMeta: OrderCancelFdsMeta;
  OrderCancelInput: OrderCancelInput;
  OrderCancelInputAdditionalOrder: OrderCancelInputAdditionalOrder;
  OrderCancelInputCategoryOrder: OrderCancelInputCategoryOrder;
  OrderCancelLeisureOrderDiscount: ResolverTypeWrapper<OrderCancelLeisureOrderDiscount>;
  OrderCancelLeisureOrderValid: ResolverTypeWrapper<OrderCancelLeisureOrderValid>;
  OrderCancelLeisureProductOrder: ResolverTypeWrapper<OrderCancelLeisureProductOrder>;
  OrderCancelLeisureProductOrderItem: ResolverTypeWrapper<OrderCancelLeisureProductOrderItem>;
  OrderCancelMobileMembership: ResolverTypeWrapper<OrderCancelMobileMembership>;
  OrderCancelPayment: ResolverTypeWrapper<OrderCancelPayment>;
  OrderCancelPolicy: ResolverTypeWrapper<Omit<OrderCancelPolicy, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderCancelPolicyCategoryOrder']> }>;
  OrderCancelPolicyAdditionalOrder: ResolverTypeWrapper<Omit<OrderCancelPolicyAdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderCancelPolicyCategoryOrder']> }>;
  OrderCancelPolicyBus: ResolverTypeWrapper<OrderCancelPolicyBus>;
  OrderCancelPolicyBusReservation: ResolverTypeWrapper<OrderCancelPolicyBusReservation>;
  OrderCancelPolicyCategory: ResolversTypes['OrderCancelPolicyBus'] | ResolversTypes['OrderCancelPolicyDomestic'] | ResolversTypes['OrderCancelPolicyLeisureProduct'] | ResolversTypes['OrderCancelPolicyTrain'];
  OrderCancelPolicyCategoryOrder: ResolverTypeWrapper<ResolversUnionTypes['OrderCancelPolicyCategoryOrder']>;
  OrderCancelPolicyDiscount: ResolverTypeWrapper<OrderCancelPolicyDiscount>;
  OrderCancelPolicyDiscountCoupon: ResolverTypeWrapper<OrderCancelPolicyDiscountCoupon>;
  OrderCancelPolicyDomestic: ResolverTypeWrapper<OrderCancelPolicyDomestic>;
  OrderCancelPolicyLeisureProduct: ResolverTypeWrapper<OrderCancelPolicyLeisureProduct>;
  OrderCancelPolicyLeisureProductItem: ResolverTypeWrapper<OrderCancelPolicyLeisureProductItem>;
  OrderCancelPolicyLeisureValid: ResolverTypeWrapper<OrderCancelPolicyLeisureValid>;
  OrderCancelPolicyPayment: ResolverTypeWrapper<OrderCancelPolicyPayment>;
  OrderCancelPolicyTrain: ResolverTypeWrapper<OrderCancelPolicyTrain>;
  OrderCancelPolicyTrainTicket: ResolverTypeWrapper<OrderCancelPolicyTrainTicket>;
  OrderCancelPolicyTrainTicketSeat: ResolverTypeWrapper<OrderCancelPolicyTrainTicketSeat>;
  OrderCancelPrecheck: ResolverTypeWrapper<OrderCancelPrecheck>;
  OrderCancelPrecheckInput: OrderCancelPrecheckInput;
  OrderCancelPrecheckInputCategoryOrder: OrderCancelPrecheckInputCategoryOrder;
  OrderCancelPreview: ResolverTypeWrapper<OrderCancelPreview>;
  OrderCancelPreviewAdditionalOrder: ResolverTypeWrapper<OrderCancelPreviewAdditionalOrder>;
  OrderCancelPreviewCartDiscount: ResolverTypeWrapper<OrderCancelPreviewCartDiscount>;
  OrderCancelPreviewCartTrainPackageDiscount: ResolverTypeWrapper<OrderCancelPreviewCartTrainPackageDiscount>;
  OrderCancelPreviewInput: OrderCancelPreviewInput;
  OrderCancelPreviewInputAdditionalOrder: OrderCancelPreviewInputAdditionalOrder;
  OrderCancelPreviewInputCategoryOrder: OrderCancelPreviewInputCategoryOrder;
  OrderCancelPreviewOrder: ResolverTypeWrapper<OrderCancelPreviewOrder>;
  OrderCancelPreviewOrderDiscount: ResolverTypeWrapper<OrderCancelPreviewOrderDiscount>;
  OrderCancelPreviewOrderDiscountDetails: ResolverTypeWrapper<OrderCancelPreviewOrderDiscountDetails>;
  OrderCancelPreviewOrderDiscountMobileMembership: ResolverTypeWrapper<OrderCancelPreviewOrderDiscountMobileMembership>;
  OrderCancelPreviewPayment: ResolverTypeWrapper<OrderCancelPreviewPayment>;
  OrderCancelTrainOrder: ResolverTypeWrapper<OrderCancelTrainOrder>;
  OrderCancelTrainOrderDiscount: ResolverTypeWrapper<OrderCancelTrainOrderDiscount>;
  OrderCancelTrainOrderTicket: ResolverTypeWrapper<OrderCancelTrainOrderTicket>;
  OrderCancelTrainOrderTicketSeatType: ResolverTypeWrapper<OrderCancelTrainOrderTicketSeatType>;
  OrderDetails: ResolverTypeWrapper<Omit<OrderDetails, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderDetailsCategoryOrder']> }>;
  OrderDetailsBus: ResolverTypeWrapper<OrderDetailsBus>;
  OrderDetailsBusCancellationBusDiscount: ResolverTypeWrapper<OrderDetailsBusCancellationBusDiscount>;
  OrderDetailsBusReservation: ResolverTypeWrapper<OrderDetailsBusReservation>;
  OrderDetailsBusReservationTicket: ResolverTypeWrapper<OrderDetailsBusReservationTicket>;
  OrderDetailsBusReservationTicketStatus: OrderDetailsBusReservationTicketStatus;
  OrderDetailsBuyer: ResolverTypeWrapper<OrderDetailsBuyer>;
  OrderDetailsCancellation: ResolverTypeWrapper<Omit<OrderDetailsCancellation, 'categoryOrders'> & { categoryOrders: Array<ResolversTypes['OrderDetailsCancellationCategory']> }>;
  OrderDetailsCancellationBus: ResolverTypeWrapper<OrderDetailsCancellationBus>;
  OrderDetailsCancellationBusDiscount: ResolverTypeWrapper<OrderDetailsCancellationBusDiscount>;
  OrderDetailsCancellationBusDiscountType: OrderDetailsCancellationBusDiscountType;
  OrderDetailsCancellationBusReservation: ResolverTypeWrapper<OrderDetailsCancellationBusReservation>;
  OrderDetailsCancellationBusReservationTicket: ResolverTypeWrapper<OrderDetailsCancellationBusReservationTicket>;
  OrderDetailsCancellationBusReservationTicketStatus: OrderDetailsCancellationBusReservationTicketStatus;
  OrderDetailsCancellationCategory: ResolverTypeWrapper<ResolversUnionTypes['OrderDetailsCancellationCategory']>;
  OrderDetailsCancellationCategoryOrder: ResolversTypes['OrderDetailsCancellationBus'] | ResolversTypes['OrderDetailsCancellationDomestic'] | ResolversTypes['OrderDetailsCancellationLeisureProduct'] | ResolversTypes['OrderDetailsCancellationTrain'];
  OrderDetailsCancellationDiscount: ResolverTypeWrapper<OrderDetailsCancellationDiscount>;
  OrderDetailsCancellationDiscountCoupon: ResolverTypeWrapper<OrderDetailsCancellationDiscountCoupon>;
  OrderDetailsCancellationDomestic: ResolverTypeWrapper<OrderDetailsCancellationDomestic>;
  OrderDetailsCancellationDomesticDiscount: ResolverTypeWrapper<OrderDetailsCancellationDomesticDiscount>;
  OrderDetailsCancellationDomesticDiscountMobileMembership: ResolverTypeWrapper<OrderDetailsCancellationDomesticDiscountMobileMembership>;
  OrderDetailsCancellationLeisureDiscount: ResolverTypeWrapper<OrderDetailsCancellationLeisureDiscount>;
  OrderDetailsCancellationLeisureProduct: ResolverTypeWrapper<OrderDetailsCancellationLeisureProduct>;
  OrderDetailsCancellationLeisureProductItem: ResolverTypeWrapper<OrderDetailsCancellationLeisureProductItem>;
  OrderDetailsCancellationOrderDiscountCoupon: ResolverTypeWrapper<OrderDetailsCancellationOrderDiscountCoupon>;
  OrderDetailsCancellationPayment: ResolverTypeWrapper<OrderDetailsCancellationPayment>;
  OrderDetailsCancellationStatus: OrderDetailsCancellationStatus;
  OrderDetailsCancellationTrain: ResolverTypeWrapper<OrderDetailsCancellationTrain>;
  OrderDetailsCancellationTrainDiscount: ResolverTypeWrapper<OrderDetailsCancellationTrainDiscount>;
  OrderDetailsCancellationTrainPackageDiscount: ResolverTypeWrapper<OrderDetailsCancellationTrainPackageDiscount>;
  OrderDetailsCancellationTrainTicket: ResolverTypeWrapper<OrderDetailsCancellationTrainTicket>;
  OrderDetailsCartDiscount: ResolverTypeWrapper<OrderDetailsCartDiscount>;
  OrderDetailsCategory: ResolversTypes['OrderDetailsBus'] | ResolversTypes['OrderDetailsDomestic'] | ResolversTypes['OrderDetailsLeisureProduct'] | ResolversTypes['OrderDetailsTrain'];
  OrderDetailsCategoryOrder: ResolverTypeWrapper<ResolversUnionTypes['OrderDetailsCategoryOrder']>;
  OrderDetailsCoupon: ResolverTypeWrapper<OrderDetailsCoupon>;
  OrderDetailsDiscount: ResolverTypeWrapper<OrderDetailsDiscount>;
  OrderDetailsDiscountBusDiscount: ResolverTypeWrapper<OrderDetailsDiscountBusDiscount>;
  OrderDetailsDiscountBusDiscountType: OrderDetailsDiscountBusDiscountType;
  OrderDetailsDomestic: ResolverTypeWrapper<OrderDetailsDomestic>;
  OrderDetailsDomesticDiscount: ResolverTypeWrapper<OrderDetailsDomesticDiscount>;
  OrderDetailsDomesticRatePlan: ResolverTypeWrapper<OrderDetailsDomesticRatePlan>;
  OrderDetailsLeisureProduct: ResolverTypeWrapper<OrderDetailsLeisureProduct>;
  OrderDetailsLeisureProductItem: ResolverTypeWrapper<OrderDetailsLeisureProductItem>;
  OrderDetailsLeisureValid: ResolverTypeWrapper<OrderDetailsLeisureValid>;
  OrderDetailsMobileMembership: ResolverTypeWrapper<OrderDetailsMobileMembership>;
  OrderDetailsPayment: ResolverTypeWrapper<OrderDetailsPayment>;
  OrderDetailsTrain: ResolverTypeWrapper<OrderDetailsTrain>;
  OrderDetailsTrainCoupon: ResolverTypeWrapper<OrderDetailsTrainCoupon>;
  OrderDetailsTrainPackageDiscount: ResolverTypeWrapper<OrderDetailsTrainPackageDiscount>;
  OrderDetailsTrainTicket: ResolverTypeWrapper<OrderDetailsTrainTicket>;
  OrderDetailsTrainTicketSeats: ResolverTypeWrapper<OrderDetailsTrainTicketSeats>;
  OrderDetailsUser: ResolverTypeWrapper<OrderDetailsUser>;
  OrderList: ResolverTypeWrapper<OrderList>;
  OrderPaymentPolicy: ResolverTypeWrapper<OrderPaymentPolicy>;
  OrdersInput: OrdersInput;
  OverviewLang: ResolverTypeWrapper<OverviewLang>;
  PaymentMainPromotion: ResolverTypeWrapper<PaymentMainPromotion>;
  PaymentMethodPromotion: ResolverTypeWrapper<PaymentMethodPromotion>;
  PaymentMethodPromotionContent: ResolverTypeWrapper<PaymentMethodPromotionContent>;
  PaymentNotice: ResolverTypeWrapper<PaymentNotice>;
  PaymentPolicy: ResolverTypeWrapper<PaymentPolicy>;
  PaymentPromotion: ResolverTypeWrapper<PaymentPromotion>;
  PaymentType: PaymentType;
  PendingStatus: PendingStatus;
  PgReceiptInfo: ResolverTypeWrapper<PgReceiptInfo>;
  Photos: ResolverTypeWrapper<Photos>;
  PickupType: PickupType;
  PlaceMetaCouponsPayload: PlaceMetaCouponsPayload;
  PlaceMetaCouponsPayloadRequest: PlaceMetaCouponsPayloadRequest;
  PlaceMetaCouponsPayloadRequestRentType: PlaceMetaCouponsPayloadRequestRentType;
  PointAssetType: PointAssetType;
  PointAssociationLevel: PointAssociationLevel;
  PointEvent: ResolverTypeWrapper<PointEvent>;
  PointItemPolicy: ResolverTypeWrapper<PointItemPolicy>;
  PointItemType: PointItemType;
  PointLeisurePolicyInput: PointLeisurePolicyInput;
  PointPlaceType: PointPlaceType;
  PointPolicyType: PointPolicyType;
  PointPropertyPolicyInput: PointPropertyPolicyInput;
  PointServicePolicy: ResolverTypeWrapper<PointServicePolicy>;
  PointTotal: ResolverTypeWrapper<PointTotal>;
  PointTrainPolicyInput: PointTrainPolicyInput;
  ProductConfigCancelPolicies: ResolverTypeWrapper<ProductConfigCancelPolicies>;
  ProductConfigCancelPoliciesPolicy: ResolverTypeWrapper<ProductConfigCancelPoliciesPolicy>;
  ProductConfigParking: ResolverTypeWrapper<ProductConfigParking>;
  ProductConfigParkingType: ProductConfigParkingType;
  ProductConfigProperty: ResolverTypeWrapper<ProductConfigProperty>;
  ProductConfigPropertyControl: ResolverTypeWrapper<ProductConfigPropertyControl>;
  ProductConfigRoomType: ResolverTypeWrapper<ProductConfigRoomType>;
  ProductConfigRoomTypeControl: ResolverTypeWrapper<ProductConfigRoomTypeControl>;
  ProductPropertyDomestic: ResolverTypeWrapper<ProductPropertyDomestic>;
  ProductPropertyDomesticRatePlan: ResolverTypeWrapper<ProductPropertyDomesticRatePlan>;
  ProductPropertyRoomTypeDomestic: ResolverTypeWrapper<ProductPropertyRoomTypeDomestic>;
  ProductTypeCode: ProductTypeCode;
  Progress: ResolverTypeWrapper<Progress>;
  PropertyBreakfast: ResolverTypeWrapper<PropertyBreakfast>;
  PropertyCategory: PropertyCategory;
  PropertyCoupon: ResolverTypeWrapper<PropertyCoupon>;
  PropertyCouponCheckProgress: ResolverTypeWrapper<PropertyCouponCheckProgress>;
  PropertyCouponCheckProgressInput: PropertyCouponCheckProgressInput;
  PropertyCouponsProgress: ResolverTypeWrapper<PropertyCouponsProgress>;
  PropertyCouponsProgressMeta: ResolverTypeWrapper<PropertyCouponsProgressMeta>;
  PropertyCouponsResponse: ResolverTypeWrapper<PropertyCouponsResponse>;
  PropertyData: ResolverTypeWrapper<PropertyData>;
  PurchaseOptionTypeCode: PurchaseOptionTypeCode;
  QrCode: ResolverTypeWrapper<QrCode>;
  Query: ResolverTypeWrapper<{}>;
  RatePlan: ResolverTypeWrapper<RatePlan>;
  RatePlanAvailability: RatePlanAvailability;
  RatePlanConfig: ResolverTypeWrapper<RatePlanConfig>;
  RatePlanConfigControl: ResolverTypeWrapper<RatePlanConfigControl>;
  RatePlanDataRequest: ResolverTypeWrapper<RatePlanDataRequest>;
  RatePlanDataRequestPersons: ResolverTypeWrapper<RatePlanDataRequestPersons>;
  RatePlanDate: ResolverTypeWrapper<RatePlanDate>;
  RatePlanDateOtherSetting: ResolverTypeWrapper<RatePlanDateOtherSetting>;
  RatePlanInvalidReason: RatePlanInvalidReason;
  RatePlanInventoryInput: RatePlanInventoryInput;
  RatePlanUseType: RatePlanUseType;
  ReasonCode: ReasonCode;
  RefundApprovalTypeCode: RefundApprovalTypeCode;
  RemoveFromCart: RemoveFromCart;
  RentTimeLine: ResolverTypeWrapper<RentTimeLine>;
  RequestOrderShare: ResolverTypeWrapper<RequestOrderShare>;
  Reservation: ResolverTypeWrapper<Reservation>;
  ReservationDetail: ResolverTypeWrapper<ReservationDetail>;
  ReservationPartnerPoint: ResolverTypeWrapper<ReservationPartnerPoint>;
  ReservationPolicy: ResolverTypeWrapper<ReservationPolicy>;
  ReservationStockRentType: ResolverTypeWrapper<ReservationStockRentType>;
  ReserveType: ReserveType;
  Rest: ResolverTypeWrapper<Rest>;
  ReviewStatusGroup: ReviewStatusGroup;
  ReviewWritable: ResolverTypeWrapper<ReviewWritable>;
  ReviewWritableParams: ReviewWritableParams;
  ReviewWritableParamsOrders: ReviewWritableParamsOrders;
  ReviewWritableParamsV2: ReviewWritableParamsV2;
  ReviewWritableReason: ReviewWritableReason;
  ReviewWritableResponse: ResolverTypeWrapper<ReviewWritableResponse>;
  ReviewWritableResponseV2: ResolverTypeWrapper<ReviewWritableResponseV2>;
  RewardStatusType: RewardStatusType;
  Role: Role;
  RoomList: ResolverTypeWrapper<RoomList>;
  RoomTypeCamping: ResolverTypeWrapper<RoomTypeCamping>;
  RoomTypeCampingZone: ResolverTypeWrapper<RoomTypeCampingZone>;
  RoomTypeData: ResolverTypeWrapper<RoomTypeData>;
  RoomTypeStock: ResolverTypeWrapper<RoomTypeStock>;
  SalesPeriod: ResolverTypeWrapper<SalesPeriod>;
  SellerInfos: ResolverTypeWrapper<SellerInfos>;
  SendCertificationInput: SendCertificationInput;
  SendReceiptEmailInput: SendReceiptEmailInput;
  SendReceiptEmailTemplateDataBuyerInformationInput: SendReceiptEmailTemplateDataBuyerInformationInput;
  SendReceiptEmailTemplateDataInput: SendReceiptEmailTemplateDataInput;
  SendReceiptEmailTemplateDataOrderInput: SendReceiptEmailTemplateDataOrderInput;
  SendReceiptEmailTemplateDataPaymentInformationCouponInput: SendReceiptEmailTemplateDataPaymentInformationCouponInput;
  SendReceiptEmailTemplateDataPaymentInformationInput: SendReceiptEmailTemplateDataPaymentInformationInput;
  SendReceiptEmailTemplateDataPaymentInformationPointInput: SendReceiptEmailTemplateDataPaymentInformationPointInput;
  SendReceiptEmailTemplateDataRefundInformationInput: SendReceiptEmailTemplateDataRefundInformationInput;
  SendReceiptEmailTemplateDataUserInformationInput: SendReceiptEmailTemplateDataUserInformationInput;
  SharedOrder: ResolverTypeWrapper<Omit<SharedOrder, 'additionalCategoryOrders' | 'categoryOrders'> & { additionalCategoryOrders: Array<ResolversTypes['SharedOrderCategory']>, categoryOrders: Array<ResolversTypes['SharedOrderCategory']> }>;
  SharedOrderBus: ResolverTypeWrapper<SharedOrderBus>;
  SharedOrderBusReservation: ResolverTypeWrapper<SharedOrderBusReservation>;
  SharedOrderBusReservationTicket: ResolverTypeWrapper<SharedOrderBusReservationTicket>;
  SharedOrderCategory: ResolverTypeWrapper<ResolversUnionTypes['SharedOrderCategory']>;
  SharedOrderCategoryOrder: ResolversTypes['SharedOrderBus'] | ResolversTypes['SharedOrderDomestic'] | ResolversTypes['SharedOrderLeisure'] | ResolversTypes['SharedOrderTrain'];
  SharedOrderDomestic: ResolverTypeWrapper<SharedOrderDomestic>;
  SharedOrderLeisure: ResolverTypeWrapper<SharedOrderLeisure>;
  SharedOrderLeisureItem: ResolverTypeWrapper<SharedOrderLeisureItem>;
  SharedOrderTrain: ResolverTypeWrapper<SharedOrderTrain>;
  SharedOrderTrainTicket: ResolverTypeWrapper<SharedOrderTrainTicket>;
  SharedRatePlan: ResolverTypeWrapper<SharedRatePlan>;
  SingleLine: ResolverTypeWrapper<SingleLine>;
  SingleStock: ResolverTypeWrapper<SingleStock>;
  Sleep: ResolverTypeWrapper<Sleep>;
  SmokingPreference: SmokingPreference;
  StarInfo: ResolverTypeWrapper<StarInfo>;
  StatusCode: StatusCode;
  StatusGroupCode: StatusGroupCode;
  StayTypeConfigs: ResolverTypeWrapper<StayTypeConfigs>;
  Stock: ResolverTypeWrapper<Stock>;
  StockReservationRoomType: ResolverTypeWrapper<StockReservationRoomType>;
  StockRoomType: ResolverTypeWrapper<StockRoomType>;
  StockRoomTypeInput: StockRoomTypeInput;
  String: ResolverTypeWrapper<Scalars['String']>;
  SubBuckets: ResolverTypeWrapper<SubBuckets>;
  Themes: ResolverTypeWrapper<Themes>;
  TrainStation: ResolverTypeWrapper<TrainStation>;
  TransportationSearch: ResolverTypeWrapper<TransportationSearch>;
  TransportationSearchCarriage: ResolverTypeWrapper<TransportationSearchCarriage>;
  TransportationSearchCarriageInput: TransportationSearchCarriageInput;
  TransportationSearchCarriageSeat: ResolverTypeWrapper<TransportationSearchCarriageSeat>;
  TransportationSearchCarriageSeatInput: TransportationSearchCarriageSeatInput;
  TransportationSearchFare: ResolverTypeWrapper<TransportationSearchFare>;
  TransportationSearchFareInput: TransportationSearchFareInput;
  TransportationSearchInput: TransportationSearchInput;
  TransportationSearchPackageFare: ResolverTypeWrapper<TransportationSearchPackageFare>;
  TransportationSearchPackageFareInput: TransportationSearchPackageFareInput;
  TransportationSearchSeat: ResolverTypeWrapper<TransportationSearchSeat>;
  TransportationSearchSeatInput: TransportationSearchSeatInput;
  TransportationSearchTrain: ResolverTypeWrapper<TransportationSearchTrain>;
  TransportationSearchTrainsInput: TransportationSearchTrainsInput;
  Type: ResolverTypeWrapper<Type>;
  UpdateCartItem: UpdateCartItem;
  UpdateCartItemByOrderIdResponse: ResolverTypeWrapper<UpdateCartItemByOrderIdResponse>;
  UpdateCartItemByOrderIdV2Response: ResolverTypeWrapper<UpdateCartItemByOrderIdV2Response>;
  UpdateDomesticAccommodationOption: UpdateDomesticAccommodationOption;
  UpdateDomesticLeisureOption: UpdateDomesticLeisureOption;
  UpdateOrder: ResolverTypeWrapper<UpdateOrder>;
  UpdatedProperty: ResolverTypeWrapper<UpdatedProperty>;
  UseTypeInput: UseTypeInput;
  User: ResolverTypeWrapper<User>;
  ValidateOrderSheetMemberClassReason: ValidateOrderSheetMemberClassReason;
  ValidateOrderSheetMemberClassResponse: ResolverTypeWrapper<ValidateOrderSheetMemberClassResponse>;
  ValidatePropertyInput: ValidatePropertyInput;
  ValidityPeriodTypeCode: ValidityPeriodTypeCode;
  VariantPrice: ResolverTypeWrapper<VariantPrice>;
  VariantSupplyItem: ResolverTypeWrapper<VariantSupplyItem>;
  Viewer: ResolverTypeWrapper<Viewer>;
  VisitType: VisitType;
  VisitorAgreements: ResolverTypeWrapper<VisitorAgreements>;
  VisitorFindAgreeData: ResolverTypeWrapper<VisitorFindAgreeData>;
  VisitorSaveAgreeInput: VisitorSaveAgreeInput;
  Week: ResolverTypeWrapper<Week>;
  YapaymentHistoryApproval: ResolverTypeWrapper<YapaymentHistoryApproval>;
  YapaymentMethod: ResolverTypeWrapper<YapaymentMethod>;
  YapaymentPaymentGoodsMeta: YapaymentPaymentGoodsMeta;
  YapaymentPaymentGoodsMetaCategory: YapaymentPaymentGoodsMetaCategory;
  YapaymentPaymentGoodsMetaType: YapaymentPaymentGoodsMetaType;
  YapaymentPaymentMethodPolicy: ResolverTypeWrapper<YapaymentPaymentMethodPolicy>;
  YapaymentPaymentNotice: ResolverTypeWrapper<YapaymentPaymentNotice>;
  YapaymentPaymentPolicy: ResolverTypeWrapper<YapaymentPaymentPolicy>;
  YapaymentPaymentPolicyInput: YapaymentPaymentPolicyInput;
  YapaymentPaymentPromotion: ResolverTypeWrapper<YapaymentPaymentPromotion>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AddToCartDomesticAccommodation: AddToCartDomesticAccommodation;
  AddToCartDomesticLeisure: AddToCartDomesticLeisure;
  AddToCartDomesticTrain: AddToCartDomesticTrain;
  AddToCartItems: AddToCartItems;
  AdditionalOrder: Omit<AdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderDetailsCategoryOrder']> };
  AddressCodes: AddressCodes;
  AddressLang: AddressLang;
  AddtoCartItemsResponse: AddtoCartItemsResponse;
  Affiliation: Affiliation;
  AgePolicy: AgePolicy;
  Aggregations: Aggregations;
  AgreementType: AgreementType;
  AvailableInventoryRatePlanData: AvailableInventoryRatePlanData;
  AvailableInventoryRatePlanInventory: AvailableInventoryRatePlanInventory;
  AvailableInventoryRatePlanResponse: AvailableInventoryRatePlanResponse;
  AvailablePeriod: AvailablePeriod;
  BannerAction: BannerAction;
  BannerImage: BannerImage;
  BannerInput: BannerInput;
  BannerLogMeta: BannerLogMeta;
  BannerResponse: BannerResponse;
  BedConfigurations: BedConfigurations;
  BedGroups: BedGroups;
  Boolean: Scalars['Boolean'];
  BusCancelPolicy: BusCancelPolicy;
  BusCancelPreview: BusCancelPreview;
  BusCancelPreviewInput: BusCancelPreviewInput;
  BusCancelPreviewType: BusCancelPreviewType;
  BusDetail: BusDetail;
  BusDetailFee: BusDetailFee;
  BusDetailInput: BusDetailInput;
  BusDetailSeat: BusDetailSeat;
  BusDetailSeatInput: BusDetailSeatInput;
  BusDetailTicketType: BusDetailTicketType;
  BusSeat: BusSeat;
  BusTransportationCompany: BusTransportationCompany;
  CancelPolicy: CancelPolicy;
  CancelPolicyBusTicket: CancelPolicyBusTicket;
  CancelPolicySummary: CancelPolicySummary;
  CartBusOrder: CartBusOrder;
  CartBusOrderReservation: CartBusOrderReservation;
  CartBusOrderReservationTicket: CartBusOrderReservationTicket;
  CartCategoryOrder: ResolversUnionParentTypes['CartCategoryOrder'];
  CartDomesticOrder: CartDomesticOrder;
  CartLeisureOrderValid: CartLeisureOrderValid;
  CartLeisureProductOrder: CartLeisureProductOrder;
  CartLeisureProductOrderItem: CartLeisureProductOrderItem;
  CartLeisureProductOrderItemVoucher: CartLeisureProductOrderItemVoucher;
  CartOrder: ResolversParentTypes['CartBusOrder'] | ResolversParentTypes['CartDomesticOrder'] | ResolversParentTypes['CartLeisureProductOrder'] | ResolversParentTypes['CartTrainOrder'];
  CartOrders: Omit<CartOrders, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['CartCategoryOrder']> };
  CartPropertyDomesticRentTimeLines: CartPropertyDomesticRentTimeLines;
  CartPropertyDomesticRentTimeLinesParams: CartPropertyDomesticRentTimeLinesParams;
  CartSingleItemParam: CartSingleItemParam;
  CartTrainOrder: CartTrainOrder;
  CartTrainOrderTicket: CartTrainOrderTicket;
  CartTrainOrderTicketSeat: CartTrainOrderTicketSeat;
  CertificationCertifyResult: CertificationCertifyResult;
  Commission: Commission;
  ConfirmBusTicket: ConfirmBusTicket;
  ConfirmBusTicketInput: ConfirmBusTicketInput;
  ConstraintNumber: Scalars['ConstraintNumber'];
  ConstraintString: Scalars['ConstraintString'];
  Content: Content;
  ContentThemes: ContentThemes;
  ContentThemesPhotos: ContentThemesPhotos;
  Coordinate: Coordinate;
  CouponDomesticInstance: CouponDomesticInstance;
  CouponDomesticInstanceInput: CouponDomesticInstanceInput;
  CouponDomesticInstancePeriod: CouponDomesticInstancePeriod;
  CouponDomesticInstanceProgress: CouponDomesticInstanceProgress;
  CouponDomesticInstanceResponse: CouponDomesticInstanceResponse;
  CouponDomesticInstanceV2: CouponDomesticInstanceV2;
  CouponDomesticInstanceV2Input: CouponDomesticInstanceV2Input;
  CouponDomesticInstances: CouponDomesticInstances;
  CouponDomesticInstancesV2: CouponDomesticInstancesV2;
  CouponDownloadInput: CouponDownloadInput;
  CouponDownloaded: CouponDownloaded;
  CouponMetadata: CouponMetadata;
  CouponPlatformCheckProgress: CouponPlatformCheckProgress;
  CouponPlatformCheckProgressConditionInput: CouponPlatformCheckProgressConditionInput;
  CouponPlatformCheckProgressInput: CouponPlatformCheckProgressInput;
  CouponPlatformCheckProgressMaxUseCount: CouponPlatformCheckProgressMaxUseCount;
  CouponPlatformCheckProgressRequestInput: CouponPlatformCheckProgressRequestInput;
  CouponPlatformConditions: CouponPlatformConditions;
  CouponPlatformDiscount: CouponPlatformDiscount;
  CouponPlatformDownloadInput: CouponPlatformDownloadInput;
  CouponPlatformDownloaded: CouponPlatformDownloaded;
  CouponPlatformInstance: CouponPlatformInstance;
  CouponPlatformInstanceDiscount: CouponPlatformInstanceDiscount;
  CouponPlatformInstanceInput: CouponPlatformInstanceInput;
  CouponPlatformInstanceInputBusReservation: CouponPlatformInstanceInputBusReservation;
  CouponPlatformInstanceInputBusReservationTicket: CouponPlatformInstanceInputBusReservationTicket;
  CouponPlatformInstanceRedemptionPolicy: CouponPlatformInstanceRedemptionPolicy;
  CouponPlatformInstanceRedemptionPolicyCondition: CouponPlatformInstanceRedemptionPolicyCondition;
  CouponPlatformInstanceRedemptionPolicyConditionV2: CouponPlatformInstanceRedemptionPolicyConditionV2;
  CouponPlatformInstanceRedemptionPolicyStock: CouponPlatformInstanceRedemptionPolicyStock;
  CouponPlatformInstanceRedemptionPolicyStockV2: CouponPlatformInstanceRedemptionPolicyStockV2;
  CouponPlatformInstanceRedemptionPolicyV2: CouponPlatformInstanceRedemptionPolicyV2;
  CouponPlatformInstanceResource: CouponPlatformInstanceResource;
  CouponPlatformInstanceResponse: CouponPlatformInstanceResponse;
  CouponPlatformInstanceV2: CouponPlatformInstanceV2;
  CouponPlatformInstances: CouponPlatformInstances;
  CouponPlatformRedemptionPolicy: CouponPlatformRedemptionPolicy;
  CouponPlatformResource: CouponPlatformResource;
  CouponPlatformUserCoupon: CouponPlatformUserCoupon;
  CouponSchema: CouponSchema;
  CouponUsablePeriod: CouponUsablePeriod;
  Days: Days;
  DepthOne: DepthOne;
  DepthThree: DepthThree;
  DepthTwo: DepthTwo;
  Description: Description;
  Descriptions: Descriptions;
  DirectionLang: DirectionLang;
  DistributionPreview: DistributionPreview;
  DistributionPreviewInput: DistributionPreviewInput;
  DistributionPreviewInputOrders: DistributionPreviewInputOrders;
  DistributionPreviewInputOrdersDiscount: DistributionPreviewInputOrdersDiscount;
  DistributionPreviewInputOrdersLeisure: DistributionPreviewInputOrdersLeisure;
  DistributionPreviewInputOrdersReservation: DistributionPreviewInputOrdersReservation;
  DistributionPreviewInputOrdersReservationDiscount: DistributionPreviewInputOrdersReservationDiscount;
  DistributionPreviewInputOrdersTrain: DistributionPreviewInputOrdersTrain;
  DistributionPreviewInputPayments: DistributionPreviewInputPayments;
  DistributionPreviewOrders: DistributionPreviewOrders;
  DistributionPreviewOrdersDiscount: DistributionPreviewOrdersDiscount;
  DistributionPreviewOrdersLeisure: DistributionPreviewOrdersLeisure;
  DistributionPreviewOrdersPayments: DistributionPreviewOrdersPayments;
  DistributionPreviewOrdersReservation: DistributionPreviewOrdersReservation;
  DistributionPreviewOrdersReservationDiscount: DistributionPreviewOrdersReservationDiscount;
  DistributionPreviewOrdersTrain: DistributionPreviewOrdersTrain;
  DomesticAccommodationCartItem: DomesticAccommodationCartItem;
  DomesticAccommodationCartItemOption: DomesticAccommodationCartItemOption;
  DomesticAccommodationCartItemOptionHotDeal: DomesticAccommodationCartItemOptionHotDeal;
  DomesticAccommodationCartItemOptionRatePlan: DomesticAccommodationCartItemOptionRatePlan;
  DomesticAccommodationCartSingleItem: DomesticAccommodationCartSingleItem;
  DomesticAccommodationUserCoupon: DomesticAccommodationUserCoupon;
  DomesticBusCartItem: DomesticBusCartItem;
  DomesticBusCartItemOption: DomesticBusCartItemOption;
  DomesticBusCartItemOptionReservation: DomesticBusCartItemOptionReservation;
  DomesticBusCartSingleItem: DomesticBusCartSingleItem;
  DomesticDailyPrices: DomesticDailyPrices;
  DomesticLeisureCartItem: DomesticLeisureCartItem;
  DomesticLeisureCartItemAdd: DomesticLeisureCartItemAdd;
  DomesticLeisureCartItemOption: DomesticLeisureCartItemOption;
  DomesticLeisureCartSingleItem: DomesticLeisureCartSingleItem;
  DomesticPropertySearch: DomesticPropertySearch;
  DomesticRatePlanBenefits: DomesticRatePlanBenefits;
  DomesticTrainCartItem: DomesticTrainCartItem;
  DomesticTrainCartItemAdd: DomesticTrainCartItemAdd;
  DomesticTrainCartItemOption: DomesticTrainCartItemOption;
  DomesticTrainCartItemOptionTicketSeat: DomesticTrainCartItemOptionTicketSeat;
  DomesticTrainCartItemSeatAdd: DomesticTrainCartItemSeatAdd;
  DomesticTrainCartItemTicket: DomesticTrainCartItemTicket;
  DomesticTrainCartSingleItem: DomesticTrainCartSingleItem;
  Event: Event;
  ExpectedReward: ExpectedReward;
  Float: Scalars['Float'];
  Hits: Hits;
  ICartItem: ResolversParentTypes['DomesticAccommodationCartItem'] | ResolversParentTypes['DomesticBusCartItem'] | ResolversParentTypes['DomesticLeisureCartItem'] | ResolversParentTypes['DomesticTrainCartItem'];
  ICartItemOption: ResolversParentTypes['DomesticAccommodationCartItemOption'] | ResolversParentTypes['DomesticBusCartItemOption'] | ResolversParentTypes['DomesticLeisureCartItemOption'] | ResolversParentTypes['DomesticTrainCartItemOption'];
  ICartSingleItem: ResolversParentTypes['DomesticAccommodationCartSingleItem'] | ResolversParentTypes['DomesticBusCartSingleItem'] | ResolversParentTypes['DomesticLeisureCartSingleItem'] | ResolversParentTypes['DomesticTrainCartSingleItem'];
  ID: Scalars['ID'];
  Information: Information;
  Int: Scalars['Int'];
  Items: Items;
  JSON: Scalars['JSON'];
  JSONObject: Scalars['JSONObject'];
  LeisureAdditionalPurchaseProduct: LeisureAdditionalPurchaseProduct;
  LeisureAdditionalPurchaseVerification: LeisureAdditionalPurchaseVerification;
  LeisureAdditionalPurchaseVerificationInput: LeisureAdditionalPurchaseVerificationInput;
  LeisureBody: LeisureBody;
  LeisureCancellationFeePlan: LeisureCancellationFeePlan;
  LeisureCategory: LeisureCategory;
  LeisureHeader: LeisureHeader;
  LeisureProduct: LeisureProduct;
  LeisureProductBraze: LeisureProductBraze;
  LeisureProductDetailInfo: LeisureProductDetailInfo;
  LeisureProductEvent: LeisureProductEvent;
  LeisureProductFacility: LeisureProductFacility;
  LeisureProductGroup: LeisureProductGroup;
  LeisureProductImage: LeisureProductImage;
  LeisureProductInfo: LeisureProductInfo;
  LeisureProductOptionGroup: LeisureProductOptionGroup;
  LeisureProductPartner: LeisureProductPartner;
  LeisureProductVariant: LeisureProductVariant;
  LeisureProductVariantInput: LeisureProductVariantInput;
  LeisureSearch: LeisureSearch;
  LeisureSearchInput: LeisureSearchInput;
  LeisureqProductItem: LeisureqProductItem;
  LeisureqProductOptionItem: LeisureqProductOptionItem;
  LeisureqProductPeriod: LeisureqProductPeriod;
  LinkageType: LinkageType;
  Location: Location;
  LocationLang: LocationLang;
  Locations: Locations;
  Managements: Managements;
  MarketingAgreeInput: MarketingAgreeInput;
  MarketingOrderInput: MarketingOrderInput;
  MemberClassItem: MemberClassItem;
  MemberGatewayCIData: MemberGatewayCiData;
  MemberGatewayMembership: MemberGatewayMembership;
  MemberGatewayMembershipData: MemberGatewayMembershipData;
  MemberGatewayMembershipDataInput: MemberGatewayMembershipDataInput;
  MemberInfo: MemberInfo;
  MemberUpdateInput: MemberUpdateInput;
  MemberUpdatePhoneNumInput: MemberUpdatePhoneNumInput;
  Mutation: {};
  NameLang: NameLang;
  NolChatResponse: NolChatResponse;
  NolMemberInfoType: NolMemberInfoType;
  Notices: Notices;
  Options: Options;
  OrderCancel: Omit<OrderCancel, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderCancelCategory']> };
  OrderCancelAdditionalOrder: Omit<OrderCancelAdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderCancelCategory']> };
  OrderCancelBusDiscount: OrderCancelBusDiscount;
  OrderCancelBusOrder: OrderCancelBusOrder;
  OrderCancelBusOrderDiscount: OrderCancelBusOrderDiscount;
  OrderCancelBusOrderReservation: OrderCancelBusOrderReservation;
  OrderCancelBusOrderReservationTicket: OrderCancelBusOrderReservationTicket;
  OrderCancelCartDiscount: OrderCancelCartDiscount;
  OrderCancelCartTrainPackageDiscount: OrderCancelCartTrainPackageDiscount;
  OrderCancelCategory: ResolversUnionParentTypes['OrderCancelCategory'];
  OrderCancelCoupon: OrderCancelCoupon;
  OrderCancelDomesticOrder: OrderCancelDomesticOrder;
  OrderCancelDomesticOrderDiscount: OrderCancelDomesticOrderDiscount;
  OrderCancelFDSMeta: OrderCancelFdsMeta;
  OrderCancelInput: OrderCancelInput;
  OrderCancelInputAdditionalOrder: OrderCancelInputAdditionalOrder;
  OrderCancelInputCategoryOrder: OrderCancelInputCategoryOrder;
  OrderCancelLeisureOrderDiscount: OrderCancelLeisureOrderDiscount;
  OrderCancelLeisureOrderValid: OrderCancelLeisureOrderValid;
  OrderCancelLeisureProductOrder: OrderCancelLeisureProductOrder;
  OrderCancelLeisureProductOrderItem: OrderCancelLeisureProductOrderItem;
  OrderCancelMobileMembership: OrderCancelMobileMembership;
  OrderCancelPayment: OrderCancelPayment;
  OrderCancelPolicy: Omit<OrderCancelPolicy, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderCancelPolicyCategoryOrder']> };
  OrderCancelPolicyAdditionalOrder: Omit<OrderCancelPolicyAdditionalOrder, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderCancelPolicyCategoryOrder']> };
  OrderCancelPolicyBus: OrderCancelPolicyBus;
  OrderCancelPolicyBusReservation: OrderCancelPolicyBusReservation;
  OrderCancelPolicyCategory: ResolversParentTypes['OrderCancelPolicyBus'] | ResolversParentTypes['OrderCancelPolicyDomestic'] | ResolversParentTypes['OrderCancelPolicyLeisureProduct'] | ResolversParentTypes['OrderCancelPolicyTrain'];
  OrderCancelPolicyCategoryOrder: ResolversUnionParentTypes['OrderCancelPolicyCategoryOrder'];
  OrderCancelPolicyDiscount: OrderCancelPolicyDiscount;
  OrderCancelPolicyDiscountCoupon: OrderCancelPolicyDiscountCoupon;
  OrderCancelPolicyDomestic: OrderCancelPolicyDomestic;
  OrderCancelPolicyLeisureProduct: OrderCancelPolicyLeisureProduct;
  OrderCancelPolicyLeisureProductItem: OrderCancelPolicyLeisureProductItem;
  OrderCancelPolicyLeisureValid: OrderCancelPolicyLeisureValid;
  OrderCancelPolicyPayment: OrderCancelPolicyPayment;
  OrderCancelPolicyTrain: OrderCancelPolicyTrain;
  OrderCancelPolicyTrainTicket: OrderCancelPolicyTrainTicket;
  OrderCancelPolicyTrainTicketSeat: OrderCancelPolicyTrainTicketSeat;
  OrderCancelPrecheck: OrderCancelPrecheck;
  OrderCancelPrecheckInput: OrderCancelPrecheckInput;
  OrderCancelPrecheckInputCategoryOrder: OrderCancelPrecheckInputCategoryOrder;
  OrderCancelPreview: OrderCancelPreview;
  OrderCancelPreviewAdditionalOrder: OrderCancelPreviewAdditionalOrder;
  OrderCancelPreviewCartDiscount: OrderCancelPreviewCartDiscount;
  OrderCancelPreviewCartTrainPackageDiscount: OrderCancelPreviewCartTrainPackageDiscount;
  OrderCancelPreviewInput: OrderCancelPreviewInput;
  OrderCancelPreviewInputAdditionalOrder: OrderCancelPreviewInputAdditionalOrder;
  OrderCancelPreviewInputCategoryOrder: OrderCancelPreviewInputCategoryOrder;
  OrderCancelPreviewOrder: OrderCancelPreviewOrder;
  OrderCancelPreviewOrderDiscount: OrderCancelPreviewOrderDiscount;
  OrderCancelPreviewOrderDiscountDetails: OrderCancelPreviewOrderDiscountDetails;
  OrderCancelPreviewOrderDiscountMobileMembership: OrderCancelPreviewOrderDiscountMobileMembership;
  OrderCancelPreviewPayment: OrderCancelPreviewPayment;
  OrderCancelTrainOrder: OrderCancelTrainOrder;
  OrderCancelTrainOrderDiscount: OrderCancelTrainOrderDiscount;
  OrderCancelTrainOrderTicket: OrderCancelTrainOrderTicket;
  OrderCancelTrainOrderTicketSeatType: OrderCancelTrainOrderTicketSeatType;
  OrderDetails: Omit<OrderDetails, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderDetailsCategoryOrder']> };
  OrderDetailsBus: OrderDetailsBus;
  OrderDetailsBusCancellationBusDiscount: OrderDetailsBusCancellationBusDiscount;
  OrderDetailsBusReservation: OrderDetailsBusReservation;
  OrderDetailsBusReservationTicket: OrderDetailsBusReservationTicket;
  OrderDetailsBuyer: OrderDetailsBuyer;
  OrderDetailsCancellation: Omit<OrderDetailsCancellation, 'categoryOrders'> & { categoryOrders: Array<ResolversParentTypes['OrderDetailsCancellationCategory']> };
  OrderDetailsCancellationBus: OrderDetailsCancellationBus;
  OrderDetailsCancellationBusDiscount: OrderDetailsCancellationBusDiscount;
  OrderDetailsCancellationBusReservation: OrderDetailsCancellationBusReservation;
  OrderDetailsCancellationBusReservationTicket: OrderDetailsCancellationBusReservationTicket;
  OrderDetailsCancellationCategory: ResolversUnionParentTypes['OrderDetailsCancellationCategory'];
  OrderDetailsCancellationCategoryOrder: ResolversParentTypes['OrderDetailsCancellationBus'] | ResolversParentTypes['OrderDetailsCancellationDomestic'] | ResolversParentTypes['OrderDetailsCancellationLeisureProduct'] | ResolversParentTypes['OrderDetailsCancellationTrain'];
  OrderDetailsCancellationDiscount: OrderDetailsCancellationDiscount;
  OrderDetailsCancellationDiscountCoupon: OrderDetailsCancellationDiscountCoupon;
  OrderDetailsCancellationDomestic: OrderDetailsCancellationDomestic;
  OrderDetailsCancellationDomesticDiscount: OrderDetailsCancellationDomesticDiscount;
  OrderDetailsCancellationDomesticDiscountMobileMembership: OrderDetailsCancellationDomesticDiscountMobileMembership;
  OrderDetailsCancellationLeisureDiscount: OrderDetailsCancellationLeisureDiscount;
  OrderDetailsCancellationLeisureProduct: OrderDetailsCancellationLeisureProduct;
  OrderDetailsCancellationLeisureProductItem: OrderDetailsCancellationLeisureProductItem;
  OrderDetailsCancellationOrderDiscountCoupon: OrderDetailsCancellationOrderDiscountCoupon;
  OrderDetailsCancellationPayment: OrderDetailsCancellationPayment;
  OrderDetailsCancellationTrain: OrderDetailsCancellationTrain;
  OrderDetailsCancellationTrainDiscount: OrderDetailsCancellationTrainDiscount;
  OrderDetailsCancellationTrainPackageDiscount: OrderDetailsCancellationTrainPackageDiscount;
  OrderDetailsCancellationTrainTicket: OrderDetailsCancellationTrainTicket;
  OrderDetailsCartDiscount: OrderDetailsCartDiscount;
  OrderDetailsCategory: ResolversParentTypes['OrderDetailsBus'] | ResolversParentTypes['OrderDetailsDomestic'] | ResolversParentTypes['OrderDetailsLeisureProduct'] | ResolversParentTypes['OrderDetailsTrain'];
  OrderDetailsCategoryOrder: ResolversUnionParentTypes['OrderDetailsCategoryOrder'];
  OrderDetailsCoupon: OrderDetailsCoupon;
  OrderDetailsDiscount: OrderDetailsDiscount;
  OrderDetailsDiscountBusDiscount: OrderDetailsDiscountBusDiscount;
  OrderDetailsDomestic: OrderDetailsDomestic;
  OrderDetailsDomesticDiscount: OrderDetailsDomesticDiscount;
  OrderDetailsDomesticRatePlan: OrderDetailsDomesticRatePlan;
  OrderDetailsLeisureProduct: OrderDetailsLeisureProduct;
  OrderDetailsLeisureProductItem: OrderDetailsLeisureProductItem;
  OrderDetailsLeisureValid: OrderDetailsLeisureValid;
  OrderDetailsMobileMembership: OrderDetailsMobileMembership;
  OrderDetailsPayment: OrderDetailsPayment;
  OrderDetailsTrain: OrderDetailsTrain;
  OrderDetailsTrainCoupon: OrderDetailsTrainCoupon;
  OrderDetailsTrainPackageDiscount: OrderDetailsTrainPackageDiscount;
  OrderDetailsTrainTicket: OrderDetailsTrainTicket;
  OrderDetailsTrainTicketSeats: OrderDetailsTrainTicketSeats;
  OrderDetailsUser: OrderDetailsUser;
  OrderList: OrderList;
  OrderPaymentPolicy: OrderPaymentPolicy;
  OrdersInput: OrdersInput;
  OverviewLang: OverviewLang;
  PaymentMainPromotion: PaymentMainPromotion;
  PaymentMethodPromotion: PaymentMethodPromotion;
  PaymentMethodPromotionContent: PaymentMethodPromotionContent;
  PaymentNotice: PaymentNotice;
  PaymentPolicy: PaymentPolicy;
  PaymentPromotion: PaymentPromotion;
  PgReceiptInfo: PgReceiptInfo;
  Photos: Photos;
  PlaceMetaCouponsPayload: PlaceMetaCouponsPayload;
  PlaceMetaCouponsPayloadRequest: PlaceMetaCouponsPayloadRequest;
  PointEvent: PointEvent;
  PointItemPolicy: PointItemPolicy;
  PointLeisurePolicyInput: PointLeisurePolicyInput;
  PointPropertyPolicyInput: PointPropertyPolicyInput;
  PointServicePolicy: PointServicePolicy;
  PointTotal: PointTotal;
  PointTrainPolicyInput: PointTrainPolicyInput;
  ProductConfigCancelPolicies: ProductConfigCancelPolicies;
  ProductConfigCancelPoliciesPolicy: ProductConfigCancelPoliciesPolicy;
  ProductConfigParking: ProductConfigParking;
  ProductConfigProperty: ProductConfigProperty;
  ProductConfigPropertyControl: ProductConfigPropertyControl;
  ProductConfigRoomType: ProductConfigRoomType;
  ProductConfigRoomTypeControl: ProductConfigRoomTypeControl;
  ProductPropertyDomestic: ProductPropertyDomestic;
  ProductPropertyDomesticRatePlan: ProductPropertyDomesticRatePlan;
  ProductPropertyRoomTypeDomestic: ProductPropertyRoomTypeDomestic;
  Progress: Progress;
  PropertyBreakfast: PropertyBreakfast;
  PropertyCoupon: PropertyCoupon;
  PropertyCouponCheckProgress: PropertyCouponCheckProgress;
  PropertyCouponCheckProgressInput: PropertyCouponCheckProgressInput;
  PropertyCouponsProgress: PropertyCouponsProgress;
  PropertyCouponsProgressMeta: PropertyCouponsProgressMeta;
  PropertyCouponsResponse: PropertyCouponsResponse;
  PropertyData: PropertyData;
  QrCode: QrCode;
  Query: {};
  RatePlan: RatePlan;
  RatePlanConfig: RatePlanConfig;
  RatePlanConfigControl: RatePlanConfigControl;
  RatePlanDataRequest: RatePlanDataRequest;
  RatePlanDataRequestPersons: RatePlanDataRequestPersons;
  RatePlanDate: RatePlanDate;
  RatePlanDateOtherSetting: RatePlanDateOtherSetting;
  RatePlanInventoryInput: RatePlanInventoryInput;
  RemoveFromCart: RemoveFromCart;
  RentTimeLine: RentTimeLine;
  RequestOrderShare: RequestOrderShare;
  Reservation: Reservation;
  ReservationDetail: ReservationDetail;
  ReservationPartnerPoint: ReservationPartnerPoint;
  ReservationPolicy: ReservationPolicy;
  ReservationStockRentType: ReservationStockRentType;
  Rest: Rest;
  ReviewWritable: ReviewWritable;
  ReviewWritableParams: ReviewWritableParams;
  ReviewWritableParamsOrders: ReviewWritableParamsOrders;
  ReviewWritableParamsV2: ReviewWritableParamsV2;
  ReviewWritableResponse: ReviewWritableResponse;
  ReviewWritableResponseV2: ReviewWritableResponseV2;
  RoomList: RoomList;
  RoomTypeCamping: RoomTypeCamping;
  RoomTypeCampingZone: RoomTypeCampingZone;
  RoomTypeData: RoomTypeData;
  RoomTypeStock: RoomTypeStock;
  SalesPeriod: SalesPeriod;
  SellerInfos: SellerInfos;
  SendCertificationInput: SendCertificationInput;
  SendReceiptEmailInput: SendReceiptEmailInput;
  SendReceiptEmailTemplateDataBuyerInformationInput: SendReceiptEmailTemplateDataBuyerInformationInput;
  SendReceiptEmailTemplateDataInput: SendReceiptEmailTemplateDataInput;
  SendReceiptEmailTemplateDataOrderInput: SendReceiptEmailTemplateDataOrderInput;
  SendReceiptEmailTemplateDataPaymentInformationCouponInput: SendReceiptEmailTemplateDataPaymentInformationCouponInput;
  SendReceiptEmailTemplateDataPaymentInformationInput: SendReceiptEmailTemplateDataPaymentInformationInput;
  SendReceiptEmailTemplateDataPaymentInformationPointInput: SendReceiptEmailTemplateDataPaymentInformationPointInput;
  SendReceiptEmailTemplateDataRefundInformationInput: SendReceiptEmailTemplateDataRefundInformationInput;
  SendReceiptEmailTemplateDataUserInformationInput: SendReceiptEmailTemplateDataUserInformationInput;
  SharedOrder: Omit<SharedOrder, 'additionalCategoryOrders' | 'categoryOrders'> & { additionalCategoryOrders: Array<ResolversParentTypes['SharedOrderCategory']>, categoryOrders: Array<ResolversParentTypes['SharedOrderCategory']> };
  SharedOrderBus: SharedOrderBus;
  SharedOrderBusReservation: SharedOrderBusReservation;
  SharedOrderBusReservationTicket: SharedOrderBusReservationTicket;
  SharedOrderCategory: ResolversUnionParentTypes['SharedOrderCategory'];
  SharedOrderCategoryOrder: ResolversParentTypes['SharedOrderBus'] | ResolversParentTypes['SharedOrderDomestic'] | ResolversParentTypes['SharedOrderLeisure'] | ResolversParentTypes['SharedOrderTrain'];
  SharedOrderDomestic: SharedOrderDomestic;
  SharedOrderLeisure: SharedOrderLeisure;
  SharedOrderLeisureItem: SharedOrderLeisureItem;
  SharedOrderTrain: SharedOrderTrain;
  SharedOrderTrainTicket: SharedOrderTrainTicket;
  SharedRatePlan: SharedRatePlan;
  SingleLine: SingleLine;
  SingleStock: SingleStock;
  Sleep: Sleep;
  StarInfo: StarInfo;
  StayTypeConfigs: StayTypeConfigs;
  Stock: Stock;
  StockReservationRoomType: StockReservationRoomType;
  StockRoomType: StockRoomType;
  StockRoomTypeInput: StockRoomTypeInput;
  String: Scalars['String'];
  SubBuckets: SubBuckets;
  Themes: Themes;
  TrainStation: TrainStation;
  TransportationSearch: TransportationSearch;
  TransportationSearchCarriage: TransportationSearchCarriage;
  TransportationSearchCarriageInput: TransportationSearchCarriageInput;
  TransportationSearchCarriageSeat: TransportationSearchCarriageSeat;
  TransportationSearchCarriageSeatInput: TransportationSearchCarriageSeatInput;
  TransportationSearchFare: TransportationSearchFare;
  TransportationSearchFareInput: TransportationSearchFareInput;
  TransportationSearchInput: TransportationSearchInput;
  TransportationSearchPackageFare: TransportationSearchPackageFare;
  TransportationSearchPackageFareInput: TransportationSearchPackageFareInput;
  TransportationSearchSeat: TransportationSearchSeat;
  TransportationSearchSeatInput: TransportationSearchSeatInput;
  TransportationSearchTrain: TransportationSearchTrain;
  TransportationSearchTrainsInput: TransportationSearchTrainsInput;
  Type: Type;
  UpdateCartItem: UpdateCartItem;
  UpdateCartItemByOrderIdResponse: UpdateCartItemByOrderIdResponse;
  UpdateCartItemByOrderIdV2Response: UpdateCartItemByOrderIdV2Response;
  UpdateDomesticAccommodationOption: UpdateDomesticAccommodationOption;
  UpdateDomesticLeisureOption: UpdateDomesticLeisureOption;
  UpdateOrder: UpdateOrder;
  UpdatedProperty: UpdatedProperty;
  UseTypeInput: UseTypeInput;
  User: User;
  ValidateOrderSheetMemberClassResponse: ValidateOrderSheetMemberClassResponse;
  ValidatePropertyInput: ValidatePropertyInput;
  VariantPrice: VariantPrice;
  VariantSupplyItem: VariantSupplyItem;
  Viewer: Viewer;
  VisitorAgreements: VisitorAgreements;
  VisitorFindAgreeData: VisitorFindAgreeData;
  VisitorSaveAgreeInput: VisitorSaveAgreeInput;
  Week: Week;
  YapaymentHistoryApproval: YapaymentHistoryApproval;
  YapaymentMethod: YapaymentMethod;
  YapaymentPaymentGoodsMeta: YapaymentPaymentGoodsMeta;
  YapaymentPaymentMethodPolicy: YapaymentPaymentMethodPolicy;
  YapaymentPaymentNotice: YapaymentPaymentNotice;
  YapaymentPaymentPolicy: YapaymentPaymentPolicy;
  YapaymentPaymentPolicyInput: YapaymentPaymentPolicyInput;
  YapaymentPaymentPromotion: YapaymentPaymentPromotion;
};

export type AuthDirectiveArgs = {
  idPath?: Maybe<Array<Scalars['String']>>;
  requires: Array<Role>;
};

export type AuthDirectiveResolver<Result, Parent, ContextType = any, Args = AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AdditionalOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdditionalOrder'] = ResolversParentTypes['AdditionalOrder']> = {
  buyer?: Resolver<ResolversTypes['OrderDetailsBuyer'], ParentType, ContextType>;
  cancellations?: Resolver<Array<ResolversTypes['OrderDetailsCancellation']>, ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['OrderDetailsCategoryOrder']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCartDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['OrderDetailsPayment']>, ParentType, ContextType>;
  totalRewardAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['OrderDetailsUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressCodesResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressCodes'] = ResolversParentTypes['AddressCodes']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subBuckets?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubBuckets']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddressLang'] = ResolversParentTypes['AddressLang']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddtoCartItemsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddtoCartItemsResponse'] = ResolversParentTypes['AddtoCartItemsResponse']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AffiliationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Affiliation'] = ResolversParentTypes['Affiliation']> = {
  association?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direct?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgePolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgePolicy'] = ResolversParentTypes['AgePolicy']> = {
  child?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toddler?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Aggregations'] = ResolversParentTypes['Aggregations']> = {
  addressCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AddressCodes']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementType'] = ResolversParentTypes['AgreementType']> = {
  isPrepaymentAgreed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPrivacyAgreed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableInventoryRatePlanDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableInventoryRatePlanData'] = ResolversParentTypes['AvailableInventoryRatePlanData']> = {
  inventory?: Resolver<Array<ResolversTypes['AvailableInventoryRatePlanInventory']>, ParentType, ContextType>;
  request?: Resolver<Maybe<ResolversTypes['RatePlanDataRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableInventoryRatePlanInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableInventoryRatePlanInventory'] = ResolversParentTypes['AvailableInventoryRatePlanInventory']> = {
  availability?: Resolver<ResolversTypes['RatePlanAvailability'], ParentType, ContextType>;
  ratePlans?: Resolver<Array<ResolversTypes['RatePlan']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['RatePlanUseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableInventoryRatePlanResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableInventoryRatePlanResponse'] = ResolversParentTypes['AvailableInventoryRatePlanResponse']> = {
  code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['AvailableInventoryRatePlanData'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailablePeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailablePeriod'] = ResolversParentTypes['AvailablePeriod']> = {
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerAction'] = ResolversParentTypes['BannerAction']> = {
  app?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerImage'] = ResolversParentTypes['BannerImage']> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerLogMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerLogMeta'] = ResolversParentTypes['BannerLogMeta']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  objectType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerResponse'] = ResolversParentTypes['BannerResponse']> = {
  action?: Resolver<Maybe<ResolversTypes['BannerAction']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['BannerImage']>, ParentType, ContextType>;
  logMeta?: Resolver<Maybe<ResolversTypes['BannerLogMeta']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BedConfigurationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BedConfigurations'] = ResolversParentTypes['BedConfigurations']> = {
  bedType?: Resolver<Maybe<ResolversTypes['BedType']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BedGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BedGroups'] = ResolversParentTypes['BedGroups']> = {
  bedConfigurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['BedConfigurations']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusCancelPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusCancelPolicy'] = ResolversParentTypes['BusCancelPolicy']> = {
  endAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusCancelPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusCancelPreview'] = ResolversParentTypes['BusCancelPreview']> = {
  buses?: Resolver<Array<ResolversTypes['BusCancelPreviewType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusCancelPreviewTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusCancelPreviewType'] = ResolversParentTypes['BusCancelPreviewType']> = {
  cancelPreviews?: Resolver<Array<ResolversTypes['BusCancelPolicy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusDetail'] = ResolversParentTypes['BusDetail']> = {
  arrivalTerminalAbbreviationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalAbbreviationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fees?: Resolver<Array<ResolversTypes['BusDetailFee']>, ParentType, ContextType>;
  isReturn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transportationCompanyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tripDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusDetailFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusDetailFee'] = ResolversParentTypes['BusDetailFee']> = {
  fee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusDetailSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusDetailSeat'] = ResolversParentTypes['BusDetailSeat']> = {
  no?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusDetailTicketTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusDetailTicketType'] = ResolversParentTypes['BusDetailTicketType']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusSeat'] = ResolversParentTypes['BusSeat']> = {
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusTransportationCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusTransportationCompany'] = ResolversParentTypes['BusTransportationCompany']> = {
  abbreviationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelPolicy'] = ResolversParentTypes['CancelPolicy']> = {
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CancelPolicyType'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelPolicyBusTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelPolicyBusTicket'] = ResolversParentTypes['CancelPolicyBusTicket']> = {
  cancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nonCancelableReason?: Resolver<Maybe<ResolversTypes['BusNonCancelableReason']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderDetailsBusReservationTicketStatus'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelPolicySummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelPolicySummary'] = ResolversParentTypes['CancelPolicySummary']> = {
  cancelPolicy?: Resolver<Maybe<ResolversTypes['CancelPolicy']>, ParentType, ContextType>;
  cancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expectedCommissionAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nonCancellationReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartBusOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartBusOrder'] = ResolversParentTypes['CartBusOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['CartBusOrderReservation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartBusOrderReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartBusOrderReservation'] = ResolversParentTypes['CartBusOrderReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['CartBusOrderReservationTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartBusOrderReservationTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartBusOrderReservationTicket'] = ResolversParentTypes['CartBusOrderReservationTicket']> = {
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartBusOrderReservationTicketStatus'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartCategoryOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartCategoryOrder'] = ResolversParentTypes['CartCategoryOrder']> = {
  __resolveType: TypeResolveFn<'CartBusOrder' | 'CartDomesticOrder' | 'CartLeisureProductOrder' | 'CartTrainOrder', ParentType, ContextType>;
};

export type CartDomesticOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartDomesticOrder'] = ResolversParentTypes['CartDomesticOrder']> = {
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  cancelPolicyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayBadge?: Resolver<Maybe<ResolversTypes['MemberClassBadgeType']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPenaltyAgree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberClassDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nolChat?: Resolver<Maybe<ResolversTypes['NolChatResponse']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingStatus?: Resolver<Maybe<ResolversTypes['PendingStatus']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productConfig?: Resolver<Maybe<ResolversTypes['ProductConfigProperty']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyCategory?: Resolver<ResolversTypes['PropertyCategory'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveType?: Resolver<Maybe<ResolversTypes['ReserveType']>, ParentType, ContextType>;
  reviewWritableV2?: Resolver<Maybe<ResolversTypes['ReviewWritableResponseV2']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusGroupCode?: Resolver<ResolversTypes['StatusGroupCode'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  visitType?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLeisureOrderValidResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLeisureOrderValid'] = ResolversParentTypes['CartLeisureOrderValid']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLeisureProductOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLeisureProductOrder'] = ResolversParentTypes['CartLeisureProductOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayBadge?: Resolver<Maybe<ResolversTypes['MemberClassBadgeType']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CartLeisureProductOrderItem']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewWritableV2?: Resolver<Maybe<ResolversTypes['ReviewWritableResponseV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLeisureProductOrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLeisureProductOrderItem'] = ResolversParentTypes['CartLeisureProductOrderItem']> = {
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  encryptedVoucherData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['LeisureProduct']>, ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['CartLeisureOrderValid'], ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['LeisureProductVariant']>, ParentType, ContextType>;
  voucher?: Resolver<Maybe<ResolversTypes['CartLeisureProductOrderItemVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartLeisureProductOrderItemVoucherResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartLeisureProductOrderItemVoucher'] = ResolversParentTypes['CartLeisureProductOrderItemVoucher']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartOrder'] = ResolversParentTypes['CartOrder']> = {
  __resolveType: TypeResolveFn<'CartBusOrder' | 'CartDomesticOrder' | 'CartLeisureProductOrder' | 'CartTrainOrder', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CartOrdersResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartOrders'] = ResolversParentTypes['CartOrders']> = {
  categoryOrders?: Resolver<Array<ResolversTypes['CartCategoryOrder']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartPropertyDomesticRentTimeLinesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartPropertyDomesticRentTimeLines'] = ResolversParentTypes['CartPropertyDomesticRentTimeLines']> = {
  lastCheckInTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxUseTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeLines?: Resolver<Array<ResolversTypes['RentTimeLine']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartTrainOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartTrainOrder'] = ResolversParentTypes['CartTrainOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['CartTrainOrderTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartTrainOrderTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartTrainOrderTicket'] = ResolversParentTypes['CartTrainOrderTicket']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['CartTrainOrderTicketSeat']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CartTrainOrderTicketSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['CartTrainOrderTicketSeat'] = ResolversParentTypes['CartTrainOrderTicketSeat']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['CartTrainOrderTicketSeatDirection'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CertificationCertifyResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CertificationCertifyResult'] = ResolversParentTypes['CertificationCertifyResult']> = {
  certCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expireTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Commission'] = ResolversParentTypes['Commission']> = {
  commissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConfirmBusTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfirmBusTicket'] = ResolversParentTypes['ConfirmBusTicket']> = {
  checkedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ConstraintNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ConstraintNumber'], any> {
  name: 'ConstraintNumber';
}

export interface ConstraintStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ConstraintString'], any> {
  name: 'ConstraintString';
}

export type ContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Content'] = ResolversParentTypes['Content']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['LeisureCategory'], ParentType, ContextType>;
  commission?: Resolver<ResolversTypes['Commission'], ParentType, ContextType>;
  coverPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dealInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealIntroduce?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealPriceGroups?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  discountRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  districtHCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gajagoSalePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  gajagoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasPenalty?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hotDealYn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  images?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  isDealAppealPointUse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  location?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['Locations']>, ParentType, ContextType>;
  lon?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lowestPriceYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noticeInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['Options']>, ParentType, ContextType>;
  pictogramJson?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postReservationYn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refundInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salesPeriod?: Resolver<ResolversTypes['SalesPeriod'], ParentType, ContextType>;
  sellerInfos?: Resolver<Array<Maybe<ResolversTypes['SellerInfos']>>, ParentType, ContextType>;
  socialImages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  sortWeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  superDealWeight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  superDealYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplyYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tags?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  todayUsable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<Array<ResolversTypes['Type']>, ParentType, ContextType>;
  usageInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentThemesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentThemes'] = ResolversParentTypes['ContentThemes']> = {
  code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photos?: Resolver<Maybe<ResolversTypes['ContentThemesPhotos']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentThemesPhotosResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentThemesPhotos'] = ResolversParentTypes['ContentThemesPhotos']> = {
  available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matched?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CoordinateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Coordinate'] = ResolversParentTypes['Coordinate']> = {
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstance'] = ResolversParentTypes['CouponDomesticInstance']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicableMaxPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicableMinPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  calculatedPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinPeriod?: Resolver<Maybe<ResolversTypes['CouponDomesticInstancePeriod']>, ParentType, ContextType>;
  couponName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  couponType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  denyListGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  metaCouponId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minActualPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offeredPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeClassification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['CouponDomesticInstanceProgress']>, ParentType, ContextType>;
  roomTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['CouponSchema']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableReasons?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  usablePeriod?: Resolver<Maybe<ResolversTypes['CouponUsablePeriod']>, ParentType, ContextType>;
  useInAdvance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  week?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstancePeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstancePeriod'] = ResolversParentTypes['CouponDomesticInstancePeriod']> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endAtDayOfWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startAtDayOfWeek?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstanceProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstanceProgress'] = ResolversParentTypes['CouponDomesticInstanceProgress']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitUse?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offered?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  used?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstanceResponse'] = ResolversParentTypes['CouponDomesticInstanceResponse']> = {
  coupons?: Resolver<Array<ResolversTypes['CouponDomesticInstance']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstanceV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstanceV2'] = ResolversParentTypes['CouponDomesticInstanceV2']> = {
  allowAdditional?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  applicableMaxPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicableMinPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  applicationType?: Resolver<Maybe<ResolversTypes['DomesticCouponApplicationType']>, ParentType, ContextType>;
  calculatedPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkinPeriod?: Resolver<Maybe<ResolversTypes['CouponDomesticInstancePeriod']>, ParentType, ContextType>;
  couponName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  couponType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  denyListGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  metaCouponId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minActualPayment?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offeredPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeClassification?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['CouponDomesticInstanceProgress']>, ParentType, ContextType>;
  roomTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  schema?: Resolver<ResolversTypes['CouponSchema'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stayTypes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableReasons?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  usableDistricts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  usablePeriod?: Resolver<ResolversTypes['CouponUsablePeriod'], ParentType, ContextType>;
  useInAdvance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  usedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  week?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstances'] = ResolversParentTypes['CouponDomesticInstances']> = {
  coupons?: Resolver<Array<ResolversTypes['CouponDomesticInstance']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDomesticInstancesV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDomesticInstancesV2'] = ResolversParentTypes['CouponDomesticInstancesV2']> = {
  coupons?: Resolver<Array<ResolversTypes['CouponDomesticInstanceV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponDownloadedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponDownloaded'] = ResolversParentTypes['CouponDownloaded']> = {
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  metaCouponId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponMetadataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponMetadata'] = ResolversParentTypes['CouponMetadata']> = {
  couponTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  servicePeriod?: Resolver<ResolversTypes['CouponDomesticInstancePeriod'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformCheckProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformCheckProgress'] = ResolversParentTypes['CouponPlatformCheckProgress']> = {
  appId?: Resolver<ResolversTypes['CouponPlatformInstanceAppId'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  couponUsable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxUseCount?: Resolver<ResolversTypes['CouponPlatformCheckProgressMaxUseCount'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productIds?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  stockUsable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformCheckProgressMaxUseCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformCheckProgressMaxUseCount'] = ResolversParentTypes['CouponPlatformCheckProgressMaxUseCount']> = {
  stock?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicyStock']>, ParentType, ContextType>;
  usable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformConditionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformConditions'] = ResolversParentTypes['CouponPlatformConditions']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformDiscount'] = ResolversParentTypes['CouponPlatformDiscount']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformDownloadedResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformDownloaded'] = ResolversParentTypes['CouponPlatformDownloaded']> = {
  couponId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstance'] = ResolversParentTypes['CouponPlatformInstance']> = {
  confirmedDiscount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  couponType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceDiscount']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redemptionPolicy?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicy']>, ParentType, ContextType>;
  resource?: Resolver<ResolversTypes['CouponPlatformInstanceResource'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  violations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceDiscount'] = ResolversParentTypes['CouponPlatformInstanceDiscount']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  percentOff?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicy'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicy']> = {
  stock?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicyStock']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyCondition'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyCondition']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyConditionV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyConditionV2'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyConditionV2']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemSet?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyStock'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyStock']> = {
  remain?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyStockV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyStockV2'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyStockV2']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  remain?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceRedemptionPolicyV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyV2'] = ResolversParentTypes['CouponPlatformInstanceRedemptionPolicyV2']> = {
  conditions?: Resolver<Maybe<Array<ResolversTypes['CouponPlatformInstanceRedemptionPolicyConditionV2']>>, ParentType, ContextType>;
  maxUseCount?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicyStockV2']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicyStockV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceResource'] = ResolversParentTypes['CouponPlatformInstanceResource']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceResponse'] = ResolversParentTypes['CouponPlatformInstanceResponse']> = {
  coupons?: Resolver<Array<ResolversTypes['CouponPlatformInstance']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstanceV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstanceV2'] = ResolversParentTypes['CouponPlatformInstanceV2']> = {
  confirmedDiscount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  couponId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  couponTarget?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceDiscount']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  redemptionPolicy?: Resolver<Maybe<ResolversTypes['CouponPlatformInstanceRedemptionPolicyV2']>, ParentType, ContextType>;
  resource?: Resolver<ResolversTypes['CouponPlatformInstanceResource'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unavailableReasons?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  violations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformInstancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformInstances'] = ResolversParentTypes['CouponPlatformInstances']> = {
  coupons?: Resolver<Array<ResolversTypes['CouponPlatformInstanceV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformRedemptionPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformRedemptionPolicy'] = ResolversParentTypes['CouponPlatformRedemptionPolicy']> = {
  conditions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CouponPlatformConditions']>>>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformResource'] = ResolversParentTypes['CouponPlatformResource']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponPlatformUserCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponPlatformUserCoupon'] = ResolversParentTypes['CouponPlatformUserCoupon']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['CouponPlatformDiscount']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  redemptionPolicy?: Resolver<Maybe<ResolversTypes['CouponPlatformRedemptionPolicy']>, ParentType, ContextType>;
  resource?: Resolver<Maybe<ResolversTypes['CouponPlatformResource']>, ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponSchemaResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponSchema'] = ResolversParentTypes['CouponSchema']> = {
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yanolja?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yanow?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CouponUsablePeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['CouponUsablePeriod'] = ResolversParentTypes['CouponUsablePeriod']> = {
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DaysResolvers<ContextType = any, ParentType extends ResolversParentTypes['Days'] = ResolversParentTypes['Days']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitOffer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitUse?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomTypeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayAbleCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayBreakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpenStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  staySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  used?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepthOneResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepthOne'] = ResolversParentTypes['DepthOne']> = {
  depth_two?: Resolver<Maybe<Array<Maybe<ResolversTypes['DepthTwo']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepthThreeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepthThree'] = ResolversParentTypes['DepthThree']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepthTwoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DepthTwo'] = ResolversParentTypes['DepthTwo']> = {
  depth_three?: Resolver<Maybe<Array<Maybe<ResolversTypes['DepthThree']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Description'] = ResolversParentTypes['Description']> = {
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DescriptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Descriptions'] = ResolversParentTypes['Descriptions']> = {
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directionLang?: Resolver<Maybe<ResolversTypes['DirectionLang']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationLang?: Resolver<Maybe<ResolversTypes['LocationLang']>, ParentType, ContextType>;
  overview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overviewLang?: Resolver<Maybe<ResolversTypes['OverviewLang']>, ParentType, ContextType>;
  pickup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  transportation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectionLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectionLang'] = ResolversParentTypes['DirectionLang']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zhcn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreview'] = ResolversParentTypes['DistributionPreview']> = {
  orders?: Resolver<ResolversTypes['DistributionPreviewOrders'], ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['DistributionPreviewOrdersPayments']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrders'] = ResolversParentTypes['DistributionPreviewOrders']> = {
  domesticLeisureTicket?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersLeisure']>, ParentType, ContextType>;
  domesticReservation?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersReservation']>, ParentType, ContextType>;
  domesticTrain?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersTrain']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersDiscount'] = ResolversParentTypes['DistributionPreviewOrdersDiscount']> = {
  couponAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersLeisureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersLeisure'] = ResolversParentTypes['DistributionPreviewOrdersLeisure']> = {
  discount?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersDiscount']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['DistributionPreviewOrdersPayments']>>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersPaymentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersPayments'] = ResolversParentTypes['DistributionPreviewOrdersPayments']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersReservation'] = ResolversParentTypes['DistributionPreviewOrdersReservation']> = {
  discount?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersReservationDiscount']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['DistributionPreviewOrdersPayments']>>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersReservationDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersReservationDiscount'] = ResolversParentTypes['DistributionPreviewOrdersReservationDiscount']> = {
  couponAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mobileMembershipAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionPreviewOrdersTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['DistributionPreviewOrdersTrain'] = ResolversParentTypes['DistributionPreviewOrdersTrain']> = {
  discount?: Resolver<Maybe<ResolversTypes['DistributionPreviewOrdersDiscount']>, ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['DistributionPreviewOrdersPayments']>>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationCartItem'] = ResolversParentTypes['DomesticAccommodationCartItem']> = {
  options?: Resolver<Array<ResolversTypes['DomesticAccommodationCartItemOption']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['ProductPropertyDomestic'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationCartItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationCartItemOption'] = ResolversParentTypes['DomesticAccommodationCartItemOption']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  availability?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  childAges?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  infant?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isChosen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  itemUpdatedByMemberClass?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberClassDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originalPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  outdated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyCoupons?: Resolver<Maybe<ResolversTypes['PropertyCouponsResponse']>, ParentType, ContextType>;
  propertyCouponsProgress?: Resolver<Maybe<Array<ResolversTypes['PropertyCouponsProgress']>>, ParentType, ContextType>;
  ratePlan?: Resolver<ResolversTypes['DomesticAccommodationCartItemOptionRatePlan'], ParentType, ContextType>;
  ratePlanConfig?: Resolver<ResolversTypes['RatePlanConfig'], ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomType?: Resolver<ResolversTypes['ProductPropertyRoomTypeDomestic'], ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  surcharges?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['CartItemOptionUnavailableReason']>, ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationCartItemOptionHotDealResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationCartItemOptionHotDeal'] = ResolversParentTypes['DomesticAccommodationCartItemOptionHotDeal']> = {
  discountRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationCartItemOptionRatePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationCartItemOptionRatePlan'] = ResolversParentTypes['DomesticAccommodationCartItemOptionRatePlan']> = {
  benefitList?: Resolver<Array<ResolversTypes['DomesticRatePlanBenefits']>, ParentType, ContextType>;
  hotDeal?: Resolver<ResolversTypes['DomesticAccommodationCartItemOptionHotDeal'], ParentType, ContextType>;
  isExceptionalCancelPolicy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationCartSingleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationCartSingleItem'] = ResolversParentTypes['DomesticAccommodationCartSingleItem']> = {
  option?: Resolver<ResolversTypes['DomesticAccommodationCartItemOption'], ParentType, ContextType>;
  property?: Resolver<ResolversTypes['ProductPropertyDomestic'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticAccommodationUserCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticAccommodationUserCoupon'] = ResolversParentTypes['DomesticAccommodationUserCoupon']> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  applicableMaxPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicableMinPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  denyListGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxDiscountPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaCouponId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minActualPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offeredPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeClassification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  roomTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['CouponSchema']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  usablePeriod?: Resolver<Maybe<ResolversTypes['CouponUsablePeriod']>, ParentType, ContextType>;
  useInAdvance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPlaceNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usedPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  week?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticBusCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticBusCartItem'] = ResolversParentTypes['DomesticBusCartItem']> = {
  options?: Resolver<Array<ResolversTypes['DomesticBusCartItemOption']>, ParentType, ContextType>;
  representativeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticBusCartItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticBusCartItemOption'] = ResolversParentTypes['DomesticBusCartItemOption']> = {
  availability?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['CouponPlatformInstanceV2']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isChosen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  outdated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  remains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['DomesticBusCartItemOptionReservation']>, ParentType, ContextType>;
  roundTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['CartItemOptionUnavailableReason']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticBusCartItemOptionReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticBusCartItemOptionReservation'] = ResolversParentTypes['DomesticBusCartItemOptionReservation']> = {
  allocationArrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  allocationDepartureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  allocationDepartureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['BusSeat']>, ParentType, ContextType>;
  totalSeats?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticBusCartSingleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticBusCartSingleItem'] = ResolversParentTypes['DomesticBusCartSingleItem']> = {
  option?: Resolver<ResolversTypes['DomesticBusCartItemOption'], ParentType, ContextType>;
  representativeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticDailyPricesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticDailyPrices'] = ResolversParentTypes['DomesticDailyPrices']> = {
  partialCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stayDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticLeisureCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticLeisureCartItem'] = ResolversParentTypes['DomesticLeisureCartItem']> = {
  dealId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['DomesticLeisureCartItemOption']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticLeisureCartItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticLeisureCartItemOption'] = ResolversParentTypes['DomesticLeisureCartItemOption']> = {
  availability?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['CouponPlatformInstanceV2']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isChosen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  leisureOptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  leisureOptionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outdated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantityLimitPerOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['CartItemOptionUnavailableReason']>, ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticLeisureCartSingleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticLeisureCartSingleItem'] = ResolversParentTypes['DomesticLeisureCartSingleItem']> = {
  dealId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  option?: Resolver<ResolversTypes['DomesticLeisureCartItemOption'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticPropertySearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticPropertySearch'] = ResolversParentTypes['DomesticPropertySearch']> = {
  aggregations?: Resolver<Maybe<ResolversTypes['Aggregations']>, ParentType, ContextType>;
  hits?: Resolver<Array<ResolversTypes['Hits']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticRatePlanBenefitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticRatePlanBenefits'] = ResolversParentTypes['DomesticRatePlanBenefits']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DomesticRatePlanBenefitType'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticTrainCartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticTrainCartItem'] = ResolversParentTypes['DomesticTrainCartItem']> = {
  options?: Resolver<Array<ResolversTypes['DomesticTrainCartItemOption']>, ParentType, ContextType>;
  representativeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticTrainCartItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticTrainCartItemOption'] = ResolversParentTypes['DomesticTrainCartItemOption']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  availability?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  child?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['CouponPlatformInstanceV2']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isChosen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  outdated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  remains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roundTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trains?: Resolver<Array<ResolversTypes['DomesticTrainCartItemTicket']>, ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['CartItemOptionUnavailableReason']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticTrainCartItemOptionTicketSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticTrainCartItemOptionTicketSeat'] = ResolversParentTypes['DomesticTrainCartItemOptionTicketSeat']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticTrainCartItemTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticTrainCartItemTicket'] = ResolversParentTypes['DomesticTrainCartItemTicket']> = {
  adultFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  childFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsGroupItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsGroupSequenceNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  packageDiscount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  runningDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seats?: Resolver<Maybe<Array<ResolversTypes['DomesticTrainCartItemOptionTicketSeat']>>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DomesticTrainCartSingleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DomesticTrainCartSingleItem'] = ResolversParentTypes['DomesticTrainCartSingleItem']> = {
  option?: Resolver<ResolversTypes['DomesticTrainCartItemOption'], ParentType, ContextType>;
  representativeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpectedRewardResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpectedReward'] = ResolversParentTypes['ExpectedReward']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HitsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Hits'] = ResolversParentTypes['Hits']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  areaCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  areaPropertyNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  associateLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  association?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  authZoneType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageQualityScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  ballonZoneType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bestPick?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  bestPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  breakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breakfast?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  chargeAlertType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentsType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponAround?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponMyRoomDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponMyRoomRent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponMyRoomStay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponRent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponStay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysAgree?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  directions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventTitles?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extraPoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  franchiseType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  happycall?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hotDeal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  introduction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iot?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  luckyBox?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mildWild?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  myRoom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  myRoomRentSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  myRoomStaySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  newCategory?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newHotDeal?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newHotDealRentDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  newHotDealStayDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  no?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ownerReplyCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  partnershipType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photoNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickup?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  placeEvent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  property?: Resolver<ResolversTypes['ProductPropertyDomestic'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qaType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qualityScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registerdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentAgree?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentMinUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveDaysDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveDaysPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveDaysUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveEarly?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservePublished?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveRentDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveRentMaxUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveRentPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveRentUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveStayDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveStayPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveStayUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reviewsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serviceType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortNotice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smartStay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayAgree?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  staySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subwayNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  todayCancel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yellowId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ICartItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ICartItem'] = ResolversParentTypes['ICartItem']> = {
  __resolveType: TypeResolveFn<'DomesticAccommodationCartItem' | 'DomesticBusCartItem' | 'DomesticLeisureCartItem' | 'DomesticTrainCartItem', ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['ICartItemOption']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
};

export type ICartItemOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ICartItemOption'] = ResolversParentTypes['ICartItemOption']> = {
  __resolveType: TypeResolveFn<'DomesticAccommodationCartItemOption' | 'DomesticBusCartItemOption' | 'DomesticLeisureCartItemOption' | 'DomesticTrainCartItemOption', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isChosen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  remains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type ICartSingleItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ICartSingleItem'] = ResolversParentTypes['ICartSingleItem']> = {
  __resolveType: TypeResolveFn<'DomesticAccommodationCartSingleItem' | 'DomesticBusCartSingleItem' | 'DomesticLeisureCartSingleItem' | 'DomesticTrainCartSingleItem', ParentType, ContextType>;
  option?: Resolver<ResolversTypes['ICartItemOption'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
};

export type InformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Information'] = ResolversParentTypes['Information']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Items'] = ResolversParentTypes['Items']> = {
  availablePeriod?: Resolver<Maybe<ResolversTypes['AvailablePeriod']>, ParentType, ContextType>;
  costPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pinType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pqlat?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pqlpp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerInfoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type LeisureAdditionalPurchaseProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureAdditionalPurchaseProduct'] = ResolversParentTypes['LeisureAdditionalPurchaseProduct']> = {
  productId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureAdditionalPurchaseVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureAdditionalPurchaseVerification'] = ResolversParentTypes['LeisureAdditionalPurchaseVerification']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureBodyResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureBody'] = ResolversParentTypes['LeisureBody']> = {
  content?: Resolver<Array<ResolversTypes['Content']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalElements?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureCancellationFeePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureCancellationFeePlan'] = ResolversParentTypes['LeisureCancellationFeePlan']> = {
  cancellationFeeTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancellationTypeCode?: Resolver<ResolversTypes['CancellationTypeCode'], ParentType, ContextType>;
  endDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureCategory'] = ResolversParentTypes['LeisureCategory']> = {
  depth_one?: Resolver<Maybe<Array<Maybe<ResolversTypes['DepthOne']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureHeaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureHeader'] = ResolversParentTypes['LeisureHeader']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProduct'] = ResolversParentTypes['LeisureProduct']> = {
  additionalPurchaseProduct?: Resolver<Maybe<ResolversTypes['LeisureAdditionalPurchaseProduct']>, ParentType, ContextType>;
  braze?: Resolver<Maybe<ResolversTypes['LeisureProductBraze']>, ParentType, ContextType>;
  facilities?: Resolver<Array<ResolversTypes['LeisureProductFacility']>, ParentType, ContextType>;
  isCancelPenalty?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMemberOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memberOnlyLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partners?: Resolver<Array<ResolversTypes['LeisureProductPartner']>, ParentType, ContextType>;
  productEvent?: Resolver<Maybe<ResolversTypes['LeisureProductEvent']>, ParentType, ContextType>;
  productGroup?: Resolver<Maybe<ResolversTypes['LeisureProductGroup']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productImage?: Resolver<ResolversTypes['LeisureProductImage'], ParentType, ContextType>;
  productInfo?: Resolver<Maybe<ResolversTypes['LeisureProductInfo']>, ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productOptionGroups?: Resolver<Maybe<Array<ResolversTypes['LeisureProductOptionGroup']>>, ParentType, ContextType>;
  productPromotions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  productStatusCode?: Resolver<ResolversTypes['LeisureProductStatusCode'], ParentType, ContextType>;
  productStatusCodeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypeCode?: Resolver<ResolversTypes['ProductTypeCode'], ParentType, ContextType>;
  productTypeCodeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purchaseOptionTypeCode?: Resolver<ResolversTypes['PurchaseOptionTypeCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductBrazeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductBraze'] = ResolversParentTypes['LeisureProductBraze']> = {
  categoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cityDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductDetailInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductDetailInfo'] = ResolversParentTypes['LeisureProductDetailInfo']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subContents?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductEvent'] = ResolversParentTypes['LeisureProductEvent']> = {
  endDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productEventTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productEventTypeCodeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductFacilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductFacility'] = ResolversParentTypes['LeisureProductFacility']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  facilityInfo?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  facilityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isRepFacility?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductGroup'] = ResolversParentTypes['LeisureProductGroup']> = {
  productGroupId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductImage'] = ResolversParentTypes['LeisureProductImage']> = {
  detailImageUrls?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rollingImageUrls?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnailImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductInfo'] = ResolversParentTypes['LeisureProductInfo']> = {
  refundInfo?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  serviceCenterInfo?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  usageInfo?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductOptionGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductOptionGroup'] = ResolversParentTypes['LeisureProductOptionGroup']> = {
  productOptionGroupId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  productOptionGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductPartnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductPartner'] = ResolversParentTypes['LeisureProductPartner']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  businessRegistrationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mailOrderSalesNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  representativeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureProductVariantResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureProductVariant'] = ResolversParentTypes['LeisureProductVariant']> = {
  cancellationFeePlans?: Resolver<Array<ResolversTypes['LeisureCancellationFeePlan']>, ParentType, ContextType>;
  isAvailableOnPurchaseDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRefundableAfterExpiration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isVoucherPageProvided?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memberClassBadgeTypeCode?: Resolver<ResolversTypes['MemberClassBadgeType'], ParentType, ContextType>;
  memberClassTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productOptionGroup?: Resolver<ResolversTypes['LeisureProductOptionGroup'], ParentType, ContextType>;
  quantityPerPerson?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantityPerPersonValidityDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantityPerPurchase?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refundApprovalTypeCode?: Resolver<ResolversTypes['RefundApprovalTypeCode'], ParentType, ContextType>;
  refundAvailableDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleEndDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleStartDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validityDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  validityEndDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validityPeriodTypeCode?: Resolver<ResolversTypes['ValidityPeriodTypeCode'], ParentType, ContextType>;
  validityStartDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variantDescription?: Resolver<Maybe<Array<ResolversTypes['LeisureProductDetailInfo']>>, ParentType, ContextType>;
  variantId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variantName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  variantPrice?: Resolver<ResolversTypes['VariantPrice'], ParentType, ContextType>;
  variantStatusCode?: Resolver<ResolversTypes['LeisureProductStatusCode'], ParentType, ContextType>;
  variantStatusCodeLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variantSupplyItems?: Resolver<Array<ResolversTypes['VariantSupplyItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureSearch'] = ResolversParentTypes['LeisureSearch']> = {
  body?: Resolver<ResolversTypes['LeisureBody'], ParentType, ContextType>;
  header?: Resolver<ResolversTypes['LeisureHeader'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureqProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureqProductItem'] = ResolversParentTypes['LeisureqProductItem']> = {
  availableForSale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  availablePeriod?: Resolver<Maybe<ResolversTypes['LeisureqProductPeriod']>, ParentType, ContextType>;
  children?: Resolver<Maybe<Array<Maybe<ResolversTypes['LeisureqProductOptionItem']>>>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiredType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitPerOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundableAfterExpiry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  salesPeriod?: Resolver<Maybe<ResolversTypes['LeisureqProductPeriod']>, ParentType, ContextType>;
  settlementPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureqProductOptionItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureqProductOptionItem'] = ResolversParentTypes['LeisureqProductOptionItem']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeisureqProductPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['LeisureqProductPeriod'] = ResolversParentTypes['LeisureqProductPeriod']> = {
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkageTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkageType'] = ResolversParentTypes['LinkageType']> = {
  NOL?: Resolver<ResolversTypes['NolMemberInfoType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocationLang'] = ResolversParentTypes['LocationLang']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zhcn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Locations'] = ResolversParentTypes['Locations']> = {
  depth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Managements'] = ResolversParentTypes['Managements']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MemberClassItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberClassItem'] = ResolversParentTypes['MemberClassItem']> = {
  appliedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  classTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstConfirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstUpgradedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MemberGatewayCiDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberGatewayCIData'] = ResolversParentTypes['MemberGatewayCIData']> = {
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MemberGatewayMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberGatewayMembership'] = ResolversParentTypes['MemberGatewayMembership']> = {
  data?: Resolver<Maybe<ResolversTypes['MemberGatewayMembershipData']>, ParentType, ContextType>;
  memberNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  option?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MemberGatewayMembershipDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberGatewayMembershipData'] = ResolversParentTypes['MemberGatewayMembershipData']> = {
  birth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MemberInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MemberInfo'] = ResolversParentTypes['MemberInfo']> = {
  agreement?: Resolver<Maybe<ResolversTypes['AgreementType']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkage?: Resolver<ResolversTypes['LinkageType'], ParentType, ContextType>;
  memberNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addToCart?: Resolver<ResolversTypes['AddtoCartItemsResponse'], ParentType, ContextType, RequireFields<MutationAddToCartArgs, 'input'>>;
  confirmBusTicket?: Resolver<ResolversTypes['ConfirmBusTicket'], ParentType, ContextType, RequireFields<MutationConfirmBusTicketArgs, 'input'>>;
  couponDomesticInstances?: Resolver<Array<ResolversTypes['CouponDomesticInstances']>, ParentType, ContextType, RequireFields<MutationCouponDomesticInstancesArgs, 'input'>>;
  couponDomesticInstancesV2?: Resolver<Array<ResolversTypes['CouponDomesticInstancesV2']>, ParentType, ContextType, RequireFields<MutationCouponDomesticInstancesV2Args, 'input'>>;
  couponPlatformCheckProgress?: Resolver<Array<ResolversTypes['CouponPlatformCheckProgress']>, ParentType, ContextType, RequireFields<MutationCouponPlatformCheckProgressArgs, 'input'>>;
  couponPlatformDownloadCoupons?: Resolver<Array<ResolversTypes['CouponPlatformDownloaded']>, ParentType, ContextType, RequireFields<MutationCouponPlatformDownloadCouponsArgs, 'input'>>;
  couponPlatformInstances?: Resolver<Array<ResolversTypes['CouponPlatformInstances']>, ParentType, ContextType, RequireFields<MutationCouponPlatformInstancesArgs, 'input'>>;
  downloadCoupons?: Resolver<Array<ResolversTypes['CouponDownloaded']>, ParentType, ContextType, RequireFields<MutationDownloadCouponsArgs, 'inputs'>>;
  memberUpdateMember?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationMemberUpdateMemberArgs, 'input'>>;
  memberUpdatePhoneNum?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationMemberUpdatePhoneNumArgs, 'input'>>;
  orderCancelV3?: Resolver<ResolversTypes['OrderCancel'], ParentType, ContextType, RequireFields<MutationOrderCancelV3Args, 'cancelDetails' | 'orderId'>>;
  orderHide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationOrderHideArgs, 'orderId'>>;
  precheckOrderCancel?: Resolver<Maybe<ResolversTypes['OrderCancelPrecheck']>, ParentType, ContextType, RequireFields<MutationPrecheckOrderCancelArgs, 'param'>>;
  propertyCouponCheckProgress?: Resolver<Array<ResolversTypes['PropertyCouponCheckProgress']>, ParentType, ContextType, RequireFields<MutationPropertyCouponCheckProgressArgs, 'input'>>;
  removeFromCart?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRemoveFromCartArgs, 'input'>>;
  requestOrderShare?: Resolver<ResolversTypes['RequestOrderShare'], ParentType, ContextType, RequireFields<MutationRequestOrderShareArgs, 'orderId'>>;
  requestSendKinesisLog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationRequestSendKinesisLogArgs, 'data' | 'eventName'>>;
  saveVisitorAgree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSaveVisitorAgreeArgs, 'input'>>;
  sendCertification?: Resolver<ResolversTypes['CertificationCertifyResult'], ParentType, ContextType, RequireFields<MutationSendCertificationArgs, 'input'>>;
  sendReceiptEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendReceiptEmailArgs, 'input'>>;
  serverCurrentAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  storeMembership?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationStoreMembershipArgs, 'data' | 'option'>>;
  updateCartItem?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationUpdateCartItemArgs, 'input'>>;
  updateCartItemByOptionId?: Resolver<ResolversTypes['UpdateCartItemByOrderIdResponse'], ParentType, ContextType, RequireFields<MutationUpdateCartItemByOptionIdArgs, 'input'>>;
  updateCartItemByOptionIdV2?: Resolver<ResolversTypes['UpdateCartItemByOrderIdV2Response'], ParentType, ContextType, RequireFields<MutationUpdateCartItemByOptionIdV2Args, 'input'>>;
  updateVisitorSessionName?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<MutationUpdateVisitorSessionNameArgs>>;
};

export type NameLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['NameLang'] = ResolversParentTypes['NameLang']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zhcn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NolChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NolChatResponse'] = ResolversParentTypes['NolChatResponse']> = {
  isAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  validInvitation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NolMemberInfoTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NolMemberInfoType'] = ResolversParentTypes['NolMemberInfoType']> = {
  achievementMonth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  affiliationAgreedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardMemberNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAchieved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAgreeAffiliation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLinked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNoTrackRecord?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  modifiedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NoticesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notices'] = ResolversParentTypes['Notices']> = {
  benefit?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  event?: Resolver<Maybe<Array<Maybe<ResolversTypes['Event']>>>, ParentType, ContextType>;
  information?: Resolver<Maybe<Array<Maybe<ResolversTypes['Information']>>>, ParentType, ContextType>;
  reservation?: Resolver<Maybe<Array<Maybe<ResolversTypes['Reservation']>>>, ParentType, ContextType>;
  singleLine?: Resolver<Maybe<Array<Maybe<ResolversTypes['SingleLine']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Options'] = ResolversParentTypes['Options']> = {
  availablePeriod?: Resolver<Maybe<ResolversTypes['AvailablePeriod']>, ParentType, ContextType>;
  canExpiredRefund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  costPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coverPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountedGajagoSalePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiredType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gajagoSalePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Items']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerMarginPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  refundType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesPeriod?: Resolver<Maybe<ResolversTypes['SalesPeriod']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stockMgtYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplyYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancel'] = ResolversParentTypes['OrderCancel']> = {
  additionalOrders?: Resolver<Maybe<Array<ResolversTypes['OrderCancelAdditionalOrder']>>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['OrderCancelCategory']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelCartDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPayment']>>, ParentType, ContextType>;
  requestedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelAdditionalOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelAdditionalOrder'] = ResolversParentTypes['OrderCancelAdditionalOrder']> = {
  categoryOrders?: Resolver<Array<ResolversTypes['OrderCancelCategory']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelBusDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelBusDiscount'] = ResolversParentTypes['OrderCancelBusDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['OrderDetailsCancellationBusDiscountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelBusOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelBusOrder'] = ResolversParentTypes['OrderCancelBusOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelBusOrderDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['OrderCancelBusOrderReservation']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelBusOrderDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelBusOrderDiscount'] = ResolversParentTypes['OrderCancelBusOrderDiscount']> = {
  busDiscount?: Resolver<Maybe<ResolversTypes['OrderCancelBusDiscount']>, ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['OrderCancelCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelBusOrderReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelBusOrderReservation'] = ResolversParentTypes['OrderCancelBusOrderReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderCancelBusOrderReservationTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelBusOrderReservationTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelBusOrderReservationTicket'] = ResolversParentTypes['OrderCancelBusOrderReservationTicket']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelCartDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelCartDiscount'] = ResolversParentTypes['OrderCancelCartDiscount']> = {
  package?: Resolver<Maybe<ResolversTypes['OrderCancelCartTrainPackageDiscount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelCartTrainPackageDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelCartTrainPackageDiscount'] = ResolversParentTypes['OrderCancelCartTrainPackageDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelCategory'] = ResolversParentTypes['OrderCancelCategory']> = {
  __resolveType: TypeResolveFn<'OrderCancelBusOrder' | 'OrderCancelDomesticOrder' | 'OrderCancelLeisureProductOrder' | 'OrderCancelTrainOrder', ParentType, ContextType>;
};

export type OrderCancelCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelCoupon'] = ResolversParentTypes['OrderCancelCoupon']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['DomesticAccommodationUserCoupon']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userCoupon?: Resolver<Maybe<ResolversTypes['CouponPlatformUserCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelDomesticOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelDomesticOrder'] = ResolversParentTypes['OrderCancelDomesticOrder']> = {
  adults?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  childrenAges?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelDomesticOrderDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingStatus?: Resolver<Maybe<ResolversTypes['PendingStatus']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyCategory?: Resolver<Maybe<ResolversTypes['PropertyCategory']>, ParentType, ContextType>;
  propertyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  propertyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  propertyVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomTypeVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusGroupCode?: Resolver<Maybe<ResolversTypes['StatusGroupCode']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  visitType?: Resolver<Maybe<ResolversTypes['VisitType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelDomesticOrderDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelDomesticOrderDiscount'] = ResolversParentTypes['OrderCancelDomesticOrderDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderCancelCoupon']>, ParentType, ContextType>;
  mobileMembership?: Resolver<Maybe<ResolversTypes['OrderCancelMobileMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelLeisureOrderDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelLeisureOrderDiscount'] = ResolversParentTypes['OrderCancelLeisureOrderDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderCancelCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelLeisureOrderValidResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelLeisureOrderValid'] = ResolversParentTypes['OrderCancelLeisureOrderValid']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelLeisureProductOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelLeisureProductOrder'] = ResolversParentTypes['OrderCancelLeisureProductOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelLeisureOrderDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderCancelLeisureProductOrderItem']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelLeisureProductOrderItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelLeisureProductOrderItem'] = ResolversParentTypes['OrderCancelLeisureProductOrderItem']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['OrderCancelLeisureOrderValid'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelMobileMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelMobileMembership'] = ResolversParentTypes['OrderCancelMobileMembership']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['MobileMembershipType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPayment'] = ResolversParentTypes['OrderCancelPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['YapaymentMethod'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicy'] = ResolversParentTypes['OrderCancelPolicy']> = {
  additionalOrders?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPolicyAdditionalOrder']>>, ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['OrderCancelPolicyCategoryOrder']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelPolicyDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partialCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPolicyPayment']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyAdditionalOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyAdditionalOrder'] = ResolversParentTypes['OrderCancelPolicyAdditionalOrder']> = {
  categoryOrders?: Resolver<Array<ResolversTypes['OrderCancelPolicyCategoryOrder']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  partialCancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyBusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyBus'] = ResolversParentTypes['OrderCancelPolicyBus']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['OrderCancelPolicyBusReservation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyBusReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyBusReservation'] = ResolversParentTypes['OrderCancelPolicyBusReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelPolicy?: Resolver<Maybe<ResolversTypes['BusCancelPolicy']>, ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['CancelPolicyBusTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyCategory'] = ResolversParentTypes['OrderCancelPolicyCategory']> = {
  __resolveType: TypeResolveFn<'OrderCancelPolicyBus' | 'OrderCancelPolicyDomestic' | 'OrderCancelPolicyLeisureProduct' | 'OrderCancelPolicyTrain', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderCancelPolicyCategoryOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyCategoryOrder'] = ResolversParentTypes['OrderCancelPolicyCategoryOrder']> = {
  __resolveType: TypeResolveFn<'OrderCancelPolicyBus' | 'OrderCancelPolicyDomestic' | 'OrderCancelPolicyLeisureProduct' | 'OrderCancelPolicyTrain', ParentType, ContextType>;
};

export type OrderCancelPolicyDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyDiscount'] = ResolversParentTypes['OrderCancelPolicyDiscount']> = {
  coupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderCancelPolicyDiscountCoupon']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyDiscountCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyDiscountCoupon'] = ResolversParentTypes['OrderCancelPolicyDiscountCoupon']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyDomestic'] = ResolversParentTypes['OrderCancelPolicyDomestic']> = {
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  cancelPolicies?: Resolver<ResolversTypes['ProductConfigCancelPolicies'], ParentType, ContextType>;
  cancelPolicy?: Resolver<Maybe<ResolversTypes['CancelPolicy']>, ParentType, ContextType>;
  cancelPolicyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nonCancellationReason?: Resolver<Maybe<ResolversTypes['NonCancellationReason']>, ParentType, ContextType>;
  pendingStatus?: Resolver<Maybe<ResolversTypes['PendingStatus']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyCategory?: Resolver<ResolversTypes['PropertyCategory'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusGroupCode?: Resolver<Maybe<ResolversTypes['StatusGroupCode']>, ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  visitType?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyLeisureProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyLeisureProduct'] = ResolversParentTypes['OrderCancelPolicyLeisureProduct']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderCancelPolicyLeisureProductItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyLeisureProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyLeisureProductItem'] = ResolversParentTypes['OrderCancelPolicyLeisureProductItem']> = {
  cancelPolicy?: Resolver<Maybe<ResolversTypes['CancelPolicy']>, ParentType, ContextType>;
  cancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nonCancellationReason?: Resolver<Maybe<ResolversTypes['NonCancellationReason']>, ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['OrderCancelPolicyLeisureValid'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyLeisureValidResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyLeisureValid'] = ResolversParentTypes['OrderCancelPolicyLeisureValid']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyPayment'] = ResolversParentTypes['OrderCancelPolicyPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['YapaymentMethod'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyTrain'] = ResolversParentTypes['OrderCancelPolicyTrain']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderCancelPolicyTrainTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyTrainTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyTrainTicket'] = ResolversParentTypes['OrderCancelPolicyTrainTicket']> = {
  adultFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelPolicy?: Resolver<Maybe<ResolversTypes['CancelPolicy']>, ParentType, ContextType>;
  cancelable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  childFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsReservationNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nonCancellationReason?: Resolver<Maybe<ResolversTypes['NonCancellationReason']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  runningDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['OrderCancelPolicyTrainTicketSeat']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPolicyTrainTicketSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPolicyTrainTicketSeat'] = ResolversParentTypes['OrderCancelPolicyTrainTicketSeat']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['CartTrainOrderTicketSeatDirection'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPrecheckResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPrecheck'] = ResolversParentTypes['OrderCancelPrecheck']> = {
  cancellable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreview'] = ResolversParentTypes['OrderCancelPreview']> = {
  additionalOrders?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPreviewAdditionalOrder']>>, ParentType, ContextType>;
  categoryOrders?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPreviewOrder']>>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelPreviewCartDiscount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPreviewPayment']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewAdditionalOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewAdditionalOrder'] = ResolversParentTypes['OrderCancelPreviewAdditionalOrder']> = {
  categoryOrders?: Resolver<Array<ResolversTypes['OrderCancelPreviewOrder']>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelPreviewCartDiscount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['OrderCancelPreviewPayment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewCartDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewCartDiscount'] = ResolversParentTypes['OrderCancelPreviewCartDiscount']> = {
  package?: Resolver<Maybe<ResolversTypes['OrderCancelPreviewCartTrainPackageDiscount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewCartTrainPackageDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewCartTrainPackageDiscount'] = ResolversParentTypes['OrderCancelPreviewCartTrainPackageDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewOrder'] = ResolversParentTypes['OrderCancelPreviewOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelPreviewOrderDiscount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewOrderDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewOrderDiscount'] = ResolversParentTypes['OrderCancelPreviewOrderDiscount']> = {
  busDiscount?: Resolver<Maybe<ResolversTypes['OrderCancelBusDiscount']>, ParentType, ContextType>;
  coupons?: Resolver<Maybe<Array<ResolversTypes['OrderCancelPreviewOrderDiscountDetails']>>, ParentType, ContextType>;
  mobileMembership?: Resolver<Maybe<ResolversTypes['OrderCancelPreviewOrderDiscountMobileMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewOrderDiscountDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewOrderDiscountDetails'] = ResolversParentTypes['OrderCancelPreviewOrderDiscountDetails']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['DomesticAccommodationUserCoupon']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userCoupon?: Resolver<Maybe<ResolversTypes['CouponPlatformUserCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewOrderDiscountMobileMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewOrderDiscountMobileMembership'] = ResolversParentTypes['OrderCancelPreviewOrderDiscountMobileMembership']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MobileMembershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelPreviewPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelPreviewPayment'] = ResolversParentTypes['OrderCancelPreviewPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['YapaymentMethod'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelTrainOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelTrainOrder'] = ResolversParentTypes['OrderCancelTrainOrder']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderCancelTrainOrderDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderCancelTrainOrderTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelTrainOrderDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelTrainOrderDiscount'] = ResolversParentTypes['OrderCancelTrainOrderDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderCancelCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelTrainOrderTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelTrainOrderTicket'] = ResolversParentTypes['OrderCancelTrainOrderTicket']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['OrderCancelTrainOrderTicketSeatType']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderCancelTrainOrderTicketSeatTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCancelTrainOrderTicketSeatType'] = ResolversParentTypes['OrderCancelTrainOrderTicketSeatType']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['CartTrainOrderTicketSeatDirection'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetails'] = ResolversParentTypes['OrderDetails']> = {
  additionalOrders?: Resolver<Array<ResolversTypes['AdditionalOrder']>, ParentType, ContextType>;
  benefitCode?: Resolver<Maybe<ResolversTypes['MemberClassBenefitCode']>, ParentType, ContextType>;
  buyer?: Resolver<ResolversTypes['OrderDetailsBuyer'], ParentType, ContextType>;
  cancellations?: Resolver<Array<ResolversTypes['OrderDetailsCancellation']>, ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['OrderDetailsCategoryOrder']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCartDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['OrderDetailsPayment']>, ParentType, ContextType>;
  totalRewardAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['OrderDetailsUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsBusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsBus'] = ResolversParentTypes['OrderDetailsBus']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['OrderDetailsBusReservation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsBusCancellationBusDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsBusCancellationBusDiscount'] = ResolversParentTypes['OrderDetailsBusCancellationBusDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['OrderDetailsCancellationBusDiscountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsBusReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsBusReservation'] = ResolversParentTypes['OrderDetailsBusReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  boardingNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  routerReservationNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderDetailsBusReservationTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsBusReservationTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsBusReservationTicket'] = ResolversParentTypes['OrderDetailsBusReservationTicket']> = {
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  confirm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  qrGenNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routerTicketNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderDetailsBusReservationTicketStatus'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsBuyerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsBuyer'] = ResolversParentTypes['OrderDetailsBuyer']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellation'] = ResolversParentTypes['OrderDetailsCancellation']> = {
  cancelCause?: Resolver<ResolversTypes['CancelCause'], ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['OrderDetailsCancellationCategory']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationDiscount']>, ParentType, ContextType>;
  itemCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payments?: Resolver<Array<ResolversTypes['OrderDetailsCancellationPayment']>, ParentType, ContextType>;
  reasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reasonDetail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  representativeGoodsName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderDetailsCancellationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationBusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationBus'] = ResolversParentTypes['OrderDetailsCancellationBus']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationBusDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['OrderDetailsCancellationBusReservation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationBusDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationBusDiscount'] = ResolversParentTypes['OrderDetailsCancellationBusDiscount']> = {
  busDiscount?: Resolver<Maybe<ResolversTypes['OrderDetailsBusCancellationBusDiscount']>, ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCancellationOrderDiscountCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationBusReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationBusReservation'] = ResolversParentTypes['OrderDetailsCancellationBusReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  boardingNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderDetailsCancellationBusReservationTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationBusReservationTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationBusReservationTicket'] = ResolversParentTypes['OrderDetailsCancellationBusReservationTicket']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  confirm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderDetailsCancellationBusReservationTicketStatus'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationCategory'] = ResolversParentTypes['OrderDetailsCancellationCategory']> = {
  __resolveType: TypeResolveFn<'OrderDetailsCancellationBus' | 'OrderDetailsCancellationDomestic' | 'OrderDetailsCancellationLeisureProduct' | 'OrderDetailsCancellationTrain', ParentType, ContextType>;
};

export type OrderDetailsCancellationCategoryOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationCategoryOrder'] = ResolversParentTypes['OrderDetailsCancellationCategoryOrder']> = {
  __resolveType: TypeResolveFn<'OrderDetailsCancellationBus' | 'OrderDetailsCancellationDomestic' | 'OrderDetailsCancellationLeisureProduct' | 'OrderDetailsCancellationTrain', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderDetailsCancellationDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationDiscount'] = ResolversParentTypes['OrderDetailsCancellationDiscount']> = {
  coupons?: Resolver<Maybe<Array<ResolversTypes['OrderDetailsCancellationDiscountCoupon']>>, ParentType, ContextType>;
  package?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationTrainPackageDiscount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationDiscountCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationDiscountCoupon'] = ResolversParentTypes['OrderDetailsCancellationDiscountCoupon']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['DomesticAccommodationUserCoupon']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userCoupon?: Resolver<Maybe<ResolversTypes['CouponPlatformUserCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationDomestic'] = ResolversParentTypes['OrderDetailsCancellationDomestic']> = {
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationDomesticDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPenaltyAgree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberClassDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rewardAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rewardStatus?: Resolver<Maybe<ResolversTypes['RewardStatusType']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes['StatusCode'], ParentType, ContextType>;
  statusGroupCode?: Resolver<ResolversTypes['StatusGroupCode'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  visitType?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationDomesticDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationDomesticDiscount'] = ResolversParentTypes['OrderDetailsCancellationDomesticDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCancellationOrderDiscountCoupon']>, ParentType, ContextType>;
  mobileMembership?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationDomesticDiscountMobileMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationDomesticDiscountMobileMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationDomesticDiscountMobileMembership'] = ResolversParentTypes['OrderDetailsCancellationDomesticDiscountMobileMembership']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MobileMembershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationLeisureDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationLeisureDiscount'] = ResolversParentTypes['OrderDetailsCancellationLeisureDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCancellationOrderDiscountCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationLeisureProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationLeisureProduct'] = ResolversParentTypes['OrderDetailsCancellationLeisureProduct']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationLeisureDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderDetailsCancellationLeisureProductItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationLeisureProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationLeisureProductItem'] = ResolversParentTypes['OrderDetailsCancellationLeisureProductItem']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['OrderDetailsLeisureValid'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationOrderDiscountCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationOrderDiscountCoupon'] = ResolversParentTypes['OrderDetailsCancellationOrderDiscountCoupon']> = {
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['DomesticAccommodationUserCoupon']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  refund?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userCoupon?: Resolver<Maybe<ResolversTypes['CouponPlatformUserCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationPayment'] = ResolversParentTypes['OrderDetailsCancellationPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['YapaymentMethod'], ParentType, ContextType>;
  requestedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationTrain'] = ResolversParentTypes['OrderDetailsCancellationTrain']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsCancellationTrainDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderDetailsCancellationTrainTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationTrainDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationTrainDiscount'] = ResolversParentTypes['OrderDetailsCancellationTrainDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCancellationOrderDiscountCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationTrainPackageDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationTrainPackageDiscount'] = ResolversParentTypes['OrderDetailsCancellationTrainPackageDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCancellationTrainTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCancellationTrainTicket'] = ResolversParentTypes['OrderDetailsCancellationTrainTicket']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  commissionAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seats?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderDetailsTrainTicketSeats']>>>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCartDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCartDiscount'] = ResolversParentTypes['OrderDetailsCartDiscount']> = {
  coupons?: Resolver<Maybe<Array<ResolversTypes['OrderDetailsCoupon']>>, ParentType, ContextType>;
  package?: Resolver<Maybe<ResolversTypes['OrderDetailsTrainPackageDiscount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCategory'] = ResolversParentTypes['OrderDetailsCategory']> = {
  __resolveType: TypeResolveFn<'OrderDetailsBus' | 'OrderDetailsDomestic' | 'OrderDetailsLeisureProduct' | 'OrderDetailsTrain', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OrderDetailsCategoryOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCategoryOrder'] = ResolversParentTypes['OrderDetailsCategoryOrder']> = {
  __resolveType: TypeResolveFn<'OrderDetailsBus' | 'OrderDetailsDomestic' | 'OrderDetailsLeisureProduct' | 'OrderDetailsTrain', ParentType, ContextType>;
};

export type OrderDetailsCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsCoupon'] = ResolversParentTypes['OrderDetailsCoupon']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  coupon?: Resolver<Maybe<ResolversTypes['DomesticAccommodationUserCoupon']>, ParentType, ContextType>;
  couponType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  userCoupon?: Resolver<Maybe<ResolversTypes['CouponPlatformUserCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsDiscount'] = ResolversParentTypes['OrderDetailsDiscount']> = {
  busDiscount?: Resolver<Maybe<ResolversTypes['OrderDetailsDiscountBusDiscount']>, ParentType, ContextType>;
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCoupon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsDiscountBusDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsDiscountBusDiscount'] = ResolversParentTypes['OrderDetailsDiscountBusDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  discountType?: Resolver<ResolversTypes['OrderDetailsDiscountBusDiscountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsDomestic'] = ResolversParentTypes['OrderDetailsDomestic']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  cancelPolicyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  canceledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  childrenAges?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dailyPrices?: Resolver<Maybe<Array<ResolversTypes['DomesticDailyPrices']>>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsDomesticDiscount']>, ParentType, ContextType>;
  displayBadge?: Resolver<ResolversTypes['MemberClassBadgeType'], ParentType, ContextType>;
  hasPartialCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPenaltyAgree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberClassDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nolChat?: Resolver<Maybe<ResolversTypes['NolChatResponse']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pendingStatus?: Resolver<Maybe<ResolversTypes['PendingStatus']>, ParentType, ContextType>;
  pickupType?: Resolver<ResolversTypes['PickupType'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productConfig?: Resolver<ResolversTypes['ProductConfigProperty'], ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyCategory?: Resolver<ResolversTypes['PropertyCategory'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlan?: Resolver<ResolversTypes['OrderDetailsDomesticRatePlan'], ParentType, ContextType>;
  ratePlanConfig?: Resolver<Maybe<ResolversTypes['RatePlanConfig']>, ParentType, ContextType>;
  ratePlanDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reserveType?: Resolver<Maybe<ResolversTypes['ReserveType']>, ParentType, ContextType>;
  reviewWritableV2?: Resolver<Maybe<ResolversTypes['ReviewWritableResponseV2']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes['StatusCode'], ParentType, ContextType>;
  statusGroupCode?: Resolver<ResolversTypes['StatusGroupCode'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  virtualPhoneNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitType?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsDomesticDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsDomesticDiscount'] = ResolversParentTypes['OrderDetailsDomesticDiscount']> = {
  coupons?: Resolver<Array<ResolversTypes['OrderDetailsCoupon']>, ParentType, ContextType>;
  mobileMembership?: Resolver<Maybe<ResolversTypes['OrderDetailsMobileMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsDomesticRatePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsDomesticRatePlan'] = ResolversParentTypes['OrderDetailsDomesticRatePlan']> = {
  isExceptionalCancelPolicy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsLeisureProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsLeisureProduct'] = ResolversParentTypes['OrderDetailsLeisureProduct']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsDiscount']>, ParentType, ContextType>;
  displayBadge?: Resolver<ResolversTypes['MemberClassBadgeType'], ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['OrderDetailsLeisureProductItem']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewWritableV2?: Resolver<Maybe<ResolversTypes['ReviewWritableResponseV2']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsLeisureProductItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsLeisureProductItem'] = ResolversParentTypes['OrderDetailsLeisureProductItem']> = {
  cancelCompletedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  cancelRequestedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  encryptedVoucherData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['OrderDetailsLeisureValid'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  voucher?: Resolver<Maybe<ResolversTypes['CartLeisureProductOrderItemVoucher']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsLeisureValidResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsLeisureValid'] = ResolversParentTypes['OrderDetailsLeisureValid']> = {
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsMobileMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsMobileMembership'] = ResolversParentTypes['OrderDetailsMobileMembership']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MobileMembershipType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsPaymentResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsPayment'] = ResolversParentTypes['OrderDetailsPayment']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['YapaymentMethod'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsTrain'] = ResolversParentTypes['OrderDetailsTrain']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['OrderDetailsDiscount']>, ParentType, ContextType>;
  hashOrderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderDetailsTrainTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsTrainCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsTrainCoupon'] = ResolversParentTypes['OrderDetailsTrainCoupon']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsTrainPackageDiscountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsTrainPackageDiscount'] = ResolversParentTypes['OrderDetailsTrainPackageDiscount']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsTrainTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsTrainTicket'] = ResolversParentTypes['OrderDetailsTrainTicket']> = {
  adultFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelCompletedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelPolicySummary?: Resolver<Maybe<ResolversTypes['CancelPolicySummary']>, ParentType, ContextType>;
  cancelRequestedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  childFare?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsReservationNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  runningDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['OrderDetailsTrainTicketSeats']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsTrainTicketSeatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsTrainTicketSeats'] = ResolversParentTypes['OrderDetailsTrainTicketSeats']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['CartTrainOrderTicketSeatDirection'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderDetailsUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderDetailsUser'] = ResolversParentTypes['OrderDetailsUser']> = {
  birthDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderListResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderList'] = ResolversParentTypes['OrderList']> = {
  orders?: Resolver<Array<ResolversTypes['CartOrders']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderPaymentPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderPaymentPolicy'] = ResolversParentTypes['OrderPaymentPolicy']> = {
  paymentNotice?: Resolver<ResolversTypes['YapaymentPaymentNotice'], ParentType, ContextType>;
  paymentPolicies?: Resolver<Array<ResolversTypes['PaymentPolicy']>, ParentType, ContextType>;
  paymentPolicySeq?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promotions?: Resolver<Maybe<ResolversTypes['PaymentPromotion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OverviewLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['OverviewLang'] = ResolversParentTypes['OverviewLang']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zhcn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMainPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMainPromotion'] = ResolversParentTypes['PaymentMainPromotion']> = {
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMethodPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethodPromotion'] = ResolversParentTypes['PaymentMethodPromotion']> = {
  content?: Resolver<ResolversTypes['PaymentMethodPromotionContent'], ParentType, ContextType>;
  paymentMethodCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMethodPromotionContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethodPromotionContent'] = ResolversParentTypes['PaymentMethodPromotionContent']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentNoticeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentNotice'] = ResolversParentTypes['PaymentNotice']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentPolicy'] = ResolversParentTypes['PaymentPolicy']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxPayableAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minPayableAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentPromotion'] = ResolversParentTypes['PaymentPromotion']> = {
  mainBannerPromotion?: Resolver<Maybe<ResolversTypes['PaymentMainPromotion']>, ParentType, ContextType>;
  paymentMethodPromotions?: Resolver<Array<ResolversTypes['PaymentMethodPromotion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PgReceiptInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PgReceiptInfo'] = ResolversParentTypes['PgReceiptInfo']> = {
  guide?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhotosResolvers<ContextType = any, ParentType extends ResolversParentTypes['Photos'] = ResolversParentTypes['Photos']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legacy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PointEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['PointEvent'] = ResolversParentTypes['PointEvent']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rewardRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PointItemPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PointItemPolicy'] = ResolversParentTypes['PointItemPolicy']> = {
  assetType?: Resolver<ResolversTypes['PointAssetType'], ParentType, ContextType>;
  itemType?: Resolver<ResolversTypes['PointItemType'], ParentType, ContextType>;
  rewardAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rewardRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PointPolicyType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PointServicePolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PointServicePolicy'] = ResolversParentTypes['PointServicePolicy']> = {
  assetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Array<Maybe<ResolversTypes['PointEvent']>>, ParentType, ContextType>;
  maxPoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rewardRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PointTotalResolvers<ContextType = any, ParentType extends ResolversParentTypes['PointTotal'] = ResolversParentTypes['PointTotal']> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  point?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigCancelPoliciesResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigCancelPolicies'] = ResolversParentTypes['ProductConfigCancelPolicies']> = {
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['CancelPolicyMethod'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  policies?: Resolver<Array<ResolversTypes['ProductConfigCancelPoliciesPolicy']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigCancelPoliciesPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigCancelPoliciesPolicy'] = ResolversParentTypes['ProductConfigCancelPoliciesPolicy']> = {
  criteria?: Resolver<ResolversTypes['CancelPolicyCreteria'], ParentType, ContextType>;
  endDays?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endOffset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ratio?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigParkingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigParking'] = ResolversParentTypes['ProductConfigParking']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  full?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigProperty'] = ResolversParentTypes['ProductConfigProperty']> = {
  badges?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  banners?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  control?: Resolver<ResolversTypes['ProductConfigPropertyControl'], ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['ProductConfigParking']>, ParentType, ContextType>;
  promotions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigPropertyControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigPropertyControl'] = ResolversParentTypes['ProductConfigPropertyControl']> = {
  globalSales?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ratePlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reservation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  selfCheckIn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigRoomTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigRoomType'] = ResolversParentTypes['ProductConfigRoomType']> = {
  badges?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  banners?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  control?: Resolver<ResolversTypes['ProductConfigRoomTypeControl'], ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['ProductConfigParking']>, ParentType, ContextType>;
  promotions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductConfigRoomTypeControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductConfigRoomTypeControl'] = ResolversParentTypes['ProductConfigRoomTypeControl']> = {
  adultAuth?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  globalSales?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  login?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mustNotCancel?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  parking?: Resolver<ResolversTypes['ProductConfigParkingType'], ParentType, ContextType>;
  reservation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPropertyDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPropertyDomestic'] = ResolversParentTypes['ProductPropertyDomestic']> = {
  config?: Resolver<Maybe<ResolversTypes['ProductConfigProperty']>, ParentType, ContextType, Partial<ProductPropertyDomesticConfigArgs>>;
  confirmedReservation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<ProductPropertyDomesticConfirmedReservationArgs>>;
  data?: Resolver<ResolversTypes['PropertyData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isRatePlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  published?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ratePlan?: Resolver<ResolversTypes['ProductPropertyDomesticRatePlan'], ParentType, ContextType, RequireFields<ProductPropertyDomesticRatePlanArgs, 'params' | 'useTypeInput'>>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType, Partial<ProductPropertyDomesticRoomTypeArgs>>;
  roomTypes?: Resolver<Array<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPropertyDomesticRatePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPropertyDomesticRatePlan'] = ResolversParentTypes['ProductPropertyDomesticRatePlan']> = {
  benefitList?: Resolver<Array<ResolversTypes['DomesticRatePlanBenefits']>, ParentType, ContextType>;
  cancelPolicy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  channelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkOutTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  config?: Resolver<ResolversTypes['RatePlanConfig'], ParentType, ContextType>;
  dates?: Resolver<Array<ResolversTypes['RatePlanDate']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalRatePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sharedRatePlans?: Resolver<Array<ResolversTypes['SharedRatePlan']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalOriginalRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductPropertyRoomTypeDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductPropertyRoomTypeDomestic'] = ResolversParentTypes['ProductPropertyRoomTypeDomestic']> = {
  additionalOneCoupons?: Resolver<Array<ResolversTypes['CouponDomesticInstanceV2']>, ParentType, ContextType>;
  additionalTwoCoupons?: Resolver<Array<ResolversTypes['CouponDomesticInstanceV2']>, ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['ProductConfigRoomType']>, ParentType, ContextType, Partial<ProductPropertyRoomTypeDomesticConfigArgs>>;
  coupons?: Resolver<Array<ResolversTypes['CouponDomesticInstanceV2']>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['RoomTypeData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Progress'] = ResolversParentTypes['Progress']> = {
  DAYS?: Resolver<Maybe<ResolversTypes['Days']>, ParentType, ContextType>;
  REST?: Resolver<Maybe<ResolversTypes['Rest']>, ParentType, ContextType>;
  SLEEP?: Resolver<Maybe<ResolversTypes['Sleep']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyBreakfastResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyBreakfast'] = ResolversParentTypes['PropertyBreakfast']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCouponResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCoupon'] = ResolversParentTypes['PropertyCoupon']> = {
  applicableMinPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkin_finished_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkin_started_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponIdx?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  couponName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maxPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priceType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provideCondition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayTypeConfigs?: Resolver<Maybe<Array<Maybe<ResolversTypes['StayTypeConfigs']>>>, ParentType, ContextType>;
  supplyStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usableRoomType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useInAdvance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  useType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  week?: Resolver<ResolversTypes['Week'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCouponCheckProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCouponCheckProgress'] = ResolversParentTypes['PropertyCouponCheckProgress']> = {
  metaCouponId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  placeIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCouponsProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCouponsProgress'] = ResolversParentTypes['PropertyCouponsProgress']> = {
  metas?: Resolver<Array<ResolversTypes['PropertyCouponsProgressMeta']>, ParentType, ContextType>;
  placeNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCouponsProgressMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCouponsProgressMeta'] = ResolversParentTypes['PropertyCouponsProgressMeta']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Progress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCouponsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCouponsResponse'] = ResolversParentTypes['PropertyCouponsResponse']> = {
  list?: Resolver<Maybe<Array<ResolversTypes['PropertyCoupon']>>, ParentType, ContextType>;
  maxDcPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDcPriceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyData'] = ResolversParentTypes['PropertyData']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addressLang?: Resolver<Maybe<ResolversTypes['AddressLang']>, ParentType, ContextType>;
  affiliation?: Resolver<Maybe<ResolversTypes['Affiliation']>, ParentType, ContextType>;
  agePolicy?: Resolver<Maybe<ResolversTypes['AgePolicy']>, ParentType, ContextType>;
  breakfasts?: Resolver<Maybe<Array<ResolversTypes['PropertyBreakfast']>>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['PropertyCategory'], ParentType, ContextType>;
  channelId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coordinate?: Resolver<Maybe<ResolversTypes['Coordinate']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerServicePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptions?: Resolver<Maybe<ResolversTypes['Descriptions']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isTest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  managements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Managements']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameLang?: Resolver<Maybe<ResolversTypes['NameLang']>, ParentType, ContextType>;
  notices?: Resolver<Maybe<ResolversTypes['Notices']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photos?: Resolver<Array<ResolversTypes['Photos']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reservationPolicy?: Resolver<Maybe<ResolversTypes['ReservationPolicy']>, ParentType, ContextType>;
  routerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  star?: Resolver<Maybe<ResolversTypes['StarInfo']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  surcharges?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  themes?: Resolver<Maybe<Array<ResolversTypes['Themes']>>, ParentType, ContextType>;
  themesImages?: Resolver<Maybe<Array<ResolversTypes['ContentThemes']>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QrCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QrCode'] = ResolversParentTypes['QrCode']> = {
  qrInfo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  benefitBanner?: Resolver<ResolversTypes['BannerResponse'], ParentType, ContextType, RequireFields<QueryBenefitBannerArgs, 'target'>>;
  busCancelPolicyPreview?: Resolver<Maybe<ResolversTypes['BusCancelPreview']>, ParentType, ContextType, RequireFields<QueryBusCancelPolicyPreviewArgs, 'params'>>;
  busDetail?: Resolver<Array<ResolversTypes['BusDetail']>, ParentType, ContextType, RequireFields<QueryBusDetailArgs, 'params'>>;
  busTransportationCompany?: Resolver<Maybe<ResolversTypes['BusTransportationCompany']>, ParentType, ContextType, RequireFields<QueryBusTransportationCompanyArgs, 'code'>>;
  cartItemV2?: Resolver<ResolversTypes['ICartSingleItem'], ParentType, ContextType, RequireFields<QueryCartItemV2Args, 'optionId'>>;
  cartItemsV3?: Resolver<Array<ResolversTypes['ICartItem']>, ParentType, ContextType>;
  cartPropertyDomesticRentTimeLines?: Resolver<ResolversTypes['CartPropertyDomesticRentTimeLines'], ParentType, ContextType, RequireFields<QueryCartPropertyDomesticRentTimeLinesArgs, 'params'>>;
  cartSingleItems?: Resolver<Array<ResolversTypes['ICartSingleItem']>, ParentType, ContextType, RequireFields<QueryCartSingleItemsArgs, 'input'>>;
  contentThemes?: Resolver<Maybe<ResolversTypes['ContentThemes']>, ParentType, ContextType, RequireFields<QueryContentThemesArgs, 'codes'>>;
  couponDomesticInstance?: Resolver<Array<ResolversTypes['CouponDomesticInstance']>, ParentType, ContextType, RequireFields<QueryCouponDomesticInstanceArgs, 'input'>>;
  couponDomesticInstanceV2?: Resolver<Array<ResolversTypes['CouponDomesticInstanceV2']>, ParentType, ContextType, RequireFields<QueryCouponDomesticInstanceV2Args, 'input'>>;
  couponMeta?: Resolver<Maybe<ResolversTypes['CouponMetadata']>, ParentType, ContextType, RequireFields<QueryCouponMetaArgs, 'couponId'>>;
  couponPlatformInstance?: Resolver<Array<ResolversTypes['CouponPlatformInstance']>, ParentType, ContextType, RequireFields<QueryCouponPlatformInstanceArgs, 'input'>>;
  couponPlatformInstanceV2?: Resolver<Array<ResolversTypes['CouponPlatformInstanceV2']>, ParentType, ContextType, RequireFields<QueryCouponPlatformInstanceV2Args, 'input'>>;
  distributionPreview?: Resolver<Maybe<ResolversTypes['DistributionPreview']>, ParentType, ContextType, RequireFields<QueryDistributionPreviewArgs, 'input'>>;
  domesticPropertySearch?: Resolver<ResolversTypes['DomesticPropertySearch'], ParentType, ContextType, Partial<QueryDomesticPropertySearchArgs>>;
  findVisitorAgree?: Resolver<ResolversTypes['VisitorFindAgreeData'], ParentType, ContextType, RequireFields<QueryFindVisitorAgreeArgs, 'phone'>>;
  isLoginUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isNolCardFirstPayPromotion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latestAppConfig?: Resolver<ResolversTypes['JSON'], ParentType, ContextType, Partial<QueryLatestAppConfigArgs>>;
  leisureProduct?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType, RequireFields<QueryLeisureProductArgs, 'id'>>;
  leisureProductVariant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType, RequireFields<QueryLeisureProductVariantArgs, 'input'>>;
  leisureSearch?: Resolver<ResolversTypes['LeisureSearch'], ParentType, ContextType, Partial<QueryLeisureSearchArgs>>;
  memberClass?: Resolver<Array<ResolversTypes['MemberClassItem']>, ParentType, ContextType>;
  memberClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  memberGatewayAskCi?: Resolver<Maybe<ResolversTypes['MemberGatewayCIData']>, ParentType, ContextType, RequireFields<QueryMemberGatewayAskCiArgs, 'tk'>>;
  memberGatewayMembership?: Resolver<Maybe<ResolversTypes['MemberGatewayMembership']>, ParentType, ContextType, RequireFields<QueryMemberGatewayMembershipArgs, 'option'>>;
  memberInfoByCache?: Resolver<ResolversTypes['MemberInfo'], ParentType, ContextType>;
  nolPointTotal?: Resolver<ResolversTypes['PointTotal'], ParentType, ContextType>;
  orderCancelPolicyV3?: Resolver<ResolversTypes['OrderCancelPolicy'], ParentType, ContextType, RequireFields<QueryOrderCancelPolicyV3Args, 'orderId'>>;
  orderCancelPreviewV2?: Resolver<ResolversTypes['OrderCancelPreview'], ParentType, ContextType, RequireFields<QueryOrderCancelPreviewV2Args, 'param'>>;
  orderDetailsV3?: Resolver<ResolversTypes['OrderDetails'], ParentType, ContextType, RequireFields<QueryOrderDetailsV3Args, 'orderId'>>;
  orderListV3?: Resolver<ResolversTypes['OrderList'], ParentType, ContextType, RequireFields<QueryOrderListV3Args, 'params'>>;
  orderPaymentPolicy?: Resolver<ResolversTypes['OrderPaymentPolicy'], ParentType, ContextType, RequireFields<QueryOrderPaymentPolicyArgs, 'input'>>;
  paymentHistoryApproval?: Resolver<ResolversTypes['YapaymentHistoryApproval'], ParentType, ContextType, RequireFields<QueryPaymentHistoryApprovalArgs, 'orderId'>>;
  pgReceiptInfo?: Resolver<ResolversTypes['PgReceiptInfo'], ParentType, ContextType, RequireFields<QueryPgReceiptInfoArgs, 'orderId' | 'tenancyCode'>>;
  ping?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pointAllPolicies?: Resolver<Array<ResolversTypes['PointItemPolicy']>, ParentType, ContextType, Partial<QueryPointAllPoliciesArgs>>;
  pointTotal?: Resolver<ResolversTypes['PointTotal'], ParentType, ContextType>;
  productConfig?: Resolver<ResolversTypes['ProductConfigProperty'], ParentType, ContextType, RequireFields<QueryProductConfigArgs, 'propertyId'>>;
  productConfigCancelPolicies?: Resolver<ResolversTypes['ProductConfigCancelPolicies'], ParentType, ContextType, RequireFields<QueryProductConfigCancelPoliciesArgs, 'id'>>;
  productConfigCancelPoliciesCheck?: Resolver<Maybe<ResolversTypes['ProductConfigCancelPolicies']>, ParentType, ContextType, RequireFields<QueryProductConfigCancelPoliciesCheckArgs, 'checkInDate' | 'checkOutDate' | 'propertyId'>>;
  property?: Resolver<ResolversTypes['ProductPropertyDomestic'], ParentType, ContextType, RequireFields<QueryPropertyArgs, 'propertyId'>>;
  propertyRoomTypeRatePlanForTest?: Resolver<Maybe<ResolversTypes['AvailableInventoryRatePlanResponse']>, ParentType, ContextType, RequireFields<QueryPropertyRoomTypeRatePlanForTestArgs, 'checkinDate' | 'checkoutDate' | 'roomTypeId'>>;
  propertyRoomTypeStock?: Resolver<ResolversTypes['SingleStock'], ParentType, ContextType, RequireFields<QueryPropertyRoomTypeStockArgs, 'checkinDate' | 'checkoutDate' | 'propertyId' | 'roomTypeId'>>;
  propertyRoomTypesStock?: Resolver<ResolversTypes['Stock'], ParentType, ContextType, RequireFields<QueryPropertyRoomTypesStockArgs, 'checkinDate' | 'checkoutDate' | 'propertyId'>>;
  qrCode?: Resolver<ResolversTypes['QrCode'], ParentType, ContextType, RequireFields<QueryQrCodeArgs, 'phoneNo' | 'reservationNo'>>;
  reservation?: Resolver<ResolversTypes['ReservationDetail'], ParentType, ContextType, RequireFields<QueryReservationArgs, 'reservationNo'>>;
  reservationRentStock?: Resolver<ResolversTypes['ReservationStockRentType'], ParentType, ContextType, RequireFields<QueryReservationRentStockArgs, 'checkinDate' | 'checkoutDate' | 'propertyId' | 'roomTypeId'>>;
  reservations?: Resolver<Array<ResolversTypes['Reservation']>, ParentType, ContextType>;
  reviewPolicy?: Resolver<Array<ResolversTypes['PointServicePolicy']>, ParentType, ContextType>;
  roomType?: Resolver<ResolversTypes['ProductPropertyRoomTypeDomestic'], ParentType, ContextType, RequireFields<QueryRoomTypeArgs, 'roomTypeId'>>;
  serverCurrentAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sharedOrder?: Resolver<ResolversTypes['SharedOrder'], ParentType, ContextType, RequireFields<QuerySharedOrderArgs, 'uuid'>>;
  trainStations?: Resolver<Array<ResolversTypes['TrainStation']>, ParentType, ContextType>;
  transportationSearchCarriageSeats?: Resolver<Array<ResolversTypes['TransportationSearchSeat']>, ParentType, ContextType, RequireFields<QueryTransportationSearchCarriageSeatsArgs, 'params'>>;
  transportationSearchCarriages?: Resolver<Array<ResolversTypes['TransportationSearchCarriage']>, ParentType, ContextType, RequireFields<QueryTransportationSearchCarriagesArgs, 'params'>>;
  transportationSearchFares?: Resolver<Array<ResolversTypes['TransportationSearchFare']>, ParentType, ContextType, RequireFields<QueryTransportationSearchFaresArgs, 'params'>>;
  transportationSearchPackageFares?: Resolver<Array<ResolversTypes['TransportationSearchPackageFare']>, ParentType, ContextType, RequireFields<QueryTransportationSearchPackageFaresArgs, 'params'>>;
  transportationSearchTrains?: Resolver<Array<ResolversTypes['TransportationSearchTrain']>, ParentType, ContextType, RequireFields<QueryTransportationSearchTrainsArgs, 'params'>>;
  transportationSearchs?: Resolver<Array<ResolversTypes['TransportationSearch']>, ParentType, ContextType, RequireFields<QueryTransportationSearchsArgs, 'inputs'>>;
  validateOrderSheetMemberClass?: Resolver<ResolversTypes['ValidateOrderSheetMemberClassResponse'], ParentType, ContextType, RequireFields<QueryValidateOrderSheetMemberClassArgs, 'properties'>>;
  validateViewerPhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validateVisitorPhone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryValidateVisitorPhoneArgs, 'phoneNumber'>>;
  verifyAdditionalPurchase?: Resolver<Maybe<ResolversTypes['LeisureAdditionalPurchaseVerification']>, ParentType, ContextType, RequireFields<QueryVerifyAdditionalPurchaseArgs, 'orderGroupId' | 'productId'>>;
  viewer?: Resolver<ResolversTypes['Viewer'], ParentType, ContextType>;
  vigToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yapaymentMethod?: Resolver<Array<ResolversTypes['YapaymentMethod']>, ParentType, ContextType, Partial<QueryYapaymentMethodArgs>>;
  yapaymentPaymentPolicy?: Resolver<ResolversTypes['YapaymentPaymentPolicy'], ParentType, ContextType, RequireFields<QueryYapaymentPaymentPolicyArgs, 'input'>>;
};

export type RatePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlan'] = ResolversParentTypes['RatePlan']> = {
  adsList?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  availability?: Resolver<ResolversTypes['RatePlanAvailability'], ParentType, ContextType>;
  averageRackRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cancelPolicy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  checkInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkOutTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dates?: Resolver<Array<ResolversTypes['RatePlanDate']>, ParentType, ContextType>;
  invalidReason?: Resolver<Maybe<ResolversTypes['RatePlanInvalidReason']>, ParentType, ContextType>;
  minUseTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reservableQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalRackRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  useTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['RatePlanUseType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanConfig'] = ResolversParentTypes['RatePlanConfig']> = {
  badges?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  control?: Resolver<ResolversTypes['RatePlanConfigControl'], ParentType, ContextType>;
  parking?: Resolver<Maybe<ResolversTypes['ProductConfigParking']>, ParentType, ContextType>;
  promotions?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanConfigControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanConfigControl'] = ResolversParentTypes['RatePlanConfigControl']> = {
  parking?: Resolver<ResolversTypes['ProductConfigParkingType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanDataRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanDataRequest'] = ResolversParentTypes['RatePlanDataRequest']> = {
  baseDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  baseTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  perDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  persons?: Resolver<ResolversTypes['RatePlanDataRequestPersons'], ParentType, ContextType>;
  surcharges?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanDataRequestPersonsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanDataRequestPersons'] = ResolversParentTypes['RatePlanDataRequestPersons']> = {
  adultPax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  childrentAges?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanDate'] = ResolversParentTypes['RatePlanDate']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  extraPersonRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherSettings?: Resolver<Maybe<ResolversTypes['RatePlanDateOtherSetting']>, ParentType, ContextType>;
  rackRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatePlanDateOtherSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatePlanDateOtherSetting'] = ResolversParentTypes['RatePlanDateOtherSetting']> = {
  depositPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RentTimeLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['RentTimeLine'] = ResolversParentTypes['RentTimeLine']> = {
  time?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useTime?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestOrderShareResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestOrderShare'] = ResolversParentTypes['RequestOrderShare']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reservation'] = ResolversParentTypes['Reservation']> = {
  affiliatePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appointmentDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  inTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inTimeDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  mrName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  myroom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  outTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outTimeDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  purchasePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  regdate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationNo?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  roomNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomTypeNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  salePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  savePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  useTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReservationDetail'] = ResolversParentTypes['ReservationDetail']> = {
  affiliatePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appointmentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appointmentEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cancelDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponEventIdx?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  datediff?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eventRefundPoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  inTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inTimeDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mpType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mrCancelAmt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mrCancelPoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mrName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  myroom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  outTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outTimeDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerPoint?: Resolver<Maybe<ResolversTypes['ReservationPartnerPoint']>, ParentType, ContextType>;
  payType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  phoneNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  publicPhoneNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchasePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  regdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reservationNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserveDetailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomNum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roomTypeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  savePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  useTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationPartnerPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReservationPartnerPoint'] = ResolversParentTypes['ReservationPartnerPoint']> = {
  allRefund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  partner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReservationPolicy'] = ResolversParentTypes['ReservationPolicy']> = {
  confirmedReservation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReservationStockRentTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReservationStockRentType'] = ResolversParentTypes['ReservationStockRentType']> = {
  myRoom?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentAbleCnt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentCnt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentDiscountPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentMinUseTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rentOpen?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentOpenEndTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rentPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentSoldout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentTimeLine?: Resolver<Maybe<Array<ResolversTypes['RentTimeLine']>>, ParentType, ContextType>;
  rentUseEndTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rentUseRoomCnt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentUseStartTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rentUseTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservationType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RestResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rest'] = ResolversParentTypes['Rest']> = {
  limitOffer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitUse?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  used?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewWritableResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewWritable'] = ResolversParentTypes['ReviewWritable']> = {
  dueDateForReview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['ReviewWritableReason']>, ParentType, ContextType>;
  reservationNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  writable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewWritableResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewWritableResponse'] = ResolversParentTypes['ReviewWritableResponse']> = {
  reservations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReviewWritable']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReviewWritableResponseV2Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ReviewWritableResponseV2'] = ResolversParentTypes['ReviewWritableResponseV2']> = {
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expectedReward?: Resolver<Maybe<ResolversTypes['ExpectedReward']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewAvailableUntil?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unavailableReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoomListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoomList'] = ResolversParentTypes['RoomList']> = {
  placeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomTimeList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  roomTypeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  staySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoomTypeCampingResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoomTypeCamping'] = ResolversParentTypes['RoomTypeCamping']> = {
  zone?: Resolver<ResolversTypes['RoomTypeCampingZone'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoomTypeCampingZoneResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoomTypeCampingZone'] = ResolversParentTypes['RoomTypeCampingZone']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoomTypeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoomTypeData'] = ResolversParentTypes['RoomTypeData']> = {
  bedGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['BedGroups']>>>, ParentType, ContextType>;
  camping?: Resolver<Maybe<ResolversTypes['RoomTypeCamping']>, ParentType, ContextType>;
  capacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cloneType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['Description']>, ParentType, ContextType>;
  extraCharge?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxCapacity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nameLang?: Resolver<Maybe<ResolversTypes['NameLang']>, ParentType, ContextType>;
  orderNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  photos?: Resolver<Array<ResolversTypes['Photos']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reservationPolicy?: Resolver<Maybe<ResolversTypes['ReservationPolicy']>, ParentType, ContextType>;
  routerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smokingPreference?: Resolver<Maybe<ResolversTypes['SmokingPreference']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoomTypeStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoomTypeStock'] = ResolversParentTypes['RoomTypeStock']> = {
  day?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  days?: Resolver<Maybe<Array<Maybe<ResolversTypes['Days']>>>, ParentType, ContextType>;
  daysAbleRoomList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  daysAverageDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysAveragePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysOpenStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  myRoom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentAbleCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentBreakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentMinUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentOpenEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentTimeLine?: Resolver<Maybe<Array<Maybe<ResolversTypes['RentTimeLine']>>>, ParentType, ContextType>;
  rentUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentWorkInDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentWorkInPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservationType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservePublished?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomList?: Resolver<Maybe<Array<Maybe<ResolversTypes['RoomList']>>>, ParentType, ContextType>;
  roomTypeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayAbleCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayBreakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpenStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  staySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayWorkInDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayWorkInPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesPeriodResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesPeriod'] = ResolversParentTypes['SalesPeriod']> = {
  end?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SellerInfosResolvers<ContextType = any, ParentType extends ResolversParentTypes['SellerInfos'] = ResolversParentTypes['SellerInfos']> = {
  businessNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyTel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrder'] = ResolversParentTypes['SharedOrder']> = {
  additionalCategoryOrders?: Resolver<Array<ResolversTypes['SharedOrderCategory']>, ParentType, ContextType>;
  categoryOrders?: Resolver<Array<ResolversTypes['SharedOrderCategory']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderBusResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderBus'] = ResolversParentTypes['SharedOrderBus']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reservations?: Resolver<Array<ResolversTypes['SharedOrderBusReservation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderBusReservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderBusReservation'] = ResolversParentTypes['SharedOrderBusReservation']> = {
  arrivalTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  boardingNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  busGrade?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTerminalNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedArriveAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnTrip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['SharedOrderBusReservationTicket']>, ParentType, ContextType>;
  transportationCompanyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderBusReservationTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderBusReservationTicket'] = ResolversParentTypes['SharedOrderBusReservationTicket']> = {
  confirm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  confirmedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  qrGenNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrderDetailsBusReservationTicketStatus'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderCategory'] = ResolversParentTypes['SharedOrderCategory']> = {
  __resolveType: TypeResolveFn<'SharedOrderBus' | 'SharedOrderDomestic' | 'SharedOrderLeisure' | 'SharedOrderTrain', ParentType, ContextType>;
};

export type SharedOrderCategoryOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderCategoryOrder'] = ResolversParentTypes['SharedOrderCategoryOrder']> = {
  __resolveType: TypeResolveFn<'SharedOrderBus' | 'SharedOrderDomestic' | 'SharedOrderLeisure' | 'SharedOrderTrain', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SharedOrderDomesticResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderDomestic'] = ResolversParentTypes['SharedOrderDomestic']> = {
  benefits?: Resolver<Maybe<Array<ResolversTypes['DomesticRatePlanBenefits']>>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingStatus?: Resolver<Maybe<ResolversTypes['PendingStatus']>, ParentType, ContextType>;
  pickupType?: Resolver<Maybe<ResolversTypes['PickupType']>, ParentType, ContextType>;
  property?: Resolver<Maybe<ResolversTypes['ProductPropertyDomestic']>, ParentType, ContextType>;
  propertyCategory?: Resolver<ResolversTypes['PropertyCategory'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratePlanTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  roomTypeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roomTypeVersion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusGroupCode?: Resolver<ResolversTypes['StatusGroupCode'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['DomesticAccommodationUseType'], ParentType, ContextType>;
  visitType?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderLeisureResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderLeisure'] = ResolversParentTypes['SharedOrderLeisure']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SharedOrderLeisureItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderLeisureItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderLeisureItem'] = ResolversParentTypes['SharedOrderLeisureItem']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dealName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['LeisureProduct'], ParentType, ContextType>;
  productVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartLeisureOrderStatus'], ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<ResolversTypes['OrderDetailsLeisureValid'], ParentType, ContextType>;
  variant?: Resolver<ResolversTypes['LeisureProductVariant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderTrain'] = ResolversParentTypes['SharedOrderTrain']> = {
  category?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Array<ResolversTypes['OrderDetailsTrainTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedOrderTrainTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedOrderTrainTicket'] = ResolversParentTypes['SharedOrderTrainTicket']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  arrivalAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  departureAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsReservationNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runningDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['OrderDetailsTrainTicketSeats']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CartTrainOrderTicketStatus'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SharedRatePlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedRatePlan'] = ResolversParentTypes['SharedRatePlan']> = {
  memberClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratePlanId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleLineResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleLine'] = ResolversParentTypes['SingleLine']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleStock'] = ResolversParentTypes['SingleStock']> = {
  data?: Resolver<ResolversTypes['RoomTypeStock'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SleepResolvers<ContextType = any, ParentType extends ResolversParentTypes['Sleep'] = ResolversParentTypes['Sleep']> = {
  limitOffer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitUse?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  used?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StarInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['StarInfo'] = ResolversParentTypes['StarInfo']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StayTypeConfigsResolvers<ContextType = any, ParentType extends ResolversParentTypes['StayTypeConfigs'] = ResolversParentTypes['StayTypeConfigs']> = {
  applicableMaxPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicableMinPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxDiscount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minActualPayment?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stock'] = ResolversParentTypes['Stock']> = {
  data?: Resolver<Array<ResolversTypes['RoomTypeStock']>, ParentType, ContextType>;
  log?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resultCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  resultMsg?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCnt?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockReservationRoomTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockReservationRoomType'] = ResolversParentTypes['StockReservationRoomType']> = {
  checkinDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkinDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkoutDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkoutDateTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  day?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysAverageDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysAveragePrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysOpenStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daysUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  docId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  inTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  myRoom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  published?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentAbleCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentBreakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentMinUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentOpenEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentSoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentUseTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rentWorkInDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentWorkInPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservationType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reservePublished?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomTypeNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stayAbleCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayBreakTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayGlobalPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpen?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayOpenStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  staySoldout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayUseRoomCnt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayUseStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stayWorkInDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stayWorkInPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StockRoomTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['StockRoomType'] = ResolversParentTypes['StockRoomType']> = {
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roomType?: Resolver<Maybe<ResolversTypes['ProductPropertyRoomTypeDomestic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubBucketsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubBuckets'] = ResolversParentTypes['SubBuckets']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThemesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Themes'] = ResolversParentTypes['Themes']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrainStationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TrainStation'] = ResolversParentTypes['TrainStation']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  districtCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ktx?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mark?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  supplyCompanyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  supplyCompanyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearch'] = ResolversParentTypes['TransportationSearch']> = {
  arrivalDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  arrivalTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  directTransferCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fares?: Resolver<Array<ResolversTypes['TransportationSearchFare']>, ParentType, ContextType>;
  goodsGroupItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsGroupSequenceNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  packageFares?: Resolver<Array<ResolversTypes['TransportationSearchPackageFare']>, ParentType, ContextType>;
  runningDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runningHourMinute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleControlYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seatAssignYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seats?: Resolver<Array<ResolversTypes['TransportationSearchCarriageSeat']>, ParentType, ContextType>;
  secondClassSeatCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  secondClassSeatYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationTrainClassifyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainChangeYn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainOrderNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transferTrainOrderNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchCarriageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchCarriage'] = ResolversParentTypes['TransportationSearchCarriage']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  restSeatCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  seatCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchCarriageSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchCarriageSeat'] = ResolversParentTypes['TransportationSearchCarriageSeat']> = {
  carriageNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchFareResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchFare'] = ResolversParentTypes['TransportationSearchFare']> = {
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carriageClassName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  passengerTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passengerTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yanoljaPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchPackageFareResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchPackageFare'] = ResolversParentTypes['TransportationSearchPackageFare']> = {
  carriageClassCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carriageClassName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  passengerTypeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  passengerTypeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  salePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelFullPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  travelSalePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yanoljaPackageDiscountAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yanoljaPackageDiscountRatio?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yanoljaPackagePrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yanoljaPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchSeatResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchSeat'] = ResolversParentTypes['TransportationSearchSeat']> = {
  directionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directionCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etcCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etcCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  goodsNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsSaleGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nearEntranceYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requestCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAvailabilityYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  smokeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  smokeCodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stationTrainClassifyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransportationSearchTrainResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransportationSearchTrain'] = ResolversParentTypes['TransportationSearchTrain']> = {
  arrivalDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  arrivalTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureStationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  departureTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  directTransferCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsGroupItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsGroupSequenceNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsItemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goodsNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runningDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  runningHourMinute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleControlYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seatAssignYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secondClassSeatCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secondClassSeatYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stationTrainClassifyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stationTrainClassifyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainChangeYn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainGroupCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainGroupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trainOrderNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferTrainOrderNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Type'] = ResolversParentTypes['Type']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCartItemByOrderIdResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCartItemByOrderIdResponse'] = ResolversParentTypes['UpdateCartItemByOrderIdResponse']> = {
  cartItemsV3?: Resolver<Array<ResolversTypes['ICartItem']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCartItemByOrderIdV2ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCartItemByOrderIdV2Response'] = ResolversParentTypes['UpdateCartItemByOrderIdV2Response']> = {
  cartSingleItems?: Resolver<Array<ResolversTypes['ICartSingleItem']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrder'] = ResolversParentTypes['UpdateOrder']> = {
  updatedProperties?: Resolver<Array<ResolversTypes['UpdatedProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatedPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatedProperty'] = ResolversParentTypes['UpdatedProperty']> = {
  adults?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  badgeMemberCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkInAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkInDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  checkOutDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  childrenAges?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratePlanVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roomTypeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  surchargeIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateOrderSheetMemberClassResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateOrderSheetMemberClassResponse'] = ResolversParentTypes['ValidateOrderSheetMemberClassResponse']> = {
  data?: Resolver<Maybe<ResolversTypes['UpdateOrder']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['ValidateOrderSheetMemberClassReason']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VariantPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['VariantPrice'] = ResolversParentTypes['VariantPrice']> = {
  discountAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  discountTypeCode?: Resolver<Maybe<ResolversTypes['DiscountTypeCode']>, ParentType, ContextType>;
  retailPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VariantSupplyItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['VariantSupplyItem'] = ResolversParentTypes['VariantSupplyItem']> = {
  partnerCode?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  supplyItemId?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  supplyItemName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Viewer'] = ResolversParentTypes['Viewer']> = {
  classCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hashedMemberNo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  memberNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nolMemberProxyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitorAgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitorAgreements'] = ResolversParentTypes['VisitorAgreements']> = {
  option?: Resolver<Maybe<ResolversTypes['MarketingAgree']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitorFindAgreeDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitorFindAgreeData'] = ResolversParentTypes['VisitorFindAgreeData']> = {
  agreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['VisitorAgreements']>>>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeekResolvers<ContextType = any, ParentType extends ResolversParentTypes['Week'] = ResolversParentTypes['Week']> = {
  impossibleWeek?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  possibleWeek?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentHistoryApprovalResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentHistoryApproval'] = ResolversParentTypes['YapaymentHistoryApproval']> = {
  isPlcc?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenancyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentMethod'] = ResolversParentTypes['YapaymentMethod']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentPaymentMethodPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentPaymentMethodPolicy'] = ResolversParentTypes['YapaymentPaymentMethodPolicy']> = {
  badgeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iconUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxPayableAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  minPayableAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortNo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentPaymentNoticeResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentPaymentNotice'] = ResolversParentTypes['YapaymentPaymentNotice']> = {
  inactivePaymentMethodCodes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  notices?: Resolver<Array<ResolversTypes['PaymentNotice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentPaymentPolicyResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentPaymentPolicy'] = ResolversParentTypes['YapaymentPaymentPolicy']> = {
  paymentMethodPolicies?: Resolver<Array<ResolversTypes['YapaymentPaymentMethodPolicy']>, ParentType, ContextType>;
  paymentNotice?: Resolver<ResolversTypes['YapaymentPaymentNotice'], ParentType, ContextType>;
  paymentPolicySeq?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  promotions?: Resolver<Array<ResolversTypes['YapaymentPaymentPromotion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YapaymentPaymentPromotionResolvers<ContextType = any, ParentType extends ResolversParentTypes['YapaymentPaymentPromotion'] = ResolversParentTypes['YapaymentPaymentPromotion']> = {
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortNo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AdditionalOrder?: AdditionalOrderResolvers<ContextType>;
  AddressCodes?: AddressCodesResolvers<ContextType>;
  AddressLang?: AddressLangResolvers<ContextType>;
  AddtoCartItemsResponse?: AddtoCartItemsResponseResolvers<ContextType>;
  Affiliation?: AffiliationResolvers<ContextType>;
  AgePolicy?: AgePolicyResolvers<ContextType>;
  Aggregations?: AggregationsResolvers<ContextType>;
  AgreementType?: AgreementTypeResolvers<ContextType>;
  AvailableInventoryRatePlanData?: AvailableInventoryRatePlanDataResolvers<ContextType>;
  AvailableInventoryRatePlanInventory?: AvailableInventoryRatePlanInventoryResolvers<ContextType>;
  AvailableInventoryRatePlanResponse?: AvailableInventoryRatePlanResponseResolvers<ContextType>;
  AvailablePeriod?: AvailablePeriodResolvers<ContextType>;
  BannerAction?: BannerActionResolvers<ContextType>;
  BannerImage?: BannerImageResolvers<ContextType>;
  BannerLogMeta?: BannerLogMetaResolvers<ContextType>;
  BannerResponse?: BannerResponseResolvers<ContextType>;
  BedConfigurations?: BedConfigurationsResolvers<ContextType>;
  BedGroups?: BedGroupsResolvers<ContextType>;
  BusCancelPolicy?: BusCancelPolicyResolvers<ContextType>;
  BusCancelPreview?: BusCancelPreviewResolvers<ContextType>;
  BusCancelPreviewType?: BusCancelPreviewTypeResolvers<ContextType>;
  BusDetail?: BusDetailResolvers<ContextType>;
  BusDetailFee?: BusDetailFeeResolvers<ContextType>;
  BusDetailSeat?: BusDetailSeatResolvers<ContextType>;
  BusDetailTicketType?: BusDetailTicketTypeResolvers<ContextType>;
  BusSeat?: BusSeatResolvers<ContextType>;
  BusTransportationCompany?: BusTransportationCompanyResolvers<ContextType>;
  CancelPolicy?: CancelPolicyResolvers<ContextType>;
  CancelPolicyBusTicket?: CancelPolicyBusTicketResolvers<ContextType>;
  CancelPolicySummary?: CancelPolicySummaryResolvers<ContextType>;
  CartBusOrder?: CartBusOrderResolvers<ContextType>;
  CartBusOrderReservation?: CartBusOrderReservationResolvers<ContextType>;
  CartBusOrderReservationTicket?: CartBusOrderReservationTicketResolvers<ContextType>;
  CartCategoryOrder?: CartCategoryOrderResolvers<ContextType>;
  CartDomesticOrder?: CartDomesticOrderResolvers<ContextType>;
  CartLeisureOrderValid?: CartLeisureOrderValidResolvers<ContextType>;
  CartLeisureProductOrder?: CartLeisureProductOrderResolvers<ContextType>;
  CartLeisureProductOrderItem?: CartLeisureProductOrderItemResolvers<ContextType>;
  CartLeisureProductOrderItemVoucher?: CartLeisureProductOrderItemVoucherResolvers<ContextType>;
  CartOrder?: CartOrderResolvers<ContextType>;
  CartOrders?: CartOrdersResolvers<ContextType>;
  CartPropertyDomesticRentTimeLines?: CartPropertyDomesticRentTimeLinesResolvers<ContextType>;
  CartTrainOrder?: CartTrainOrderResolvers<ContextType>;
  CartTrainOrderTicket?: CartTrainOrderTicketResolvers<ContextType>;
  CartTrainOrderTicketSeat?: CartTrainOrderTicketSeatResolvers<ContextType>;
  CertificationCertifyResult?: CertificationCertifyResultResolvers<ContextType>;
  Commission?: CommissionResolvers<ContextType>;
  ConfirmBusTicket?: ConfirmBusTicketResolvers<ContextType>;
  ConstraintNumber?: GraphQLScalarType;
  ConstraintString?: GraphQLScalarType;
  Content?: ContentResolvers<ContextType>;
  ContentThemes?: ContentThemesResolvers<ContextType>;
  ContentThemesPhotos?: ContentThemesPhotosResolvers<ContextType>;
  Coordinate?: CoordinateResolvers<ContextType>;
  CouponDomesticInstance?: CouponDomesticInstanceResolvers<ContextType>;
  CouponDomesticInstancePeriod?: CouponDomesticInstancePeriodResolvers<ContextType>;
  CouponDomesticInstanceProgress?: CouponDomesticInstanceProgressResolvers<ContextType>;
  CouponDomesticInstanceResponse?: CouponDomesticInstanceResponseResolvers<ContextType>;
  CouponDomesticInstanceV2?: CouponDomesticInstanceV2Resolvers<ContextType>;
  CouponDomesticInstances?: CouponDomesticInstancesResolvers<ContextType>;
  CouponDomesticInstancesV2?: CouponDomesticInstancesV2Resolvers<ContextType>;
  CouponDownloaded?: CouponDownloadedResolvers<ContextType>;
  CouponMetadata?: CouponMetadataResolvers<ContextType>;
  CouponPlatformCheckProgress?: CouponPlatformCheckProgressResolvers<ContextType>;
  CouponPlatformCheckProgressMaxUseCount?: CouponPlatformCheckProgressMaxUseCountResolvers<ContextType>;
  CouponPlatformConditions?: CouponPlatformConditionsResolvers<ContextType>;
  CouponPlatformDiscount?: CouponPlatformDiscountResolvers<ContextType>;
  CouponPlatformDownloaded?: CouponPlatformDownloadedResolvers<ContextType>;
  CouponPlatformInstance?: CouponPlatformInstanceResolvers<ContextType>;
  CouponPlatformInstanceDiscount?: CouponPlatformInstanceDiscountResolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicy?: CouponPlatformInstanceRedemptionPolicyResolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicyCondition?: CouponPlatformInstanceRedemptionPolicyConditionResolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicyConditionV2?: CouponPlatformInstanceRedemptionPolicyConditionV2Resolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicyStock?: CouponPlatformInstanceRedemptionPolicyStockResolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicyStockV2?: CouponPlatformInstanceRedemptionPolicyStockV2Resolvers<ContextType>;
  CouponPlatformInstanceRedemptionPolicyV2?: CouponPlatformInstanceRedemptionPolicyV2Resolvers<ContextType>;
  CouponPlatformInstanceResource?: CouponPlatformInstanceResourceResolvers<ContextType>;
  CouponPlatformInstanceResponse?: CouponPlatformInstanceResponseResolvers<ContextType>;
  CouponPlatformInstanceV2?: CouponPlatformInstanceV2Resolvers<ContextType>;
  CouponPlatformInstances?: CouponPlatformInstancesResolvers<ContextType>;
  CouponPlatformRedemptionPolicy?: CouponPlatformRedemptionPolicyResolvers<ContextType>;
  CouponPlatformResource?: CouponPlatformResourceResolvers<ContextType>;
  CouponPlatformUserCoupon?: CouponPlatformUserCouponResolvers<ContextType>;
  CouponSchema?: CouponSchemaResolvers<ContextType>;
  CouponUsablePeriod?: CouponUsablePeriodResolvers<ContextType>;
  Days?: DaysResolvers<ContextType>;
  DepthOne?: DepthOneResolvers<ContextType>;
  DepthThree?: DepthThreeResolvers<ContextType>;
  DepthTwo?: DepthTwoResolvers<ContextType>;
  Description?: DescriptionResolvers<ContextType>;
  Descriptions?: DescriptionsResolvers<ContextType>;
  DirectionLang?: DirectionLangResolvers<ContextType>;
  DistributionPreview?: DistributionPreviewResolvers<ContextType>;
  DistributionPreviewOrders?: DistributionPreviewOrdersResolvers<ContextType>;
  DistributionPreviewOrdersDiscount?: DistributionPreviewOrdersDiscountResolvers<ContextType>;
  DistributionPreviewOrdersLeisure?: DistributionPreviewOrdersLeisureResolvers<ContextType>;
  DistributionPreviewOrdersPayments?: DistributionPreviewOrdersPaymentsResolvers<ContextType>;
  DistributionPreviewOrdersReservation?: DistributionPreviewOrdersReservationResolvers<ContextType>;
  DistributionPreviewOrdersReservationDiscount?: DistributionPreviewOrdersReservationDiscountResolvers<ContextType>;
  DistributionPreviewOrdersTrain?: DistributionPreviewOrdersTrainResolvers<ContextType>;
  DomesticAccommodationCartItem?: DomesticAccommodationCartItemResolvers<ContextType>;
  DomesticAccommodationCartItemOption?: DomesticAccommodationCartItemOptionResolvers<ContextType>;
  DomesticAccommodationCartItemOptionHotDeal?: DomesticAccommodationCartItemOptionHotDealResolvers<ContextType>;
  DomesticAccommodationCartItemOptionRatePlan?: DomesticAccommodationCartItemOptionRatePlanResolvers<ContextType>;
  DomesticAccommodationCartSingleItem?: DomesticAccommodationCartSingleItemResolvers<ContextType>;
  DomesticAccommodationUserCoupon?: DomesticAccommodationUserCouponResolvers<ContextType>;
  DomesticBusCartItem?: DomesticBusCartItemResolvers<ContextType>;
  DomesticBusCartItemOption?: DomesticBusCartItemOptionResolvers<ContextType>;
  DomesticBusCartItemOptionReservation?: DomesticBusCartItemOptionReservationResolvers<ContextType>;
  DomesticBusCartSingleItem?: DomesticBusCartSingleItemResolvers<ContextType>;
  DomesticDailyPrices?: DomesticDailyPricesResolvers<ContextType>;
  DomesticLeisureCartItem?: DomesticLeisureCartItemResolvers<ContextType>;
  DomesticLeisureCartItemOption?: DomesticLeisureCartItemOptionResolvers<ContextType>;
  DomesticLeisureCartSingleItem?: DomesticLeisureCartSingleItemResolvers<ContextType>;
  DomesticPropertySearch?: DomesticPropertySearchResolvers<ContextType>;
  DomesticRatePlanBenefits?: DomesticRatePlanBenefitsResolvers<ContextType>;
  DomesticTrainCartItem?: DomesticTrainCartItemResolvers<ContextType>;
  DomesticTrainCartItemOption?: DomesticTrainCartItemOptionResolvers<ContextType>;
  DomesticTrainCartItemOptionTicketSeat?: DomesticTrainCartItemOptionTicketSeatResolvers<ContextType>;
  DomesticTrainCartItemTicket?: DomesticTrainCartItemTicketResolvers<ContextType>;
  DomesticTrainCartSingleItem?: DomesticTrainCartSingleItemResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  ExpectedReward?: ExpectedRewardResolvers<ContextType>;
  Hits?: HitsResolvers<ContextType>;
  ICartItem?: ICartItemResolvers<ContextType>;
  ICartItemOption?: ICartItemOptionResolvers<ContextType>;
  ICartSingleItem?: ICartSingleItemResolvers<ContextType>;
  Information?: InformationResolvers<ContextType>;
  Items?: ItemsResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  LeisureAdditionalPurchaseProduct?: LeisureAdditionalPurchaseProductResolvers<ContextType>;
  LeisureAdditionalPurchaseVerification?: LeisureAdditionalPurchaseVerificationResolvers<ContextType>;
  LeisureBody?: LeisureBodyResolvers<ContextType>;
  LeisureCancellationFeePlan?: LeisureCancellationFeePlanResolvers<ContextType>;
  LeisureCategory?: LeisureCategoryResolvers<ContextType>;
  LeisureHeader?: LeisureHeaderResolvers<ContextType>;
  LeisureProduct?: LeisureProductResolvers<ContextType>;
  LeisureProductBraze?: LeisureProductBrazeResolvers<ContextType>;
  LeisureProductDetailInfo?: LeisureProductDetailInfoResolvers<ContextType>;
  LeisureProductEvent?: LeisureProductEventResolvers<ContextType>;
  LeisureProductFacility?: LeisureProductFacilityResolvers<ContextType>;
  LeisureProductGroup?: LeisureProductGroupResolvers<ContextType>;
  LeisureProductImage?: LeisureProductImageResolvers<ContextType>;
  LeisureProductInfo?: LeisureProductInfoResolvers<ContextType>;
  LeisureProductOptionGroup?: LeisureProductOptionGroupResolvers<ContextType>;
  LeisureProductPartner?: LeisureProductPartnerResolvers<ContextType>;
  LeisureProductVariant?: LeisureProductVariantResolvers<ContextType>;
  LeisureSearch?: LeisureSearchResolvers<ContextType>;
  LeisureqProductItem?: LeisureqProductItemResolvers<ContextType>;
  LeisureqProductOptionItem?: LeisureqProductOptionItemResolvers<ContextType>;
  LeisureqProductPeriod?: LeisureqProductPeriodResolvers<ContextType>;
  LinkageType?: LinkageTypeResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  LocationLang?: LocationLangResolvers<ContextType>;
  Locations?: LocationsResolvers<ContextType>;
  Managements?: ManagementsResolvers<ContextType>;
  MemberClassItem?: MemberClassItemResolvers<ContextType>;
  MemberGatewayCIData?: MemberGatewayCiDataResolvers<ContextType>;
  MemberGatewayMembership?: MemberGatewayMembershipResolvers<ContextType>;
  MemberGatewayMembershipData?: MemberGatewayMembershipDataResolvers<ContextType>;
  MemberInfo?: MemberInfoResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NameLang?: NameLangResolvers<ContextType>;
  NolChatResponse?: NolChatResponseResolvers<ContextType>;
  NolMemberInfoType?: NolMemberInfoTypeResolvers<ContextType>;
  Notices?: NoticesResolvers<ContextType>;
  Options?: OptionsResolvers<ContextType>;
  OrderCancel?: OrderCancelResolvers<ContextType>;
  OrderCancelAdditionalOrder?: OrderCancelAdditionalOrderResolvers<ContextType>;
  OrderCancelBusDiscount?: OrderCancelBusDiscountResolvers<ContextType>;
  OrderCancelBusOrder?: OrderCancelBusOrderResolvers<ContextType>;
  OrderCancelBusOrderDiscount?: OrderCancelBusOrderDiscountResolvers<ContextType>;
  OrderCancelBusOrderReservation?: OrderCancelBusOrderReservationResolvers<ContextType>;
  OrderCancelBusOrderReservationTicket?: OrderCancelBusOrderReservationTicketResolvers<ContextType>;
  OrderCancelCartDiscount?: OrderCancelCartDiscountResolvers<ContextType>;
  OrderCancelCartTrainPackageDiscount?: OrderCancelCartTrainPackageDiscountResolvers<ContextType>;
  OrderCancelCategory?: OrderCancelCategoryResolvers<ContextType>;
  OrderCancelCoupon?: OrderCancelCouponResolvers<ContextType>;
  OrderCancelDomesticOrder?: OrderCancelDomesticOrderResolvers<ContextType>;
  OrderCancelDomesticOrderDiscount?: OrderCancelDomesticOrderDiscountResolvers<ContextType>;
  OrderCancelLeisureOrderDiscount?: OrderCancelLeisureOrderDiscountResolvers<ContextType>;
  OrderCancelLeisureOrderValid?: OrderCancelLeisureOrderValidResolvers<ContextType>;
  OrderCancelLeisureProductOrder?: OrderCancelLeisureProductOrderResolvers<ContextType>;
  OrderCancelLeisureProductOrderItem?: OrderCancelLeisureProductOrderItemResolvers<ContextType>;
  OrderCancelMobileMembership?: OrderCancelMobileMembershipResolvers<ContextType>;
  OrderCancelPayment?: OrderCancelPaymentResolvers<ContextType>;
  OrderCancelPolicy?: OrderCancelPolicyResolvers<ContextType>;
  OrderCancelPolicyAdditionalOrder?: OrderCancelPolicyAdditionalOrderResolvers<ContextType>;
  OrderCancelPolicyBus?: OrderCancelPolicyBusResolvers<ContextType>;
  OrderCancelPolicyBusReservation?: OrderCancelPolicyBusReservationResolvers<ContextType>;
  OrderCancelPolicyCategory?: OrderCancelPolicyCategoryResolvers<ContextType>;
  OrderCancelPolicyCategoryOrder?: OrderCancelPolicyCategoryOrderResolvers<ContextType>;
  OrderCancelPolicyDiscount?: OrderCancelPolicyDiscountResolvers<ContextType>;
  OrderCancelPolicyDiscountCoupon?: OrderCancelPolicyDiscountCouponResolvers<ContextType>;
  OrderCancelPolicyDomestic?: OrderCancelPolicyDomesticResolvers<ContextType>;
  OrderCancelPolicyLeisureProduct?: OrderCancelPolicyLeisureProductResolvers<ContextType>;
  OrderCancelPolicyLeisureProductItem?: OrderCancelPolicyLeisureProductItemResolvers<ContextType>;
  OrderCancelPolicyLeisureValid?: OrderCancelPolicyLeisureValidResolvers<ContextType>;
  OrderCancelPolicyPayment?: OrderCancelPolicyPaymentResolvers<ContextType>;
  OrderCancelPolicyTrain?: OrderCancelPolicyTrainResolvers<ContextType>;
  OrderCancelPolicyTrainTicket?: OrderCancelPolicyTrainTicketResolvers<ContextType>;
  OrderCancelPolicyTrainTicketSeat?: OrderCancelPolicyTrainTicketSeatResolvers<ContextType>;
  OrderCancelPrecheck?: OrderCancelPrecheckResolvers<ContextType>;
  OrderCancelPreview?: OrderCancelPreviewResolvers<ContextType>;
  OrderCancelPreviewAdditionalOrder?: OrderCancelPreviewAdditionalOrderResolvers<ContextType>;
  OrderCancelPreviewCartDiscount?: OrderCancelPreviewCartDiscountResolvers<ContextType>;
  OrderCancelPreviewCartTrainPackageDiscount?: OrderCancelPreviewCartTrainPackageDiscountResolvers<ContextType>;
  OrderCancelPreviewOrder?: OrderCancelPreviewOrderResolvers<ContextType>;
  OrderCancelPreviewOrderDiscount?: OrderCancelPreviewOrderDiscountResolvers<ContextType>;
  OrderCancelPreviewOrderDiscountDetails?: OrderCancelPreviewOrderDiscountDetailsResolvers<ContextType>;
  OrderCancelPreviewOrderDiscountMobileMembership?: OrderCancelPreviewOrderDiscountMobileMembershipResolvers<ContextType>;
  OrderCancelPreviewPayment?: OrderCancelPreviewPaymentResolvers<ContextType>;
  OrderCancelTrainOrder?: OrderCancelTrainOrderResolvers<ContextType>;
  OrderCancelTrainOrderDiscount?: OrderCancelTrainOrderDiscountResolvers<ContextType>;
  OrderCancelTrainOrderTicket?: OrderCancelTrainOrderTicketResolvers<ContextType>;
  OrderCancelTrainOrderTicketSeatType?: OrderCancelTrainOrderTicketSeatTypeResolvers<ContextType>;
  OrderDetails?: OrderDetailsResolvers<ContextType>;
  OrderDetailsBus?: OrderDetailsBusResolvers<ContextType>;
  OrderDetailsBusCancellationBusDiscount?: OrderDetailsBusCancellationBusDiscountResolvers<ContextType>;
  OrderDetailsBusReservation?: OrderDetailsBusReservationResolvers<ContextType>;
  OrderDetailsBusReservationTicket?: OrderDetailsBusReservationTicketResolvers<ContextType>;
  OrderDetailsBuyer?: OrderDetailsBuyerResolvers<ContextType>;
  OrderDetailsCancellation?: OrderDetailsCancellationResolvers<ContextType>;
  OrderDetailsCancellationBus?: OrderDetailsCancellationBusResolvers<ContextType>;
  OrderDetailsCancellationBusDiscount?: OrderDetailsCancellationBusDiscountResolvers<ContextType>;
  OrderDetailsCancellationBusReservation?: OrderDetailsCancellationBusReservationResolvers<ContextType>;
  OrderDetailsCancellationBusReservationTicket?: OrderDetailsCancellationBusReservationTicketResolvers<ContextType>;
  OrderDetailsCancellationCategory?: OrderDetailsCancellationCategoryResolvers<ContextType>;
  OrderDetailsCancellationCategoryOrder?: OrderDetailsCancellationCategoryOrderResolvers<ContextType>;
  OrderDetailsCancellationDiscount?: OrderDetailsCancellationDiscountResolvers<ContextType>;
  OrderDetailsCancellationDiscountCoupon?: OrderDetailsCancellationDiscountCouponResolvers<ContextType>;
  OrderDetailsCancellationDomestic?: OrderDetailsCancellationDomesticResolvers<ContextType>;
  OrderDetailsCancellationDomesticDiscount?: OrderDetailsCancellationDomesticDiscountResolvers<ContextType>;
  OrderDetailsCancellationDomesticDiscountMobileMembership?: OrderDetailsCancellationDomesticDiscountMobileMembershipResolvers<ContextType>;
  OrderDetailsCancellationLeisureDiscount?: OrderDetailsCancellationLeisureDiscountResolvers<ContextType>;
  OrderDetailsCancellationLeisureProduct?: OrderDetailsCancellationLeisureProductResolvers<ContextType>;
  OrderDetailsCancellationLeisureProductItem?: OrderDetailsCancellationLeisureProductItemResolvers<ContextType>;
  OrderDetailsCancellationOrderDiscountCoupon?: OrderDetailsCancellationOrderDiscountCouponResolvers<ContextType>;
  OrderDetailsCancellationPayment?: OrderDetailsCancellationPaymentResolvers<ContextType>;
  OrderDetailsCancellationTrain?: OrderDetailsCancellationTrainResolvers<ContextType>;
  OrderDetailsCancellationTrainDiscount?: OrderDetailsCancellationTrainDiscountResolvers<ContextType>;
  OrderDetailsCancellationTrainPackageDiscount?: OrderDetailsCancellationTrainPackageDiscountResolvers<ContextType>;
  OrderDetailsCancellationTrainTicket?: OrderDetailsCancellationTrainTicketResolvers<ContextType>;
  OrderDetailsCartDiscount?: OrderDetailsCartDiscountResolvers<ContextType>;
  OrderDetailsCategory?: OrderDetailsCategoryResolvers<ContextType>;
  OrderDetailsCategoryOrder?: OrderDetailsCategoryOrderResolvers<ContextType>;
  OrderDetailsCoupon?: OrderDetailsCouponResolvers<ContextType>;
  OrderDetailsDiscount?: OrderDetailsDiscountResolvers<ContextType>;
  OrderDetailsDiscountBusDiscount?: OrderDetailsDiscountBusDiscountResolvers<ContextType>;
  OrderDetailsDomestic?: OrderDetailsDomesticResolvers<ContextType>;
  OrderDetailsDomesticDiscount?: OrderDetailsDomesticDiscountResolvers<ContextType>;
  OrderDetailsDomesticRatePlan?: OrderDetailsDomesticRatePlanResolvers<ContextType>;
  OrderDetailsLeisureProduct?: OrderDetailsLeisureProductResolvers<ContextType>;
  OrderDetailsLeisureProductItem?: OrderDetailsLeisureProductItemResolvers<ContextType>;
  OrderDetailsLeisureValid?: OrderDetailsLeisureValidResolvers<ContextType>;
  OrderDetailsMobileMembership?: OrderDetailsMobileMembershipResolvers<ContextType>;
  OrderDetailsPayment?: OrderDetailsPaymentResolvers<ContextType>;
  OrderDetailsTrain?: OrderDetailsTrainResolvers<ContextType>;
  OrderDetailsTrainCoupon?: OrderDetailsTrainCouponResolvers<ContextType>;
  OrderDetailsTrainPackageDiscount?: OrderDetailsTrainPackageDiscountResolvers<ContextType>;
  OrderDetailsTrainTicket?: OrderDetailsTrainTicketResolvers<ContextType>;
  OrderDetailsTrainTicketSeats?: OrderDetailsTrainTicketSeatsResolvers<ContextType>;
  OrderDetailsUser?: OrderDetailsUserResolvers<ContextType>;
  OrderList?: OrderListResolvers<ContextType>;
  OrderPaymentPolicy?: OrderPaymentPolicyResolvers<ContextType>;
  OverviewLang?: OverviewLangResolvers<ContextType>;
  PaymentMainPromotion?: PaymentMainPromotionResolvers<ContextType>;
  PaymentMethodPromotion?: PaymentMethodPromotionResolvers<ContextType>;
  PaymentMethodPromotionContent?: PaymentMethodPromotionContentResolvers<ContextType>;
  PaymentNotice?: PaymentNoticeResolvers<ContextType>;
  PaymentPolicy?: PaymentPolicyResolvers<ContextType>;
  PaymentPromotion?: PaymentPromotionResolvers<ContextType>;
  PgReceiptInfo?: PgReceiptInfoResolvers<ContextType>;
  Photos?: PhotosResolvers<ContextType>;
  PointEvent?: PointEventResolvers<ContextType>;
  PointItemPolicy?: PointItemPolicyResolvers<ContextType>;
  PointServicePolicy?: PointServicePolicyResolvers<ContextType>;
  PointTotal?: PointTotalResolvers<ContextType>;
  ProductConfigCancelPolicies?: ProductConfigCancelPoliciesResolvers<ContextType>;
  ProductConfigCancelPoliciesPolicy?: ProductConfigCancelPoliciesPolicyResolvers<ContextType>;
  ProductConfigParking?: ProductConfigParkingResolvers<ContextType>;
  ProductConfigProperty?: ProductConfigPropertyResolvers<ContextType>;
  ProductConfigPropertyControl?: ProductConfigPropertyControlResolvers<ContextType>;
  ProductConfigRoomType?: ProductConfigRoomTypeResolvers<ContextType>;
  ProductConfigRoomTypeControl?: ProductConfigRoomTypeControlResolvers<ContextType>;
  ProductPropertyDomestic?: ProductPropertyDomesticResolvers<ContextType>;
  ProductPropertyDomesticRatePlan?: ProductPropertyDomesticRatePlanResolvers<ContextType>;
  ProductPropertyRoomTypeDomestic?: ProductPropertyRoomTypeDomesticResolvers<ContextType>;
  Progress?: ProgressResolvers<ContextType>;
  PropertyBreakfast?: PropertyBreakfastResolvers<ContextType>;
  PropertyCoupon?: PropertyCouponResolvers<ContextType>;
  PropertyCouponCheckProgress?: PropertyCouponCheckProgressResolvers<ContextType>;
  PropertyCouponsProgress?: PropertyCouponsProgressResolvers<ContextType>;
  PropertyCouponsProgressMeta?: PropertyCouponsProgressMetaResolvers<ContextType>;
  PropertyCouponsResponse?: PropertyCouponsResponseResolvers<ContextType>;
  PropertyData?: PropertyDataResolvers<ContextType>;
  QrCode?: QrCodeResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RatePlan?: RatePlanResolvers<ContextType>;
  RatePlanConfig?: RatePlanConfigResolvers<ContextType>;
  RatePlanConfigControl?: RatePlanConfigControlResolvers<ContextType>;
  RatePlanDataRequest?: RatePlanDataRequestResolvers<ContextType>;
  RatePlanDataRequestPersons?: RatePlanDataRequestPersonsResolvers<ContextType>;
  RatePlanDate?: RatePlanDateResolvers<ContextType>;
  RatePlanDateOtherSetting?: RatePlanDateOtherSettingResolvers<ContextType>;
  RentTimeLine?: RentTimeLineResolvers<ContextType>;
  RequestOrderShare?: RequestOrderShareResolvers<ContextType>;
  Reservation?: ReservationResolvers<ContextType>;
  ReservationDetail?: ReservationDetailResolvers<ContextType>;
  ReservationPartnerPoint?: ReservationPartnerPointResolvers<ContextType>;
  ReservationPolicy?: ReservationPolicyResolvers<ContextType>;
  ReservationStockRentType?: ReservationStockRentTypeResolvers<ContextType>;
  Rest?: RestResolvers<ContextType>;
  ReviewWritable?: ReviewWritableResolvers<ContextType>;
  ReviewWritableResponse?: ReviewWritableResponseResolvers<ContextType>;
  ReviewWritableResponseV2?: ReviewWritableResponseV2Resolvers<ContextType>;
  RoomList?: RoomListResolvers<ContextType>;
  RoomTypeCamping?: RoomTypeCampingResolvers<ContextType>;
  RoomTypeCampingZone?: RoomTypeCampingZoneResolvers<ContextType>;
  RoomTypeData?: RoomTypeDataResolvers<ContextType>;
  RoomTypeStock?: RoomTypeStockResolvers<ContextType>;
  SalesPeriod?: SalesPeriodResolvers<ContextType>;
  SellerInfos?: SellerInfosResolvers<ContextType>;
  SharedOrder?: SharedOrderResolvers<ContextType>;
  SharedOrderBus?: SharedOrderBusResolvers<ContextType>;
  SharedOrderBusReservation?: SharedOrderBusReservationResolvers<ContextType>;
  SharedOrderBusReservationTicket?: SharedOrderBusReservationTicketResolvers<ContextType>;
  SharedOrderCategory?: SharedOrderCategoryResolvers<ContextType>;
  SharedOrderCategoryOrder?: SharedOrderCategoryOrderResolvers<ContextType>;
  SharedOrderDomestic?: SharedOrderDomesticResolvers<ContextType>;
  SharedOrderLeisure?: SharedOrderLeisureResolvers<ContextType>;
  SharedOrderLeisureItem?: SharedOrderLeisureItemResolvers<ContextType>;
  SharedOrderTrain?: SharedOrderTrainResolvers<ContextType>;
  SharedOrderTrainTicket?: SharedOrderTrainTicketResolvers<ContextType>;
  SharedRatePlan?: SharedRatePlanResolvers<ContextType>;
  SingleLine?: SingleLineResolvers<ContextType>;
  SingleStock?: SingleStockResolvers<ContextType>;
  Sleep?: SleepResolvers<ContextType>;
  StarInfo?: StarInfoResolvers<ContextType>;
  StayTypeConfigs?: StayTypeConfigsResolvers<ContextType>;
  Stock?: StockResolvers<ContextType>;
  StockReservationRoomType?: StockReservationRoomTypeResolvers<ContextType>;
  StockRoomType?: StockRoomTypeResolvers<ContextType>;
  SubBuckets?: SubBucketsResolvers<ContextType>;
  Themes?: ThemesResolvers<ContextType>;
  TrainStation?: TrainStationResolvers<ContextType>;
  TransportationSearch?: TransportationSearchResolvers<ContextType>;
  TransportationSearchCarriage?: TransportationSearchCarriageResolvers<ContextType>;
  TransportationSearchCarriageSeat?: TransportationSearchCarriageSeatResolvers<ContextType>;
  TransportationSearchFare?: TransportationSearchFareResolvers<ContextType>;
  TransportationSearchPackageFare?: TransportationSearchPackageFareResolvers<ContextType>;
  TransportationSearchSeat?: TransportationSearchSeatResolvers<ContextType>;
  TransportationSearchTrain?: TransportationSearchTrainResolvers<ContextType>;
  Type?: TypeResolvers<ContextType>;
  UpdateCartItemByOrderIdResponse?: UpdateCartItemByOrderIdResponseResolvers<ContextType>;
  UpdateCartItemByOrderIdV2Response?: UpdateCartItemByOrderIdV2ResponseResolvers<ContextType>;
  UpdateOrder?: UpdateOrderResolvers<ContextType>;
  UpdatedProperty?: UpdatedPropertyResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  ValidateOrderSheetMemberClassResponse?: ValidateOrderSheetMemberClassResponseResolvers<ContextType>;
  VariantPrice?: VariantPriceResolvers<ContextType>;
  VariantSupplyItem?: VariantSupplyItemResolvers<ContextType>;
  Viewer?: ViewerResolvers<ContextType>;
  VisitorAgreements?: VisitorAgreementsResolvers<ContextType>;
  VisitorFindAgreeData?: VisitorFindAgreeDataResolvers<ContextType>;
  Week?: WeekResolvers<ContextType>;
  YapaymentHistoryApproval?: YapaymentHistoryApprovalResolvers<ContextType>;
  YapaymentMethod?: YapaymentMethodResolvers<ContextType>;
  YapaymentPaymentMethodPolicy?: YapaymentPaymentMethodPolicyResolvers<ContextType>;
  YapaymentPaymentNotice?: YapaymentPaymentNoticeResolvers<ContextType>;
  YapaymentPaymentPolicy?: YapaymentPaymentPolicyResolvers<ContextType>;
  YapaymentPaymentPromotion?: YapaymentPaymentPromotionResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  auth?: AuthDirectiveResolver<any, any, ContextType>;
};
